// Traductions de l'outil : window.PTX_T (texte français → traduction), écrit par le thème hors français.
// Lot 29 : détourage adapté au contraste (22/10), photos transparentes posées telles quelles.
var ptxT = window.ptxT || (window.ptxT = (s) => (window.PTX_T && window.PTX_T[s]) || s);
/*
 * Outil de personnalisation Printtex.
 * Interface : le produit reste toujours visible (au centre / en haut), les réglages s'affichent selon l'élément
 * sélectionné, prix et panier toujours en bas.
 * - Face / dos ; plusieurs images et textes par côté ; déplacement, taille, rotation (Fabric.js) ; annuler / rétablir.
 * - Textes : ~55 polices, taille, courbe, espacement, contour, gras / italique, modifiés en direct.
 * - Dos : photo de dos blanche teintée avec la couleur lue sur la photo de face de la variante.
 * - Prix « pack » (vêtement + impression) selon la grille : teinte, 1 ou 2 marquages, palier de quantité.
 * - Panier : variante du produit caché « pack » + aperçu JPG + fichier de production PNG par zone (visuel seul,
 *   fond transparent, recadré, taille réelle à 300 dpi) + format et position en cm.
 */
(() => {
  const dataEl = document.getElementById('PrinttexPersoData');
  const modal = document.getElementById('PrinttexPerso');
  if (!dataEl || !modal) return;

  const data = JSON.parse(dataEl.textContent);
  // Produit activé par son gabarit mais sans grille de prix validée : pas d'outil (on garde l'achat simple).
  if (!data.tarifs) { document.querySelectorAll('.pp-cta, .pp-sticky').forEach((e) => e.remove()); return; }
  // Plus de 250 variantes (sweat-col-rond-280…) : Liquid coupe la liste à 250 ; les pages suivantes viennent de la
  // section printtex-variantes (?section_id=…&page=N). L'outil attend cette liste avant de s'initialiser.
  const variantesCompletes = data.variants.length < 250 || !data.handle ? Promise.resolve() : (async () => {
    for (let page = 2; page <= 9; page++) {
      const html = await (await fetch(`/products/${data.handle}?section_id=printtex-variantes&page=${page}`)).text();
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-variantes]');
      if (!el) break;
      const connus = new Set(data.variants.map((v) => v.id));
      JSON.parse(el.textContent).forEach((v) => { if (!connus.has(v.id)) data.variants.push(v); });
      if (page >= Number(el.dataset.pages)) break;
    }
  })().catch((e) => console.error(e));
  const DPI = 300;
  const LOGICAL_W = 400; // largeur logique d'une zone d'impression (coordonnées Fabric)
  const SIDES = data.cotes ? { ...data.cotes } : { face: ptxT("Face"), dos: ptxT("Dos") }; // noms par produit (ex. jogging : 5 emplacements)
  const SIDES_FR = data.cotes ? { ...data.cotes } : { face: 'Face', dos: 'Dos' }; // lot 31 : ce qui part à l'atelier reste en français
  const FONTS = [
    'Montserrat', 'Poppins', 'Roboto', 'Open Sans', 'Lato', 'Raleway', 'Oswald', 'Bebas Neue', 'Anton', 'Archivo Black',
    'Teko', 'Staatliches', 'Russo One', 'Righteous', 'Lilita One', 'Passion One', 'Bungee', 'Rubik Mono One', 'Black Ops One', 'Orbitron',
    'Audiowide', 'Press Start 2P', 'Monoton', 'Bangers', 'Chewy', 'Fredoka', 'Comfortaa', 'Alfa Slab One', 'Abril Fatface', 'Playfair Display',
    'Cinzel', 'Rye', 'UnifrakturMaguntia', 'Special Elite', 'Courier Prime', 'Creepster', 'Lobster', 'Pacifico', 'Dancing Script', 'Great Vibes',
    'Satisfy', 'Sacramento', 'Yellowtail', 'Kaushan Script', 'Permanent Marker', 'Rock Salt', 'Caveat', 'Shadows Into Light', 'Gloria Hallelujah', 'Indie Flower',
  ];
  const SYSTEM_FONTS = ['Arial', 'Impact', 'Georgia', 'Times New Roman', 'Verdana'];
  const COLORS = ['#000000', '#ffffff', '#9ca3af', '#dc2626', '#f97316', '#facc15', '#16a34a', '#0ea5e9', '#1d4ed8', '#7c3aed', '#ec4899', '#78350f', '#d4af37'];

  // La fenêtre est déplacée sous <body> pour échapper aux conteneurs du thème.
  document.body.appendChild(modal);
  // Variante de mise en page de l'outil (?variante=a…e), posée avant toute ouverture (lien direct #personnaliser).
  // Carte cadeau : lien de l'e-mail #carte=<CODE> → code gardé pour la visite, adresse nettoyée, outil ouvert.
  const CARTE_CLE = 'ptx-carte-cadeau';
  let carteDuLien = false; // lien de l'e-mail de la carte : l'outil s'ouvre tout de suite
  const REMISE_CLE = 'ptx-carte-remise'; // ex. CADEAU (livraison offerte avec la carte)
  {
    const m = location.hash.match(/^#carte=([A-Za-z0-9-]{8,40})(?:&remise=([A-Za-z0-9-]{3,40}))?$/);
    if (m) {
      try { sessionStorage.setItem(CARTE_CLE, m[1].replace(/-/g, '')); if (m[2]) sessionStorage.setItem(REMISE_CLE, m[2].toUpperCase()); } catch (e) { /* navigation privée : saisie au paiement */ }
      carteDuLien = true;
      history.replaceState(null, '', `${location.pathname}${location.search}`);
    }
  }
  // Applique la carte au panier du site (API vitrine Shopify, sans jeton). Sans effet si le code est faux ou épuisé.
  async function appliquerCarteCadeau() {
    let code = null; let remise = null;
    try { code = sessionStorage.getItem(CARTE_CLE); remise = sessionStorage.getItem(REMISE_CLE); } catch (e) { return; }
    if (!code && !remise) return;
    try {
      const panier = await fetch('/cart.js').then((r) => r.json());
      if (!panier.item_count) return;
      const api = (query, variables) => fetch('/api/2025-10/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query, variables }) }).then((x) => x.json());
      const id = `${ptxT("gid://shopify/Cart/")}${panier.token}`;
      if (code) {
        const r = await api(ptxT("mutation($id: ID!, $c: [String!]!) { cartGiftCardCodesAdd(cartId: $id, giftCardCodes: $c) { cart { appliedGiftCards { lastCharacters } } userErrors { message } } }"), { id, c: [code] });
        if (r?.data?.cartGiftCardCodesAdd?.cart?.appliedGiftCards?.length) sessionStorage.removeItem(CARTE_CLE);
      }
      if (remise) {
        // Remise ajoutée aux codes déjà présents (jamais remplacés).
        const deja = (await api(ptxT("query($id: ID!) { cart(id: $id) { discountCodes { code } } }"), { id }))?.data?.cart?.discountCodes?.map((d) => d.code) || [];
        const r = await api(ptxT("mutation($id: ID!, $c: [String!]!) { cartDiscountCodesUpdate(cartId: $id, discountCodes: $c) { cart { discountCodes { code applicable } } userErrors { message } } }"), { id, c: [...new Set([...deja, remise])] });
        if (r?.data?.cartDiscountCodesUpdate?.cart?.discountCodes?.some((d) => d.code.toUpperCase() === remise && d.applicable)) sessionStorage.removeItem(REMISE_CLE);
      }
    } catch (e) { /* le client peut toujours saisir le code au paiement */ }
  }
  const varianteOutil = (new URLSearchParams(location.search).get('variante') || 'e').toLowerCase(); // E (« application ») par défaut, choix de Karim
  // Accès de test (?pp-test) : contrôles automatiques de l'outil (zones, design contenu dans la zone).
  if (new URLSearchParams(location.search).has('pp-test')) window.ppTest = { get state() { return state; }, get data() { return data; }, get facesPretes() { return facesPretes; }, get drawEpoque() { return drawEpoque; }, previewFile: (s, w) => previewFile(s, w), logicalH: (s) => logicalH(s), fitInZone: (o, s, i) => fitInZone(o, s, i), dansForme: (o, s) => dansForme(o, s) };
  if (/^[a-e]$/.test(varianteOutil)) modal.classList.add(`pp-var-${varianteOutil}`);
  // Barre d'actions sur le bord de l'aperçu et alerte de qualité dans le panneau : rien ne cache le design (15/10/2026).
  modal.querySelector('[data-pp-stagewrap]').appendChild(modal.querySelector('[data-pp-float]'));
  // Mobile : le panneau se replie, l'alerte irait avec lui ; elle reste donc sur l'aperçu, sous la barre d'outils (17/10/2026).
  if (matchMedia('(max-width: 899px)').matches) modal.querySelector('[data-pp-stagewrap]').appendChild(modal.querySelector('[data-pp-warning]'));
  else modal.querySelector('.pp-panels').prepend(modal.querySelector('[data-pp-warning]'));

  const $ = (sel) => modal.querySelector(sel);
  const $$ = (sel) => [...modal.querySelectorAll(sel)];
  const stageWrap = $('[data-pp-stagewrap]');
  const stage = $('[data-pp-stage]');
  const mockupCanvas = $('[data-pp-mockup]');
  const fileInput = $('[data-pp-file]');
  const T = {
    input: $('[data-pp-text-input]'), color: $('[data-pp-color]'),
    size: $('[data-pp-size]'), curve: $('[data-pp-curve]'), spacing: $('[data-pp-spacing]'),
    stroke: $('[data-pp-stroke]'), strokeWidth: $('[data-pp-stroke-width]'),
    bold: $('[data-pp-bold]'), italic: $('[data-pp-italic]'),
  };
  const priceEl = $('[data-pp-price]');
  const errorEl = $('[data-pp-error]');
  const addBtn = $('[data-pp-add]');
  const warningEl = $('[data-pp-warning]');
  // Alerte de qualité refermable (Karim : elle masquait le vêtement) : un toucher la ferme pour ce message.
  warningEl?.addEventListener('click', () => { warningEl.dataset.ferme = warningEl.textContent; warningEl.hidden = true; });
  if (warningEl) { warningEl.setAttribute('role', 'button'); warningEl.title = ptxT('Fermer'); }

  const parCote = (f) => Object.fromEntries(Object.keys(SIDES).map((k) => [k, f()]));
  const state = {
    side: 'face', variant: null, canvases: {}, images: {}, backs: {}, ready: false, qty: {},
    font: 'Montserrat', restoring: false,
    // Par côté (face, dos, ou les emplacements du produit : jogging) : historique, placement rapide choisi, zone côté contre-cœur.
    history: parCote(() => []), future: parCote(() => []), pos: parCote(() => null), miroir: parCote(() => false),
  };

  // Points d'accroche des modules (ex. printtex-modeles.js) : voir window.PrinttexPerso en fin de fichier.
  const ext = { couleur: [], selection: [], restaurer: [] };

  const money = (cents) => (cents / 100).toFixed(2).replace('.', ',').replace(',00', '') + ' €';
  const zoneOf = (side) => data.zones[side];
  // Hauteur logique de la zone affichée (forme esthétique, mesurée à l'affichage) ; la largeur LOGICAL_W vaut cmW imprimés.
  const ratioZone = {};
  const logicalH = (side) => LOGICAL_W * (ratioZone[side] || (zoneOf(side).zone_cmH ?? zoneOf(side).cmH) / zoneOf(side).cmW);
  // Hauteur maximale d'un design : cmH imprimés (35 × 40 cm max.), même si la zone dessinée est plus haute.
  const hauteurMax = (side) => LOGICAL_W * zoneOf(side).cmH / zoneOf(side).cmW;
  const canvas = () => state.canvases[state.side];
  const active = () => canvas()?.getActiveObject();

  /* ---------- Onglets ---------- */
  const mobile = () => window.matchMedia('(max-width: 899px)').matches;
  // Texte et Tailles (mobile, variante E) : le panneau s'ouvre EN BAS, à la place de la barre prix / panier, sous les
  // onglets, compact, pour garder le vêtement visible pendant la saisie (retours Karim 16/10/2026).
  const BAS = ['texte', 'quantites'];
  function majBas() {
    if (modal.classList.contains('pp-tiroir')) { modal.classList.remove('pp-bas'); return false; }
    const avant = modal.classList.contains('pp-bas');
    const bas = mobile() && modal.classList.contains('pp-var-e') && modal.classList.contains('pp-sheet-open') && BAS.includes(state.tab);
    modal.classList.toggle('pp-bas', bas);
    return avant !== bas;
  }
  function feuille(ouverte) {
    if (modal.classList.contains('pp-tiroir')) { tiroirCran(ouverte ? (modal.dataset.cran === 'ferme' ? 'moitie' : modal.dataset.cran) : 'ferme'); return; }
    const avant = modal.classList.contains('pp-sheet-open');
    modal.classList.toggle('pp-sheet-open', !!ouverte && mobile());
    const basChange = majBas();
    // Variante E : le panneau est dans la page (il ne recouvre pas le vêtement) → l'aperçu se redessine à la place restante.
    if (modal.classList.contains('pp-var-e') && (basChange || avant !== modal.classList.contains('pp-sheet-open'))) drawMockup();
  }
  function setTab(name) {
    $$('[data-pp-tab]').forEach((b) => { const on = b.dataset.ppTab === name; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
    $$('[data-pp-panel]').forEach((p) => { p.hidden = p.dataset.ppPanel !== name; });
    state.tab = name;
    if (modal.classList.contains('pp-tiroir')) tiroirTitre();
    if (majBas() && modal.classList.contains('pp-var-e')) drawMockup();
  }

  /* ---------- Variantes ---------- */
  const optIndex = (names) => data.options.findIndex((o) => names.includes(o.name.toLowerCase()));
  const couleurIdx = optIndex(['couleur', 'color', 'coloris']);
  const tailleIdx = optIndex(['taille', 'size', 'tailles']);
  const couleurOf = (v) => (couleurIdx >= 0 && v ? v.options[couleurIdx] : '');
  const variantFor = (couleur, taille) => data.variants.find((v) =>
    (couleurIdx < 0 || v.options[couleurIdx] === couleur) && (tailleIdx < 0 || v.options[tailleIdx] === taille));

  function currentPageVariantId() {
    const input = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    const fromUrl = new URLSearchParams(location.search).get('variant');
    return Number(input?.value || fromUrl) || data.variants[0].id;
  }

  function buildSwatches() {
    const box = $('[data-pp-swatches]');
    box.innerHTML = '';
    if (couleurIdx < 0) { $('[data-pp-tab="couleur"]').hidden = true; return; }
    data.options[couleurIdx].values.forEach((val) => {
      const v = data.variants.find((x) => x.options[couleurIdx] === val);
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'pp-swatch';
      b.title = val;
      b.setAttribute('aria-label', val);
      b.dataset.value = val;
      // Pastille : couleur unie, la même que celle du vêtement dessiné (teinte réglée pour le produit,
      // sinon couleur lue au centre du vêtement sur la photo de la variante).
      const hex = data.couleurs_hex?.[val];
      if (hex) b.style.background = hex;
      else if (v) targetColor(v).then((c) => { b.style.background = `rgb(${c.map(Math.round).join(',')})`; });
      b.addEventListener('click', () => setVariant(v));
      box.appendChild(b);
    });
  }

  // Quantités par taille (le palier de prix se calcule sur le total).
  function buildSizes() {
    const box = $('[data-pp-sizes]');
    box.innerHTML = '';
    const tailles = tailleIdx >= 0 ? data.options[tailleIdx].values : [''];
    tailles.forEach((t) => {
      const v = variantFor(state.variant ? couleurOf(state.variant) : '', t);
      const ok = v && v.available;
      const cell = document.createElement('div');
      cell.className = 'pp-size' + (ok ? '' : ' is-off');
      cell.innerHTML = `<span>${t || ptxT("Quantité")}</span>
        <div class="pp-stepper"><button type="button" aria-label="${ptxT("Moins")}">−</button><input type="number" min="0" inputmode="numeric" class="pp-input" aria-label="Quantité ${t}"><button type="button" aria-label="${ptxT("Plus")}">+</button></div>`;
      const [minus, plus] = cell.querySelectorAll('button');
      const input = cell.querySelector('input');
      input.value = state.qty[t] || '';
      input.placeholder = '0';
      [minus, plus, input].forEach((el) => { el.disabled = !ok; });
      const set = (n) => { state.qty[t] = Math.max(0, n); input.value = state.qty[t] || ''; state.tailleChoisie = true; updatePrice(); };
      minus.addEventListener('click', () => set((state.qty[t] || 0) - 1));
      plus.addEventListener('click', () => set((state.qty[t] || 0) + 1));
      input.addEventListener('input', () => set(parseInt(input.value, 10) || 0));
      box.appendChild(cell);
    });
  }

  function setVariant(v) {
    Object.keys(facesPretes).forEach((s) => { delete facesPretes[s]; }); // autre couleur : pré-dessins périmés
    if (!v) return;
    const first = !state.variant;
    state.variant = v;
    if (first) state.qty[tailleIdx >= 0 ? v.options[tailleIdx] : ''] = 1;
    $$('.pp-swatch').forEach((b) => b.classList.toggle('is-active', b.dataset.value === couleurOf(v)));
    const name = $('[data-pp-color-name]');
    if (name) name.textContent = couleurOf(v);
    buildSizes();
    drawMockup();
    if (!first) { stage.classList.remove('pp-couleur'); void stage.offsetWidth; stage.classList.add('pp-couleur'); } // nouvelle couleur : la photo réapparaît en fondu court
    document.dispatchEvent(new CustomEvent("pp:couleur", { detail: { id: v.id } })); // fiche (phrase + tableau) alignée sur la couleur de l'outil
    updatePrice();
    couleurTexteAuto();
    majVetement();
  }

  // Couleur du texte par défaut : blanc sur vêtement foncé, noir sur clair (contour à l'inverse),
  // tant que le client n'a pas choisi lui-même une couleur de texte.
  let couleurTexteChoisie = false;
  function couleurTexteAuto() {
    if (!state.variant) return;
    targetColor(state.variant).then(([r, g, b]) => {
      const fonce = 0.299 * r + 0.587 * g + 0.114 * b < 140;
      state.fonce = fonce;
      ext.couleur.forEach((f) => f(fonce)); // modules (modèles prêts) : couleur adaptée au vêtement
      if (couleurTexteChoisie) return;
      T.color.value = fonce ? '#ffffff' : '#000000';
      T.stroke.value = fonce ? '#000000' : '#ffffff';
      $$('[data-pp-swatch-color]').forEach((x) => x.classList.toggle('is-active', x.dataset.ppSwatchColor === T.color.value));
      // Texte sélectionné encore à la couleur automatique : il suit le changement de couleur du vêtement.
      const t = active();
      if (t?.ppType === 'text' && t.ppProps?.fill !== T.color.value && ['#ffffff', '#000000'].includes(t.ppProps?.fill)) textChanged();
    });
  }

  /* ---------- Photos produit et dos teinté ---------- */
  function loadImage(url) {
    if (!url) return Promise.resolve(null);
    if (!state.images[url]) {
      state.images[url] = new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        // Décodée en arrière-plan avant usage : le changement de couleur est ensuite instantané.
        // decode() peut ne jamais aboutir (onglet en arrière-plan) : on n'attend pas plus de 500 ms.
        img.onload = () => Promise.race([img.decode ? img.decode().catch(() => {}) : null, new Promise((r) => setTimeout(r, 500))]).then(() => resolve(img));
        img.onerror = () => resolve(null);
        img.src = url;
      });
    }
    return state.images[url];
  }

  function averageColor(img, fx, fy, fw, fh) {
    const c = document.createElement('canvas');
    c.width = 60; c.height = 60;
    const ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, img.naturalWidth * fx, img.naturalHeight * fy, img.naturalWidth * fw, img.naturalHeight * fh, 0, 0, 60, 60);
    const d = ctx.getImageData(0, 0, 60, 60).data;
    const m = [0, 0, 0];
    for (let i = 0; i < d.length; i += 4) for (let k = 0; k < 3; k++) m[k] += d[i + k];
    return m.map((x) => x / (d.length / 4));
  }

  /* Contours du vêtement sur une photo (fractions de la photo) : la zone d'impression est placée par rapport
     au vêtement, ce qui permet d'utiliser des photos cadrées différemment. */
  // Calcul des contours et des zones : assets/printtex-zone.js (commun avec la planche de contrôle).
  const garmentBox = (el) => window.PrinttexZone.garmentBox(el, data);
  const boxes = { set: (el, b) => window.PrinttexZone.setBox(el, b) };

  const centre = (b) => [b.x + b.w * 0.4, b.y + b.h * 0.42, b.w * 0.2, b.h * 0.18];
  const lum = (r, g, b) => 0.299 * r + 0.587 * g + 0.114 * b;

  // Couleur du vêtement d'une variante, lue au centre du vêtement sur sa photo.
  const colors = {};
  function targetColor(v) {
    const key = couleurOf(v) || 'defaut';
    if (!colors[key]) {
      // Teinte imposée par le réglage du produit (produits sans photo par couleur), sinon lue sur la photo de la variante.
      const hex = data.couleurs_hex?.[couleurOf(v)];
      colors[key] = hex
        ? Promise.resolve([1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16)))
        : loadImage(v.image || data.defaultImage).then((img) => (img ? averageColor(img, ...centre(garmentBox(img))) : [255, 255, 255]));
    }
    return colors[key];
  }

  // Teint une photo de base (fond transparent ou uni) avec la couleur de la variante, en gardant plis et ombres.
  const tints = {};
  function tinted(url, v) {
    if (!v) return loadImage(url); // variante pas encore choisie : photo telle quelle
    const key = `${url}|${couleurOf(v)}`;
    if (!tints[key]) {
      tints[key] = (async () => {
        const base = await loadImage(url);
        if (!base) return null;
        const target = await targetColor(v);
        const W = Math.min(1200, base.naturalWidth);
        const H = Math.round(W * base.naturalHeight / base.naturalWidth);
        const c = document.createElement('canvas');
        c.width = W; c.height = H;
        const ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(base, 0, 0, W, H);
        const lm = lum(...averageColor(base, ...centre(garmentBox(base)))) || 1;
        // Sur une photo de base foncée, les écarts de lumière sont amplifiés : on les atténue.
        const k = Math.max(0.25, Math.min(1, lm / 128));
        const id = ctx.getImageData(0, 0, W, H);
        const p = id.data;
        const bg = [p[0], p[1], p[2], p[3]];
        for (let i = 0; i < p.length; i += 4) {
          if (!p[i + 3]) continue;
          // Fond : rendu transparent. Teint en blanc, le vêtement aurait exactement la couleur du fond et le détourage le
          // mangerait (Karim 23/10 : t-shirt blanc troué) ; transparent, la photo se pose telle quelle sur la pierre.
          if (bg[3] > 20 && Math.abs(p[i] - bg[0]) + Math.abs(p[i + 1] - bg[1]) + Math.abs(p[i + 2] - bg[2]) < 36) { p[i + 3] = 0; continue; }
          const l = lum(p[i], p[i + 1], p[i + 2]);
          const extra = (l - lm) * 0.35; // garde du relief sur les couleurs foncées
          const f = 1 + (l / lm - 1) * k;
          for (let c = 0; c < 3; c++) p[i + c] = Math.max(0, Math.min(255, target[c] * f + extra));
        }
        ctx.putImageData(id, 0, 0);
        // Contours mesurés sur la photo d'origine : sur un vêtement teint en blanc, le fond ne se distingue plus.
        boxes.set(c, garmentBox(base));
        return c;
      })();
    }
    return tints[key];
  }

  // Photo à afficher pour un côté. Réglage par produit : data.face / data.dos = { image, tint }.
  // Sans réglage : photo de la variante (retournée pour le dos).
  async function mockupSource(side) {
    const v = state.variant;
    const cfg = data[side] || {};
    const url = cfg.images?.[couleurOf(v)] || cfg.image;
    if (url) {
      const el = cfg.tint ? await tinted(url, v) : await loadImage(url);
      // Même cadrage pour toutes les couleurs d'un produit : zone mesurée sur la photo principale (un blanc sur fond clair
      // paraît plus étroit et décalerait la zone ; correctif repris de l'appli, 17/10/2026).
      if (el && cfg.image && url !== cfg.image) { const ref = await loadImage(cfg.image); if (ref) boxes.set(el, garmentBox(ref)); }
      if (el) { ratiosFaces[side] = ratioOf(el); return { el, mirror: !!cfg.mirror }; }
    }
    const el = await loadImage(v?.image || data.defaultImage); if (el) ratiosFaces[side] = ratioOf(el);
    return { el, mirror: side === 'dos' && !data.jambes };
  }
  const ratiosFaces = {}; // format (h / l) de la photo de chaque face : la scène prend le plus haut, pour ne jamais changer de taille

  const ratioOf = (el) => (el ? (el.naturalHeight || el.height) / (el.naturalWidth || el.width) : 1.2);

  // Teinte « pierre » des photos (charte v2, comme le site) : var(--ptx-photo), sinon #ecebe8 (#cfcbc5 en sombre).
  const pierre = () => (getComputedStyle(document.documentElement).getPropertyValue('--ptx-photo').trim() || (window.matchMedia('(prefers-color-scheme: dark)').matches ? '#cfcbc5' : '#ecebe8'));
  const photosPierre = new Map();
  function photoPierre(el) {
    const teinte = pierre(); const cle = el;
    const deja = photosPierre.get(cle); if (deja && deja.teinte === teinte) return deja.c;
    const nw = el.naturalWidth || el.width; const nh = el.naturalHeight || el.height;
    if (!nw || !nh) return el;
    const k = Math.min(1, 900 / Math.max(nw, nh)); const W = Math.round(nw * k); const H = Math.round(nh * k);
    const c = document.createElement('canvas'); c.width = W; c.height = H;
    const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(el, 0, 0, W, H);
    let img; try { img = x.getImageData(0, 0, W, H); } catch (e) { return el; } // photo d'un autre domaine : telle quelle
    const d = img.data; const ref = [d[0], d[1], d[2]];
    if (d[3] === 0) { photosPierre.set(cle, { c: el, teinte }); return el; } // photo déjà détourée (transparence) : posée telle quelle sur la pierre
    const m = document.createElement('canvas').getContext('2d'); m.fillStyle = teinte; m.fillRect(0, 0, 1, 1); const t = m.getImageData(0, 0, 1, 1).data;
    // Fond = pixels proches de la couleur du coin, reliés aux bords (le vêtement, entouré de son contour, est épargné).
    // Tolérance selon le contraste vêtement / fond (centre de la photo) : un vêtement foncé supporte 40 (le halo et le
    // grain du fond partent), un vêtement blanc sur fond blanc reste à 6 (Karim 22/10 : « il reste du fond » sur le bob).
    let contraste = 0; { const cx = W >> 1; const cy = H >> 1; let n = 0; for (let y = cy - 16; y <= cy + 16; y += 4) for (let x2 = cx - 16; x2 <= cx + 16; x2 += 4) { const p = (y * W + x2) * 4; contraste += Math.abs(d[p] - ref[0]) + Math.abs(d[p + 1] - ref[1]) + Math.abs(d[p + 2] - ref[2]); n++; } contraste /= n; }
    const TOL = Math.max(6, Math.min(110, Math.round(contraste / 5))); // noir : 110 (ombre portée gris clair comprise), beige : ~10, blanc : 6
    const proche = (p) => Math.abs(d[p] - ref[0]) + Math.abs(d[p + 1] - ref[1]) + Math.abs(d[p + 2] - ref[2]) <= TOL;
    const vu = new Uint8Array(W * H); const pile = [];
    for (let i = 0; i < W; i++) { pile.push(i, (H - 1) * W + i); }
    for (let i = 0; i < H; i++) { pile.push(i * W, i * W + W - 1); }
    while (pile.length) {
      const q = pile.pop(); if (vu[q]) continue; const p = q * 4; if (!proche(p)) continue;
      vu[q] = 1; d[p] = t[0]; d[p + 1] = t[1]; d[p + 2] = t[2];
      const px = q % W; if (px > 0) pile.push(q - 1); if (px < W - 1) pile.push(q + 1); if (q >= W) pile.push(q - W); if (q < W * (H - 1)) pile.push(q + W);
    }
    // Trous de fond fermés (anse d'un tote, tour de cou d'un tablier) : sur un vêtement contrasté (TOL > 20), les zones de la
    // couleur du fond non reliées aux bords et d'au moins 0,1 % de la photo deviennent aussi du fond (Karim 22/10).
    if (TOL > 20) {
      const vu2 = new Uint8Array(W * H);
      for (let s0 = 0; s0 < W * H; s0++) {
        if (vu[s0] || vu2[s0] || !proche(s0 * 4)) continue;
        const comp = []; const p2 = [s0]; vu2[s0] = 1;
        while (p2.length) { const q = p2.pop(); comp.push(q); const px = q % W; for (const r of [px > 0 ? q - 1 : -1, px < W - 1 ? q + 1 : -1, q >= W ? q - W : -1, q < W * (H - 1) ? q + W : -1]) { if (r >= 0 && !vu[r] && !vu2[r] && proche(r * 4)) { vu2[r] = 1; p2.push(r); } } }
        if (comp.length >= W * H * 0.001) comp.forEach((q) => { vu[q] = 1; const p = q * 4; d[p] = t[0]; d[p + 1] = t[1]; d[p + 2] = t[2]; });
      }
    }
    // Bord : 3 pixels du vêtement le long du fond, multipliés par la teinte (plus de liseré blanc, Karim 20/10).
    let bord = vu;
    for (let n = 0; n < 3; n++) {
      const suiv = new Uint8Array(bord);
      for (let q = 0; q < W * H; q++) {
        if (bord[q]) continue; const px = q % W;
        if ((px > 0 && bord[q - 1]) || (px < W - 1 && bord[q + 1]) || (q >= W && bord[q - W]) || (q < W * (H - 1) && bord[q + W])) { suiv[q] = 1; const p = q * 4; d[p] = d[p] * t[0] / 255; d[p + 1] = d[p + 1] * t[1] / 255; d[p + 2] = d[p + 2] * t[2] / 255; }
      }
      bord = suiv;
    }
    x.putImageData(img, 0, 0);
    photosPierre.set(cle, { c, teinte });
    return c;
  }
  function paintSource(ctx, src, w, h) {
    ctx.fillStyle = src.el ? pierre() : '#ffffff';
    ctx.fillRect(0, 0, w, h);
    if (!src.el) return;
    ctx.save();
    if (src.mirror) { ctx.translate(w, 0); ctx.scale(-1, 1); }
    ctx.drawImage(photoPierre(src.el), 0, 0, w, h);
    ctx.restore();
  }

  // Zone d'impression en pixels pour une photo affichée en w × h (zone définie par rapport au vêtement).
  const zoneRect = (side, src, w, h) => window.PrinttexZone.zoneRect(data, side, src, w, h, state.miroir[side]);

  // Le produit s'adapte à la place disponible (largeur ET hauteur) : il reste entièrement visible.
  let drawToken = 0;
  let vetementAffiche = null;
  // Cadrage, zoom et fenêtre de la photo d'une face (lectures de mise en page seulement) : partagé par drawMockup et le
  // pré-dessin de l'autre face pour la rotation.
  function calculerVue(side, src) {
    const ratio = Math.max(ratioOf(src.el), ...Object.values(ratiosFaces)); // même scène pour Face et Dos
    const availW = stageWrap.clientWidth - railLargeur(); // téléphone : le rail d'icônes à gauche ne couvre pas le vêtement
    const posRow = $('[data-pp-pos]');
    refreshPos();
    // Place pour la ligne d'info (et les boutons de placement) sous le produit.
    const ligneE = modal.classList.contains('pp-var-e') && mobile()
      ? [...stageWrap.children].filter((e) => e !== stage && getComputedStyle(e).position !== 'absolute' && e.offsetParent).reduce((t, e) => t + e.offsetHeight, 0) + 4 : 0;
    // Téléphone (tiroir) : bande du haut réservée aux pastilles et boutons posés sur la scène.
    const bandeHaut = (modal.classList.contains('pp-bas3') && window.matchMedia('(orientation: landscape) and (max-height: 500px)').matches) ? 0 : modal.classList.contains('pp-tiroir') && ( // couché : pas de bande
glisseMode() || modal.dataset.cran !== 'plein' || window.matchMedia('(orientation: landscape) and (max-height: 500px)').matches) ? 54 : 0;
    stage.style.marginTop = bandeHaut ? `${bandeHaut}px` : '';
    const availH = -bandeHaut + (ligneE ? stageWrap.clientHeight - ligneE : mobile() ? stageWrap.clientHeight - 4 : stageWrap.clientHeight - 34 - (posRow.hidden ? 0 : posRow.offsetHeight + 8));
    /* Vue (15/10/2026) : photo recadrée sur le vêtement (marge 3 %) pour qu'il occupe toute la place ; zoom sur la zone
       d'impression (bouton Zoom / Vue entière, automatique à l'ajout d'un design, pincer sur mobile). La photo entière
       est calculée à l'échelle FW × FH puis décalée (ox, oy) dans la fenêtre vw × vh. */
    const g = { ...garmentBox(src.el) };
    if (src.mirror) g.x = 1 - g.x - g.w;
    const m = 0.03;
    const crop = { x: Math.max(0, g.x - m), y: Math.max(0, g.y - m) };
    crop.w = Math.min(1, g.x + g.w + m) - crop.x;
    crop.h = Math.min(1, g.y + g.h + m) - crop.y;
    const fit = Math.max(200, Math.min(availW / crop.w, availH / (crop.h * ratio)));
    // Zoom qui fait tenir la zone d'impression dans 85 % de la fenêtre.
    const z1 = zoneRect(side, src, fit, fit * ratioOf(src.el));
    const zoomZone = Math.max(1, Math.min((availW * 0.85) / z1.width, (availH * 0.85) / z1.height, 4));
    // Mobile : la vue « entière » remplit la hauteur (manches coupées sur les côtés, comme les grands éditeurs).
    // (Variante E : vêtement entier en pleine largeur, sans couper les manches.)
    const plein = mobile() && !modal.classList.contains('pp-var-e') ? Math.min(4, Math.max(1, availH / (crop.h * ratio) / fit)) : 1;
    const zoom = vue.mode === 'zone' ? Math.max(zoomZone, plein) : vue.mode === 'entier' ? plein : Math.min(4, Math.max(1, Number(vue.mode) || 1));
    const FW = fit * zoom; const FH = FW * ratio;
    /* Lot 30 (Karim 23/10 : « le dos est allongé ») : la photo est dessinée à SON format (FHs), centrée dans la scène commune
       FW × FH (hauteur du côté le plus haut, pour que la scène ne change pas de taille) ; avant, elle était étirée à FH. */
    const FHs = FW * ratioOf(src.el); const dy = (FH - FHs) / 2;
    const vw = Math.floor(Math.min(availW, crop.w * FW)); const vh = Math.floor(Math.min(availH, crop.h * FH));
    const r0 = zoneRect(side, src, FW, FHs); r0.top += dy;
    const borne = (o, debut, taille, fen) => (taille <= fen ? (fen - taille) / 2 - debut : Math.min(-debut, Math.max(fen - debut - taille, o)));
    const ox = borne(zoom > 1 ? vw / 2 - (r0.left + r0.width / 2) : -crop.x * FW, crop.x * FW, crop.w * FW, vw);
    const oy = borne(zoom > 1 ? vh / 2 - (r0.top + r0.height / 2) : -(crop.y * FHs + dy), crop.y * FHs + dy, crop.h * FHs, vh);
    return { ratio, FW, FH, FHs, dy, vw, vh, r0, ox, oy, zoomZone, plein, zoom };
  }
  const facesPretes = {}; let drawEpoque = 0;
  async function drawMockup() {
    const token = ++drawToken; drawEpoque++;
    const side = state.side;
    // Simple redessin (pincer, cran du tiroir, place restante) : la photo reste affichée, pas de fondu ni de chargeur.
    // Le fondu ne sert qu'au changement de photo (couleur, face / dos) quand elle doit être chargée.
    const attente = setTimeout(() => { if (token === drawToken) stage.classList.add('is-loading'); }, 150);
    const src = await mockupSource(side);
    clearTimeout(attente);
    if (token !== drawToken) return;
    stage.classList.remove('is-loading');
    if (src.el !== vetementAffiche) {
      // Fondu enchaîné : copie de l'ancienne photo par-dessus la nouvelle, qui s'efface (jamais de vêtement vide).
      if (vetementAffiche && !state.sansFondu && mockupCanvas.width && mockupCanvas.offsetWidth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const fondu = document.createElement('canvas'); fondu.width = mockupCanvas.width; fondu.height = mockupCanvas.height;
        fondu.getContext('2d').drawImage(mockupCanvas, 0, 0);
        fondu.className = 'pp-mockup-fondu';
        Object.assign(fondu.style, { left: `${mockupCanvas.offsetLeft}px`, top: `${mockupCanvas.offsetTop}px`, width: `${mockupCanvas.offsetWidth}px`, height: `${mockupCanvas.offsetHeight}px` });
        stage.querySelectorAll('.pp-mockup-fondu').forEach((x) => x.remove());
        mockupCanvas.after(fondu);
        requestAnimationFrame(() => requestAnimationFrame(() => fondu.classList.add('is-sortie')));
        setTimeout(() => fondu.remove(), 260);
      }
      vetementAffiche = src.el;
      // Nouvelle photo (couleur, face / dos) : remplacée d'un coup, jamais effacée (Karim : « fluide », pas de clignotement).
      mockupCanvas.classList.add('is-shown');
    }
    const { ratio, FW, FH, FHs, dy, vw, vh, r0, ox, oy, zoomZone, plein, zoom } = calculerVue(side, src);
    vue.zoomZone = zoomZone;
    const dpr = window.devicePixelRatio || 1;
    mockupCanvas.width = vw * dpr;
    mockupCanvas.height = vh * dpr;
    stage.style.width = `${vw}px`;
    stage.style.height = `${vh}px`;
    const ctx = mockupCanvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.fillStyle = pierre(); // charte v2 : même fond « pierre » que le site
    ctx.fillRect(0, 0, vw, vh);
    ctx.translate(ox, oy + dy);
    paintSource(ctx, src, FW, FHs);
    if (!ressort.anim) { mockupCanvas.style.transform = ''; if (ressort.double) { ressort.double.remove(); ressort.double = null; } } // fin de rotation : le principal, repeint, reprend
    layoutZone({ ...r0, left: r0.left + ox, top: r0.top + oy });
    // L'autre face est pré-dessinée dans un temps libre, pour la rotation.
    if (state.ready && !ressort.anim) setTimeout(() => { if (!ressort.anim) Object.keys(SIDES).filter((s) => s !== state.side).forEach((s) => prechaufferFace(s)); }, 60); // tout de suite après le dessin (requestIdleCallback tardait sur processeur lent)
    glisseApresDessin();
    const zb = $('[data-pp-zoom]');
    if (zb) { zb.hidden = zoomZone < plein * 1.15; zb.textContent = zoom > plein * 1.05 ? ptxT("Vue entière") : ptxT("Zoom sur la zone"); }
  }

  // Mode de vue : 'entier', 'zone' ou un facteur de zoom (pincer). auto = zoom automatique à l'ajout d'un design.
  const vue = { mode: 'entier', auto: true, zoomZone: 1 };
  function setVue(mode, manuel) {
    if (manuel) vue.auto = false;
    if (vue.mode === mode) return;
    vue.mode = mode;
    drawMockup();
  }
  // Variante E : pas de zoom automatique sur la zone (le vêtement reste entier, retour Karim 16/10) ; bouton loupe pour zoomer.
  function zoomAuto() { if (vue.auto && vue.mode === 'entier' && !modal.classList.contains('pp-var-e')) setVue('zone'); }

  // Couleur du fond de la photo (coin haut gauche) : remplit les bords quand la photo ne couvre pas la fenêtre.
  const fonds = new WeakMap();
  function fondPhoto(el) {
    if (!el) return '#ffffff';
    if (!fonds.has(el)) {
      const c = document.createElement('canvas'); c.width = 4; c.height = 4;
      const x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(el, 0, 0, 40, 40 * ratioOf(el));
      const d = x.getImageData(0, 0, 1, 1).data;
      fonds.set(el, d[3] < 20 ? '#ffffff' : `rgb(${d[0]},${d[1]},${d[2]})`);
    }
    return fonds.get(el);
  }

  /* ---------- Zones d'impression (Fabric) ---------- */
  function createCanvases() {
    fabric.Object.prototype.set({
      transparentCorners: false, cornerColor: '#ffffff', cornerStrokeColor: '#141210',
      borderColor: '#ffffff', cornerSize: 14, touchCornerSize: 30, cornerStyle: 'circle', padding: 4,
      lockScalingFlip: true, // un doigt qui dépasse le bord opposé ne retourne plus l'objet (texte lu à l'envers, vidéo Karim 23/10)
    });
    // Cadre de sélection bicolore (trait sombre, puis tirets blancs) : lisible sur un vêtement blanc comme noir.
    if (!fabric.Object.prototype.drawBordersBicolore) {
      const db = fabric.Object.prototype.drawBorders; fabric.Object.prototype.drawBordersBicolore = true;
      fabric.Object.prototype.drawBorders = function (ctx, opts) { const c = this.borderColor; const d = this.borderDashArray; this.borderColor = 'rgba(20, 18, 16, 0.75)'; this.borderDashArray = null; db.call(this, ctx, opts); this.borderColor = '#ffffff'; this.borderDashArray = [4, 3]; db.call(this, ctx, opts); this.borderColor = c; this.borderDashArray = d; return this; };
    }
    // Variante E : poignées plus fines (le vêtement est plus petit quand le panneau est ouvert).
    if (modal.classList.contains('pp-var-e')) {
      // Lot 29 : poignées tactiles larges (Karim 20/10 : un toucher à côté désélectionnait) ; côtés visibles = déformation libre.
      fabric.Object.prototype.set({ cornerSize: 10, touchCornerSize: 40, padding: 10 });
    }
    fabric.Object.prototype.set({ snapAngle: 45, snapThreshold: 6 });
    // Enregistrement : une image traitée (canevas, remplacé à chaque traitement) n'est convertie en PNG qu'une fois.
    if (!fabric.Image.prototype.ptxSrc) {
      const srcCache = new WeakMap(); const getSrc = fabric.Image.prototype.getSrc;
      fabric.Image.prototype.ptxSrc = true;
      fabric.Image.prototype.getSrc = function (filtered) {
        const el = filtered ? this._element : this._originalElement;
        if (!el || !el.toDataURL) return getSrc.call(this, filtered);
        if (!srcCache.has(el)) srcCache.set(el, getSrc.call(this, filtered));
        return srcCache.get(el);
      };
    }
    // Croix « retirer » (Karim : sans ordinateur, pas de touche Suppr) : coin haut droit, à l'intérieur de l'élément
    // pour rester visible même collé au bord de la zone ; cible tactile de 44 px.
    if (fabric.Object.prototype.controls && !fabric.Object.prototype.controls.retirer) {
      fabric.Object.prototype.controls.retirer = new fabric.Control({
        x: 0.5, y: -0.5, offsetX: -16, offsetY: 16, sizeX: 26, sizeY: 26, touchSizeX: 44, touchSizeY: 44, cursorStyle: 'pointer',
        render(ctx, left, top) {
          ctx.save(); ctx.translate(left, top);
          ctx.beginPath(); ctx.arc(0, 0, 12, 0, Math.PI * 2); ctx.fillStyle = '#0d0d0d'; ctx.fill();
          ctx.lineWidth = 1.5; ctx.strokeStyle = '#ffffff'; ctx.stroke();
          ctx.beginPath(); ctx.moveTo(-4.5, -4.5); ctx.lineTo(4.5, 4.5); ctx.moveTo(4.5, -4.5); ctx.lineTo(-4.5, 4.5);
          ctx.lineWidth = 2.2; ctx.lineCap = 'round'; ctx.stroke(); ctx.restore();
        },
        mouseUpHandler(e, t) { const cible = t?.target; if (!cible?.canvas || t.corner !== 'retirer' || t.action === 'drag') return false; cible.canvas.setActiveObject(cible); action('delete'); return true; },
      });
    }
    Object.keys(SIDES).forEach((side) => {
      if (side !== 'face' && side !== 'dos' && !document.getElementById(`PrinttexCanvas_${side}`)) ajouterCote(side);
      const el = document.getElementById(side === 'face' ? 'PrinttexCanvasFace' : side === 'dos' ? 'PrinttexCanvasDos' : `PrinttexCanvas_${side}`);
      const c = new fabric.Canvas(el, { preserveObjectStacking: true, selection: false, targetFindTolerance: 15 });
      // Un toucher à moins de 24 px de l'élément sélectionné le garde sélectionné (au lieu de viser le vêtement).
      const ft = c.findTarget.bind(c);
      c.findTarget = (ev, skip) => { const t = ft(ev, skip); const a = c.getActiveObject(); if (t || !a) return t; const p = c.getPointer(ev); const r = a.getBoundingRect(); const m = 24 / (c.getZoom() || 1); return p.x >= r.left - m && p.x <= r.left + r.width + m && p.y >= r.top - m && p.y <= r.top + r.height + m ? a : t; };
      if (!fabric.Object.prototype.ptxApparition) {
        // Opacité d'apparition appliquée au rendu uniquement (ppApparition n'est jamais enregistré).
        const op = fabric.Object.prototype._setOpacity; fabric.Object.prototype.ptxApparition = true;
        fabric.Object.prototype._setOpacity = function (ctx) { op.call(this, ctx); if (this.ppApparition != null && this.ppApparition < 1) ctx.globalAlpha *= this.ppApparition; };
      }
      c.on('object:added', (e) => {
        const o = e.target;
        if (state.restoring || !o || !/^(image|text)$/.test(o.ppType) || o._ptxVu) return;
        o._ptxVu = true;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const t0 = performance.now(); o.ppApparition = 0.4;
        const duree = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mv-apparition')) || 200;
        const pas = (t) => { const k = Math.min(1, (t - t0) / duree); o.ppApparition = 0.4 + 0.6 * (1 - (1 - k) ** 3); c.requestRenderAll(); if (k < 1) requestAnimationFrame(pas); else { delete o.ppApparition; c.requestRenderAll(); } };
        requestAnimationFrame(pas);
      });
      c.on('selection:created', onSelection);
      c.on('selection:updated', onSelection);
      c.on('selection:cleared', onSelection);
      // Agrandissement et rotation bloqués à la plus grande taille qui tient entièrement dans la zone.
      c.on('object:scaling', (e) => { const k = e.transform?.corner; state.etire = k === 'ml' || k === 'mr' ? ptxT("largeur") : k === 'mt' || k === 'mb' ? ptxT("hauteur") : ''; fitInZone(e.target, state.side, true); onSelection(); });
      c.on('object:added', (e) => { if (e.target?.ppType === 'image') e.target.setControlsVisibility({ ml: false, mr: false, mt: false, mb: false }); }); // Karim 23/10 : une image s'agrandit toujours en proportion (plus de poignées du milieu qui la déforment)
      c.on('object:rotating', (e) => { fitInZone(e.target, state.side, true); onSelection(); });
      // Un élément ne sort jamais de la zone d'impression : rien n'est coupé à l'impression.
      c.on('object:moving', (e) => { $('[data-pp-float]').hidden = true; fitInZone(e.target, state.side, true); });
      c.on('object:modified', (e) => { state.etire = ''; fitInZone(e.target, state.side, true); c.requestRenderAll(); onSelection(); snapshot(); });
      if (data.jambes) placementFixe(c, side);
      state.canvases[side] = c;
      snapshot(side);
    });
  }

  function layoutZone(r) {
    const side = state.side;
    const z = zoneOf(side);
    const zw = Math.round(r.width);
    const zh = Math.round(r.height);
    const ancien = ratioZone[side];
    ratioZone[side] = r.height / r.width; // tailles exactes : l'arrondi au pixel ne doit pas faire croire à une autre forme
    const box = $(`[data-pp-zone="${side}"]`);
    box.style.left = `${Math.round(r.left)}px`;
    box.style.top = `${Math.round(r.top)}px`;
    box.style.width = `${zw}px`;
    box.style.height = `${zh}px`;
    const c = state.canvases[side];
    if (c.getWidth() !== zw || c.getHeight() !== zh) c.setDimensions({ width: zw, height: zh }); // sinon le canevas serait vidé pour rien
    c.setZoom(zw / LOGICAL_W);
    // Zone « forme » (short, débardeur) : contour en pointillés à la place du rectangle.
    formesZone[side] = r.forme ? { f: r.forme, mirror: r.mirror } : null;
    box.classList.toggle('pp-zone--forme', !!r.forme);
    let calque = box.querySelector('.pp-forme');
    if (r.forme) {
      if (!calque) { calque = document.createElement('canvas'); calque.className = 'pp-forme'; box.prepend(calque); }
      const dpr = window.devicePixelRatio || 1;
      calque.width = zw * dpr; calque.height = zh * dpr;
      const cx = calque.getContext('2d');
      cx.setTransform(dpr, 0, 0, dpr, 0, 0);
      window.PrinttexZone.dessinerForme(cx, r.forme, { left: 0, top: 0, width: zw, height: zh }, r.mirror, '#ffffff');
      if (!ancien) c.getObjects().forEach((o) => fitInZone(o, side));
    } else if (calque) calque.remove();
    // Forme de zone changée (autre photo, autre couleur) : les éléments sont recalés dans la nouvelle zone.
    if (ancien && Math.abs(ancien - ratioZone[side]) > 0.001) c.getObjects().forEach((o) => fitInZone(o, side));
    c.renderAll(); // tout de suite (pas à l'image suivante) : jamais d'image vide après un redimensionnement
    // Mention sous l'aperçu (ex. fermeture éclair qui traverse le visuel), face seulement.
    let mention = $('[data-pp-mention]');
    if (!mention) { mention = document.createElement('p'); mention.className = 'pp-mention'; mention.dataset.ppMention = ''; stage.after(mention); }
    mention.textContent = side === 'face' && data.mention_face ? ptxT(data.mention_face) : '';
    mention.hidden = !mention.textContent;
    const size = $('[data-pp-zone-size]');
    if (size) size.textContent = `${z.cmW.toLocaleString('fr-FR')} × ${z.cmH.toLocaleString('fr-FR')} ${ptxT("cm max.")}`;
    refreshUi();
  }

  // Emplacement en plus (jogging) : zone + bouton d'onglet copiés sur ceux du dos.
  function ajouterCote(side) {
    const zDos = $('[data-pp-zone="dos"]');
    const z = document.createElement('div');
    z.className = 'pp-zone';
    z.dataset.ppZone = side;
    z.hidden = true;
    z.innerHTML = zDos.innerHTML.replace(/<canvas[^>]*><\/canvas>/, '') + `<canvas id="PrinttexCanvas_${side}"></canvas>`;
    z.querySelectorAll('.canvas-container').forEach((n) => n.remove());
    zDos.after(z);
    const bDos = $('[data-pp-side="dos"]');
    const b = bDos.cloneNode(true);
    b.dataset.ppSide = side;
    b.classList.remove('is-active');
    b.setAttribute('aria-selected', 'false');
    b.querySelector('[data-pp-cote]')?.setAttribute('data-pp-cote', side);
    b.querySelector('[data-pp-dot]')?.setAttribute('data-pp-dot', side);
    const lib = b.querySelector('[data-pp-cote]');
    if (lib) lib.textContent = SIDES[side];
    $('.pp-seg').appendChild(b);
    b.addEventListener('click', () => setSide(side));
    const seg = $('.pp-seg');
    if (!seg.classList.contains('pp-seg--multi')) {
      seg.classList.add('pp-seg--multi');
      // Fondu à droite retiré quand on arrive au bout de la rangée.
      const fin = () => seg.classList.toggle('is-fin', seg.scrollLeft + seg.clientWidth >= seg.scrollWidth - 4);
      seg.addEventListener('scroll', fin, { passive: true });
      window.addEventListener('resize', fin);
      setTimeout(fin, 0);
    }
  }

  // Rotation A au ressort (Karim 21/10 : « effet A, vraiment fluide ») : angle piloté par un ressort physique au temps
  // réel (rAF, dt), interruptible à tout angle ; la face dessinée change au passage de 90° ; dépassement ≈ 10° ; ombre au
  // sol qui se resserre sur la tranche ; une écriture de transform par image ; will-change pendant la rotation seulement.
  const ROTATION_FACES = false; // Karim 23/10 (vidéo) : changement Face → Dos instantané, sans animation ni attente
  const ressort = { a: 0, v: 0, cible: 0, anim: 0, t: 0, de: null, vers: null };
  let ombreEl = null;
  function basculerSide(side) {
    if (side === state.side && !ressort.anim) return;
    if (!ROTATION_FACES) { setSide(side); return; }
    if (!state.ready || !mockupCanvas.classList.contains('is-shown') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { setSide(side); return; }
    if (!ressort.anim) { ressort.de = state.side; ressort.a = 0; ressort.v = 0; }
    ressort.vers = side === ressort.de ? null : side; ressort.cible = ressort.vers ? 180 : 0;
    // pas de préchauffage ici : il se fait dans un temps libre (sinon il tombe pendant les premières images) ; au pire, drawMockup à 90°
    if (!ombreEl) { ombreEl = document.createElement('div'); ombreEl.className = 'pp-ombre'; stage.appendChild(ombreEl); }
    stage.classList.add('pp-rotation'); state.sansFondu = true;
    if (!ressort.anim) { ressort.t = 0; ressort.anim = requestAnimationFrame(pasRessort); }
  }
  // Photo d'une face décodée et détourée d'avance (cache de photoPierre) : rien de lourd pendant la rotation.
  function prechaufferFace(side) {
    if (data.sides && !data.sides.includes(side)) return Promise.resolve(); // produit à une seule face (bob, casquette, tablier) : rien à pré-dessiner ni à retourner
    return mockupSource(side).then(async (s) => {
      if (!s.el) return; try { await s.el.decode?.(); } catch (e) { /* déjà décodée */ } photoPierre(s.el);
      const v = calculerVue(side, s); const dpr = window.devicePixelRatio || 1;
      const c = document.createElement('canvas'); c.width = v.vw * dpr; c.height = v.vh * dpr;
      const ctx = c.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.fillStyle = pierre(); ctx.fillRect(0, 0, v.vw, v.vh); ctx.translate(v.ox, v.oy + v.dy); paintSource(ctx, s, v.FW, v.FHs);
      // zone de cette face placée d'avance (élément caché) : rien à recalculer au passage de 90°
      if (side !== state.side && !ressort.anim) { const avant = state.side; state.side = side; try { layoutZone({ ...v.r0, left: v.r0.left + v.ox, top: v.r0.top + v.oy }); } finally { state.side = avant; refreshPos(); /* boutons de position : ceux de la face affichée */ } }
      facesPretes[side] = { canvas: c, vue: v, src: s, epoque: drawEpoque };
      if (side !== state.side && !ressort.anim) { if (ressort.double && ressort.double !== c) ressort.double.remove(); c.className = 'pp-mockup pp-mockup--double is-shown'; c.style.transform = 'rotateY(180deg)'; mockupCanvas.after(c); ressort.double = c; }
    }).catch((e) => { console.warn('Préchauffage de la face impossible :', e); });
  }
  function pasRessort(t) {
    const dt = Math.min(0.05, ressort.t ? (t - ressort.t) / 1000 : 1 / 60); ressort.t = t;
    const w = 11; const z = 0.68; // raideur et amortissement : balayage ≈ 0,29 s, posé en ≈ 0,53 s, dépassement ≈ 10°
    const x = ressort.a - ressort.cible;
    ressort.v += (-w * w * x - 2 * z * w * ressort.v) * dt; ressort.a += ressort.v * dt;
    const coteVoulu = ressort.a > 90 ? ressort.vers : ressort.de;
    if (coteVoulu && coteVoulu !== state.side) { // à 90° : bascule légère (photo + zone), le reste de setSide attend l'arrêt
      state.side = coteVoulu; $$('[data-pp-zone]').forEach((el) => { el.hidden = el.dataset.ppZone !== coteVoulu; }); $$('[data-pp-side]').forEach((bt) => bt.classList.toggle('is-active', bt.dataset.ppSide === coteVoulu));
      const p = facesPretes[coteVoulu]; // dos de la carte déjà dans la scène : rien à peindre ; sinon, drawMockup
      if (p && p.epoque === drawEpoque && ressort.double === p.canvas) vetementAffiche = p.src.el;
      else { if (ressort.double) { ressort.double.remove(); ressort.double = null; } drawMockup(); }
      ressort.finir = true;
    }
    const deg = ressort.a > 90 ? ressort.a - 180 : ressort.a; // la face dessinée est toujours celle qu'on voit
    const tf = `rotateY(${deg.toFixed(2)}deg)`;
    const zones = stage.querySelectorAll('[data-pp-zone]');
    mockupCanvas.style.transform = `rotateY(${ressort.a.toFixed(2)}deg)`; if (ressort.double) ressort.double.style.transform = `rotateY(${(ressort.a + 180).toFixed(2)}deg)`; zones.forEach((el) => { el.style.transform = tf; });
    const c = Math.abs(Math.cos((ressort.a * Math.PI) / 180));
    ombreEl.style.transform = `translateX(-50%) scaleX(${(0.5 + 0.5 * c).toFixed(3)})`; ombreEl.style.opacity = (0.35 + 0.4 * c).toFixed(2);
    if (Math.abs(x) < 0.05 && Math.abs(ressort.v) < 1) {
      ressort.a = ressort.cible; ressort.v = 0; ressort.anim = 0;
      zones.forEach((el) => { el.style.transform = ''; }); if (!ressort.finir) { mockupCanvas.style.transform = ''; if (ressort.double) ressort.double.style.transform = 'rotateY(180deg)'; }
      ombreEl.style.opacity = '0';
      stage.classList.remove('pp-rotation'); state.sansFondu = false; Object.values(state.canvases).forEach((cv) => cv.calcOffset());
      if (ressort.finir) { ressort.finir = false; setSide(state.side); } // rendu complet, sélection, boutons : à l'arrêt
      return;
    }
    ressort.anim = requestAnimationFrame(pasRessort);
  }
  function setSide(side) {
    state.side = side;
    Object.values(state.canvases).forEach((c) => c.discardActiveObject().requestRenderAll());
    if (T.input) T.input.value = ''; // autre face : le champ ne garde pas le texte de l'autre côté (sinon il serait dupliqué)
    $$('[data-pp-side]').forEach((b) => { const on = b.dataset.ppSide === side; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); if (on && b.parentNode.classList.contains('pp-seg--multi')) b.scrollIntoView({ block: 'nearest', inline: 'center' }); });
    $$('[data-pp-zone]').forEach((z) => { z.hidden = z.dataset.ppZone !== side; });
    drawMockup();
    onSelection();
  }

  /* ---------- Historique (annuler / rétablir) ---------- */
  function snapshot(side = state.side) {
    if (state.restoring) return;
    majLogoRefait();
    const c = state.canvases[side];
    const h = state.history[side];
    h.push(JSON.stringify(c.toJSON(['ppType', 'ppProps', 'ppId', 'ppFond', 'ppTol', 'ppCouleur', 'ppFondAuto'])));
    if (h.length > 40) h.shift();
    state.future[side] = [];
    refreshUi();
    scheduleSave();
  }

  function restore(json) {
    const c = canvas();
    state.restoring = true;
    c.loadFromJSON(json, () => {
      c.getObjects().forEach((o) => o.setCoords());
      c.discardActiveObject();
      c.requestRenderAll();
      state.restoring = false;
      onSelection();
      updatePrice();
    });
  }

  function undo() {
    const h = state.history[state.side];
    if (h.length < 2) return;
    state.future[state.side].push(h.pop());
    restore(h[h.length - 1]);
  }

  function redo() {
    const f = state.future[state.side];
    if (!f.length) return;
    const json = f.pop();
    state.history[state.side].push(json);
    restore(json);
  }

  /* ---------- Images : retrait automatique du fond ---------- */
  // Image d'origine de chaque élément (pour changer de mode de fond sans perte).
  const originaux = new Map();

  /* Analyse le fond : déjà transparent, fond uni (couleur dominante du pourtour) ou fond complexe (photo). */
  function analyseFond(src) {
    const max = 16000000; // limite des navigateurs mobiles
    const k = Math.min(1, Math.sqrt(max / (src.naturalWidth * src.naturalHeight)));
    const w = Math.round(src.naturalWidth * k); const h = Math.round(src.naturalHeight * k);
    const el = document.createElement('canvas');
    el.width = w; el.height = h;
    const ctx = el.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(src, 0, 0, w, h);
    const id = ctx.getImageData(0, 0, w, h);
    const d = id.data;
    const bord = [];
    for (let x = 0; x < w; x++) bord.push(x, (h - 1) * w + x);
    for (let y = 1; y < h - 1; y++) bord.push(y * w, y * w + w - 1);
    const transparents = bord.filter((p) => d[p * 4 + 3] < 250).length;
    if (transparents > bord.length * 0.05) return { el, ctx, id, type: 'transparent' };
    // Couleur du fond : médiane du pourtour, puis part du pourtour proche de cette couleur.
    const med = [0, 1, 2].map((c) => { const v = bord.map((p) => d[p * 4 + c]).sort((a, b) => a - b); return v[v.length >> 1]; });
    const proches = bord.filter((p) => ecart(d, p * 4, med) <= TOL).length;
    // Couleurs principales (pour « Couleur à retirer ») : la couleur du pourtour d'abord, puis les plus présentes.
    const comptes = new Map();
    const pasC = Math.max(1, Math.floor(Math.sqrt(w * h / 120000))) * 4;
    for (let i = 0; i < d.length; i += pasC) {
      if (d[i + 3] < 128) continue;
      const key = ((d[i] >> 5) << 6) | ((d[i + 1] >> 5) << 3) | (d[i + 2] >> 5);
      const e = comptes.get(key) || { n: 0, r: 0, g: 0, b: 0 };
      e.n++; e.r += d[i]; e.g += d[i + 1]; e.b += d[i + 2];
      comptes.set(key, e);
    }
    const palette = [med];
    [...comptes.values()].sort((x, y) => y.n - x.n).forEach((e) => {
      const c = [Math.round(e.r / e.n), Math.round(e.g / e.n), Math.round(e.b / e.n)];
      if (palette.length < 6 && palette.every((p) => Math.max(...[0, 1, 2].map((k) => Math.abs(p[k] - c[k]))) > 48)) palette.push(c);
    });
    // B2 (lot 30) : la couleur du fond est-elle présente DANS le sujet (noir sur noir, robe blanche sur fond blanc) ? Boîte du
    // sujet (pixels loin du fond) érodée de 10 %, part des pixels proches du fond à l'intérieur ; au-delà de 2 %, un retrait n'est
    // jamais « propre » (douteux d'office, damier mis en avant). Sans objet pour un logo (les blancs des lettres sont normaux).
    let fondDansSujet = false; {
      const pasB = Math.max(1, Math.floor(Math.sqrt(w * h / 250000))); let x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (let y = 0; y < h; y += pasB) for (let x = 0; x < w; x += pasB) { const i = (y * w + x) * 4; if (d[i + 3] >= 128 && ecart(d, i, med) > TOL) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
      if (x1 > x0 && y1 > y0) { const mx = Math.round((x1 - x0) * 0.1); const my = Math.round((y1 - y0) * 0.1); let dedans = 0; let prochesDedans = 0;
        for (let y = y0 + my; y <= y1 - my; y += pasB) for (let x = x0 + mx; x <= x1 - mx; x += pasB) { const i = (y * w + x) * 4; if (d[i + 3] < 128) continue; dedans++; if (ecart(d, i, med) <= TOL) prochesDedans++; }
        fondDansSujet = dedans > 0 && prochesDedans / dedans > 0.02; }
    }
    if (proches <= bord.length * 0.6) return { el, ctx, id, type: 'photo', fond: med, palette, fondDansSujet };
    // Logo (peu de couleurs) : le fond est retiré partout, y compris dans les lettres.
    // Dessin ou photo détourée sur fond uni : seulement autour, pour garder les blancs du sujet.
    const bins = new Map();
    let total = 0;
    const pas = Math.max(1, Math.floor(Math.sqrt(w * h / 250000))) * 4;
    for (let i = 0; i < d.length; i += pas) {
      if (ecart(d, i, med) <= TOL) continue;
      const key = ((d[i] >> 4) << 8) | ((d[i + 1] >> 4) << 4) | (d[i + 2] >> 4);
      bins.set(key, (bins.get(key) || 0) + 1);
      total++;
    }
    const principales = [...bins.values()].sort((a, b) => b - a).slice(0, 8).reduce((a, b) => a + b, 0);
    return { el, ctx, id, type: 'uni', fond: med, palette, fondDansSujet, logo: total > 0 && principales >= total * 0.85 };
  }

  const TOL = 42; // écart toléré avec la couleur du fond (bruit JPEG)
  const ecart = (d, i, c) => Math.max(Math.abs(d[i] - c[0]), Math.abs(d[i + 1] - c[1]), Math.abs(d[i + 2] - c[2]));

  /* Retire le fond uni : « contour » = la partie reliée aux bords (garde l'intérieur, ex. les yeux d'un dessin),
     « partout » = toute la couleur du fond (ex. l'intérieur des lettres d'un logo). Bords adoucis. */
  // tol : intensité du retrait (curseur « Intensité du retrait ») ; plus bas = garde les couleurs proches du fond.
  // Masque du fond (1 = pixel retiré) : « partout » = toute la couleur ; sinon remplissage depuis les bords.
  function masqueFond(a, mode, tol = TOL, fond = a.fond) {
    const { el, id } = a; const w = el.width; const h = el.height; const src = id.data; const n = w * h;
    const fondMask = new Uint8Array(n);
    if (mode === 'partout') {
      for (let p = 0; p < n; p++) if (ecart(src, p * 4, fond) <= tol) fondMask[p] = 1;
    } else {
      const pile = new Int32Array(n);
      let top = 0;
      const pousser = (p) => { if (!fondMask[p] && ecart(src, p * 4, fond) <= tol) { fondMask[p] = 1; pile[top++] = p; } };
      for (let x = 0; x < w; x++) { pousser(x); pousser((h - 1) * w + x); }
      for (let y = 0; y < h; y++) { pousser(y * w); pousser(y * w + w - 1); }
      while (top) {
        const p = pile[--top]; const x = p % w;
        if (x > 0) pousser(p - 1);
        if (x < w - 1) pousser(p + 1);
        if (p >= w) pousser(p - w);
        if (p < n - w) pousser(p + w);
      }
    }
    return fondMask;
  }
  // Le fond retiré mord-il dans le sujet ? Part du quart central (25 à 75 % en x et y) classée « fond » (bug #1689 :
  // robe blanche reliée au fond blanc). Au-delà de 3 %, le mode automatique garde le fond.
  function fondMordLeCentre(a, tol = TOL) {
    const w = a.el.width; const h = a.el.height; const m = masqueFond(a, 'contour', tol, a.fond); const d = a.id.data;
    /* Lot 30 : fenêtre = moitié centrale de la boîte du VISUEL (pixels loin du fond), pas de l'image : un logo rond, un écusson ou
       un logo avec des marges n'est plus gardé à tort. Mordu = plus de la moitié de cette fenêtre partirait (vêtement blanc sur fond blanc). */
    let x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (let y = 0; y < h; y += 2) for (let x = 0; x < w; x += 2) { const i = (y * w + x) * 4; if (d[i + 3] >= 128 && ecart(d, i, a.fond) > tol) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
    if (x1 - x0 < 4 || y1 - y0 < 4) return false;
    const mx = (x1 - x0) >> 2; const my = (y1 - y0) >> 2; let n = 0; let total = 0;
    for (let y = y0 + my; y <= y1 - my; y += 2) for (let x = x0 + mx; x <= x1 - mx; x += 2) { total++; if (m[y * w + x]) n++; }
    return total > 0 && n / total > 0.5;
  }
  function retirerFond(a, mode, tol = TOL, fond = a.fond) {
    const { el, id } = a;
    const w = el.width; const h = el.height;
    const src = id.data;
    const out = new ImageData(new Uint8ClampedArray(src), w, h);
    const d = out.data;
    const n = w * h;
    const fondMask = masqueFond(a, mode, tol, fond);
    for (let p = 0; p < n; p++) {
      if (fondMask[p]) { d[p * 4 + 3] = 0; continue; }
      // Bord adouci : un pixel voisin du fond et encore proche de sa couleur devient semi-transparent.
      const x = p % w;
      const voisin = (x > 0 && fondMask[p - 1]) || (x < w - 1 && fondMask[p + 1]) || (p >= w && fondMask[p - w]) || (p < n - w && fondMask[p + w]);
      if (voisin) {
        const e = ecart(src, p * 4, fond);
        if (e < tol * 2.5) d[p * 4 + 3] = Math.round(d[p * 4 + 3] * (e - tol) / (tol * 1.5));
      }
    }
    return out;
  }

  // Image traitée selon le mode, recadrée au plus près de ce qui reste visible.
  /* Détourage IA (idée 4, accord de Karim le 17/10/2026) : modèle U2-Net léger (u2netp, licence Apache 2.0) hébergé
     dans Shopify Fichiers, exécuté dans le navigateur par onnxruntime-web (MIT), chargés seulement au 1er clic sur
     « Détourer la photo ». Aucune image n'est envoyée à un serveur. */
  const MODELE_DETOURAGE = data.detourage || 'https://cdn.shopify.com/s/files/1/0833/8459/8874/files/u2netp.onnx?v=1792211081';
  const ORT = 'https://cdn.jsdelivr.net/npm/onnxruntime-web@1.17.3/dist/';
  let sessionIA = null;
  function chargerIA() {
    sessionIA ??= (async () => {
      if (!window.ort) await new Promise((ok, ko) => { const s = document.createElement('script'); s.src = ORT + 'ort.wasm.min.js'; s.onload = ok; s.onerror = ko; document.head.appendChild(s); });
      window.ort.env.wasm.wasmPaths = ORT;
      window.ort.env.wasm.numThreads = 1;
      return window.ort.InferenceSession.create(MODELE_DETOURAGE, { executionProviders: ['wasm'] });
    })().catch((e) => { sessionIA = null; throw e; });
    return sessionIA;
  }
  async function masqueIA(a) {
    if (a.masqueIA) return a.masqueIA;
    const S = 320;
    const c = document.createElement('canvas'); c.width = S; c.height = S;
    const x = c.getContext('2d'); x.drawImage(a.el, 0, 0, S, S);
    const d = x.getImageData(0, 0, S, S).data;
    const MOY = [0.485, 0.456, 0.406]; const ET = [0.229, 0.224, 0.225];
    let mx = 1; for (let i = 0; i < d.length; i += 4) mx = Math.max(mx, d[i], d[i + 1], d[i + 2]);
    const t = new Float32Array(3 * S * S);
    for (let p = 0; p < S * S; p++) for (let k = 0; k < 3; k++) t[k * S * S + p] = (d[p * 4 + k] / mx - MOY[k]) / ET[k];
    const s = await chargerIA();
    const sortie = await s.run({ [s.inputNames[0]]: new window.ort.Tensor('float32', t, [1, 3, S, S]) });
    const m = sortie[s.outputNames[0]].data;
    let mn = Infinity; let mm = -Infinity;
    for (let i = 0; i < m.length; i++) { if (m[i] < mn) mn = m[i]; if (m[i] > mm) mm = m[i]; }
    const mc = document.createElement('canvas'); mc.width = S; mc.height = S;
    const mx2 = mc.getContext('2d'); const md = mx2.createImageData(S, S);
    for (let p = 0; p < S * S; p++) { md.data[p * 4 + 3] = Math.round((255 * (m[p] - mn)) / (mm - mn || 1)); }
    mx2.putImageData(md, 0, 0);
    const big = document.createElement('canvas'); big.width = a.el.width; big.height = a.el.height;
    const bx = big.getContext('2d'); bx.imageSmoothingQuality = 'high'; bx.drawImage(mc, 0, 0, big.width, big.height);
    a.masqueIA = bx.getImageData(0, 0, big.width, big.height).data;
    return a.masqueIA;
  }
  function pixelsDetoures(a) {
    const out = new ImageData(new Uint8ClampedArray(a.id.data), a.id.width, a.id.height);
    const m = a.masqueIA;
    // Bords nets : en dessous de 20 % = fond, au-dessus de 60 % = sujet, fondu entre les deux.
    for (let p = 0; p < out.data.length; p += 4) {
      const v = m[p + 3] / 255; const al = v < 0.2 ? 0 : v > 0.6 ? 1 : (v - 0.2) / 0.4;
      out.data[p + 3] = Math.round(out.data[p + 3] * al);
    }
    return out;
  }

  function pixelsTraites(a, mode, tol, couleur) {
    return mode === 'detoure' && a.masqueIA ? pixelsDetoures(a)
      : mode === 'garder' || !a.fond ? a.id : retirerFond(a, mode, tol, couleur || a.fond);
  }
  /* Lot 30 (A1, B1, B2) : contrôle après tout retrait, sur une copie ≤ 0,8 Mpx.
     - retrait par couleur : morsure = part des pixels retirés qui ne ressemblaient PAS à la couleur retirée (écart > 1,5 × tol) ;
       un fond uni bien retiré donne ≈ 0 %, une jambe ou des cheveux mangés bien plus (la mesure ne rétrécit pas avec le sujet) ;
       trous = zones transparentes non reliées au bord (hors « partout » et logos : les lettres sont des trous voulus) ;
     - IA : part des pixels retirés avec une faible certitude (masque entre 5 et 20 %) rapportée au sujet ; jamais « raté » ;
     - fond ≈ sujet (B2, reconnu à l'import) : jamais « propre ».
     Verdict : propre / douteux (affiché + avertissement) / rate (image gardée entière + explication). */
  function controleRetrait(a, mode, tol, couleur) {
    const pixels = pixelsTraites(a, mode, tol, couleur);
    const S = 800; const w0 = pixels.width; const h0 = pixels.height; const k = Math.min(1, S / Math.max(w0, h0));
    const w = Math.max(1, Math.round(w0 * k)); const h = Math.max(1, Math.round(h0 * k)); const n = w * h;
    const petit = (src) => { const c = document.createElement('canvas'); c.width = w; c.height = h; const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(src, 0, 0, w, h); return x.getImageData(0, 0, w, h).data; };
    const tmp = document.createElement('canvas'); tmp.width = w0; tmp.height = h0; tmp.getContext('2d').putImageData(pixels, 0, 0);
    const o = petit(a.el); const r = petit(tmp);
    const m = { mode, morsure: 0, trous: 0, incertains: 0, fondDansSujet: !!a.fondDansSujet && !a.logo && mode !== 'detoure' };
    let verdict = 'propre'; let raison = '';
    if (mode === 'detoure' && a.masqueIA) {
      let sujet = 0; let incertains = 0; const mk = a.masqueIA; const W0 = a.el.width;
      for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) { const i = (Math.round(y / k) * W0 + Math.round(x / k)) * 4 + 3; const v = (mk[i] ?? 0) / 255; if (v >= 0.6) sujet++; else if (v >= 0.05 && v < 0.2) incertains++; }
      m.incertains = sujet ? Math.round((incertains / sujet) * 1000) / 10 : 0;
      if (m.incertains > 8) { verdict = 'douteux'; raison = ptxT("le contour est incertain par endroits (cheveux, ombres)"); }
    } else {
      const ref = couleur || a.fond || [255, 255, 255]; const seuil = Math.max(24, tol * 1.5);
      let sujet = 0; let retiresLoin = 0;
      for (let p = 0; p < n; p++) { const i = p * 4; if (o[i + 3] < 128) continue; const loin = ecart(o, i, ref) > seuil; if (loin) sujet++; if (r[i + 3] < 128 && loin) retiresLoin++; }
      m.morsure = sujet ? Math.round((retiresLoin / sujet) * 1000) / 10 : 0;
      if (mode !== 'partout' && !a.logo) {
        const vu = new Uint8Array(n); const pile = []; const pousser = (p) => { if (!vu[p] && r[p * 4 + 3] < 128) { vu[p] = 1; pile.push(p); } };
        for (let x = 0; x < w; x++) { pousser(x); pousser((h - 1) * w + x); } for (let y = 0; y < h; y++) { pousser(y * w); pousser(y * w + w - 1); }
        while (pile.length) { const p = pile.pop(); const x = p % w; if (x > 0) pousser(p - 1); if (x < w - 1) pousser(p + 1); if (p >= w) pousser(p - w); if (p < n - w) pousser(p + w); }
        let trous = 0; for (let p = 0; p < n; p++) if (r[p * 4 + 3] < 128 && !vu[p]) trous++; m.trous = Math.round((trous / n) * 1000) / 10;
      }
      if (m.morsure > 3) { verdict = 'rate'; raison = `${ptxT("le retrait abîmait votre image")} (${String(m.morsure).replace('.', ',')} % ${ptxT("du sujet")})`; }
      else if (m.morsure > 1) { verdict = 'douteux'; raison = `${ptxT("une partie de votre image part avec le fond")} (${String(m.morsure).replace('.', ',')} %)`; }
      else if (m.trous > 1) { verdict = 'douteux'; raison = ptxT("des trous apparaissent dans votre image"); }
    }
    if (verdict === 'propre' && m.fondDansSujet) { verdict = 'douteux'; raison = ptxT("le fond a la couleur de parties de votre image"); }
    return { verdict, raison, mesures: m, demande: mode };
  }
  /* Lot 30 (B2) : contre-contrôle par le masque IA après un retrait par couleur sur une photo à fond uni : part du sujet
     (masque ≥ 60 %) retirée. > 3 % → raté (image gardée entière) ; 1 à 3 % → douteux. Asynchrone : le verdict se met à jour
     dès que l'IA a répondu ; sans IA (réseau, appareil), le verdict couleur reste seul. */
  async function verifierParIA(obj, a, mode, tol, couleur) {
    try {
      const m = await masqueIA(a);
      if (obj.ppFond !== mode || !Object.values(state.canvases).some((cv) => cv.getObjects().includes(obj))) return; // le client a changé d'avis entre-temps
      const pixels = pixelsTraites(a, mode, tol, couleur); const W = a.el.width; const H = a.el.height; const pas = Math.max(1, Math.floor(Math.sqrt((W * H) / 400000)));
      let sujet = 0; let manges = 0;
      for (let y = 0; y < H; y += pas) for (let x = 0; x < W; x += pas) { const i = (y * W + x) * 4; if (m[i + 3] / 255 < 0.6) continue; sujet++; if (pixels.data[i + 3] < 128 && a.id.data[i + 3] >= 128) manges++; }
      const pct = sujet ? Math.round((manges / sujet) * 1000) / 10 : 0;
      const c = obj.ppControle || { verdict: 'propre', raison: '', mesures: { mode }, demande: mode }; c.mesures.morsureIA = pct;
      if (pct > 3) {
        c.verdict = 'rate'; c.raison = `${ptxT("le retrait mangeait une partie du sujet")} (${String(pct).replace('.', ',')} %)`;
        setFond(obj, 'garder', tol, couleur, false); obj.ppControle = c; onSelection(); // « garder » efface le contrôle : on le remet pour la note
      } else if (pct > 1 && c.verdict === 'propre') { c.verdict = 'douteux'; c.raison = `${ptxT("une partie du sujet part avec le fond")} (${String(pct).replace('.', ',')} %)`; obj.ppControle = c; onSelection(); }
    } catch (e) { console.warn('contre-contrôle IA indisponible :', e && e.message); } // verdict couleur seul
  }
  function imageTraitee(a, mode, tol, couleur) {
    const pixels = pixelsTraites(a, mode, tol, couleur);
    const tmp = document.createElement('canvas');
    tmp.width = a.el.width; tmp.height = a.el.height;
    tmp.getContext('2d').putImageData(pixels, 0, 0);
    return trimTransparent(tmp).el;
  }

  // auto = choix fait par l'outil (réexaminé si le client change la couleur du vêtement) ; sinon choix du client, gardé.
  function setFond(obj, mode, tol = obj.ppTol ?? TOL, couleur = obj.ppCouleur, auto = false) {
    const a = originaux.get(obj.ppId);
    if (!a) return;
    const centre = obj.getCenterPoint();
    // Lot 30 : tout retrait est contrôlé ; raté → l'image reste entière (le client lit pourquoi) ; douteux → affiché avec avertissement.
    let modeFinal = mode; let controle = null;
    if (mode !== 'garder' && (a.fond || (mode === 'detoure' && a.masqueIA))) {
      try { controle = controleRetrait(a, mode, tol, couleur); } catch (e) { controle = null; }
      if (controle && controle.verdict === 'rate') { modeFinal = 'garder'; if (auto) controle = null; }
    }
    obj.ppControle = controle;
    obj.setElement(imageTraitee(a, modeFinal, tol, couleur));
    obj.ppFond = modeFinal;
    if (!auto && modeFinal !== 'garder' && modeFinal !== 'detoure' && a.type === 'uni' && !a.logo) verifierParIA(obj, a, modeFinal, tol, couleur); // photo à fond uni : l'IA voit ce que les couleurs ne voient pas
    obj.ppTol = tol;
    obj.ppCouleur = couleur;
    obj.ppFondAuto = auto;
    obj.setPositionByOrigin(centre, 'center', 'center');
    fitInZone(obj);
    obj.dirty = true; // redessin de l'image et cadre recalculé quand sa taille change
    obj.setCoords();
    canvas().requestRenderAll();
    snapshot();
    onSelection();
  }

  // Couleur du vêtement choisi (rgb), tenue à jour au changement de couleur.
  let rgbVetement = null;
  const procheVetement = (c) => !!(c && rgbVetement) && Math.max(...[0, 1, 2].map((k) => Math.abs(c[k] - rgbVetement[k]))) <= 60;
  // Fond retiré d'office seulement s'il a presque la couleur du vêtement ET qu'il ne mord pas dans le sujet (#1689).
  const modeAuto = (a) => { if (a.type !== 'uni' || !a.logo || !procheVetement(a.fond)) return 'garder'; /* Karim 23/10 (#1681) : retrait d'office seulement pour un dessin / logo à fond uni, jamais pour une photo */ if (a.mordCentre === undefined) a.mordCentre = fondMordLeCentre(a); return a.mordCentre ? 'garder' : 'contour'; };
  const hexDe = (c) => '#' + c.map((x) => x.toString(16).padStart(2, '0')).join('');
  function majVetement() {
    if (!state.variant) return;
    targetColor(state.variant).then((rgb) => {
      rgbVetement = rgb;
      // Images dont le fond a été choisi par l'outil : nouveau choix selon le nouveau vêtement.
      Object.values(state.canvases).forEach((c) => c.getObjects().forEach((o) => {
        const a = o.ppType === 'image' && o.ppFondAuto !== false ? originaux.get(o.ppId) : null;
        if (a && modeAuto(a) !== o.ppFond) {
          const cv = canvas();
          state.restoring = true;
          const centre = o.getCenterPoint();
          // Même taille à l'écran (et en cm) qu'avant : changer la couleur du vêtement ne doit pas agrandir le visuel.
          const cote = Math.max(o.getScaledWidth(), o.getScaledHeight());
          o.setElement(imageTraitee(a, modeAuto(a), o.ppTol ?? TOL, o.ppCouleur));
          o.scale(cote / Math.max(o.width, o.height));
          o.ppFond = modeAuto(a);
          o.setPositionByOrigin(centre, 'center', 'center');
          o.dirty = true; o.setCoords();
          state.restoring = false;
          c.requestRenderAll();
          if (c === cv) onSelection();
        }
      }));
      onSelection();
    });
  }

  function majLogoRefait() {
    const l = $('[data-pp-logo-refait]'); if (!l || !data.optionLogo) return;
    const images = Object.values(state.canvases).flatMap((c) => c.getObjects().filter((o) => o.ppType === 'image'));
    l.hidden = !images.length;
    const faible = images.some((o) => o.width / ((o.getScaledWidth() * zoneOf(state.side).cmW / LOGICAL_W) / 2.54) < 150);
    l.classList.toggle('is-conseille', faible && !state.logoRefait);
    const p = l.querySelector('[data-pp-logo-refait-prix]'); if (p) p.textContent = totalQty() >= 5 ? ptxT("offert (5 pièces et plus)") : '+5 €';
  }
  function refreshFond(obj) {
    majLogoRefait();
    const box = $('[data-pp-fond]');
    const a = obj && obj.ppType === 'image' ? originaux.get(obj.ppId) : null;
    box.hidden = !a;
    if (!a) return;
    $$('[data-pp-fond-mode]').forEach((b) => {
      b.classList.toggle('is-active', b.dataset.ppFondMode === obj.ppFond);
      b.disabled = !a.fond;
    });
    const detour = $('[data-pp-detourer]');
    if (detour) {
      detour.hidden = !(a.type === 'photo' || (a.type === 'uni' && !a.logo)) && obj.ppFond !== 'detoure'; // photos (fond non uni) et photos à fond uni (personne en studio : l'IA d'abord, règle § 4)
      detour.classList.toggle('is-active', obj.ppFond === 'detoure');
    }
    // Couleur à retirer : pastilles des couleurs principales de l'image.
    const pal = $('[data-pp-fond-couleurs]');
    if (pal) {
      const choisie = obj.ppCouleur || a.fond;
      pal.hidden = !a.palette || obj.ppFond === 'garder' || obj.ppFond === 'detoure';
      pal.querySelector('[data-pp-fond-pastilles]').innerHTML = (a.palette || []).map((c, i) => `<button type="button" class="pp-fond__pastille${c.join() === (choisie || []).join() ? ' is-active' : ''}" data-pp-fond-couleur="${i}" style="background:${hexDe(c)}" aria-label="Retirer cette couleur${i ? '' : ` ${ptxT("(bord de l'image)")}`}" title="${i ? ptxT("Retirer cette couleur") : ptxT("Couleur du bord de l'image")}"></button>`).join('');
    }
    // Curseur d'intensité : seulement quand un fond uni est retiré.
    const intensite = $('[data-pp-intensite]');
    if (intensite) {
      intensite.hidden = !a.fond || obj.ppFond === 'garder' || obj.ppFond === 'detoure';
      $('[data-pp-intensite-curseur]').value = obj.ppTol ?? TOL;
    }
    const vet = couleurOf(state.variant) ? couleurOf(state.variant).toLowerCase() : ptxT("vêtement");
    const conseil = a.type === 'uni' && obj.ppFond === 'garder' && a.mordCentre && obj.ppFondAuto !== false ? ptxT("Fond gardé : la couleur du fond est aussi dans votre visuel (par exemple un vêtement blanc sur fond blanc). Pour le retirer quand même, choisissez « Retirer le fond ».")
      : a.type === 'uni' && !a.logo && obj.ppFond === 'garder' && procheVetement(a.fond) ? ptxT("Le fond de votre photo a la couleur du vêtement : il ne se verra pas, vous pouvez le garder.")
      : a.type === 'uni' && obj.ppFond === 'garder' && !procheVetement(a.fond)
      ? `${ptxT("Le fond de votre image n'a pas la couleur du vêtement (")}${vet}${ptxT(") : il sera imprimé comme un rectangle. Choisissez « Retirer le fond » pour ne garder que le dessin.")}`
      : a.type === 'uni' && obj.ppFondAuto !== false && obj.ppFond !== 'garder' ? `${ptxT("Fond retiré automatiquement : il a presque la couleur du vêtement (")}${vet}).` : '';
    // Lot 30 (A2) : « Avant » et « Ce qui sera imprimé » sur damier (fond CSS, jamais un objet du canevas) : un trou de la couleur du
    // vêtement se voit ; puis le verdict du contrôle, prioritaire sur les autres notes.
    const ctrl = obj.ppControle; const infoEl = $('[data-pp-fond-info]'); const apercus = $('[data-pp-fond-apercus]');
    if (apercus) {
      const montrer = obj.ppFond !== 'garder' || !!ctrl; apercus.hidden = !montrer;
      if (montrer) {
        apercus.innerHTML = `<figure><canvas width="96" height="96"></canvas><figcaption>${ptxT("Avant")}</figcaption></figure><figure><span class="pp-damier"><canvas width="96" height="96"></canvas></span><figcaption>${ptxT("Ce qui sera imprimé")}</figcaption></figure>`;
        const [c1, c2] = apercus.querySelectorAll('canvas');
        const dessiner = (cv, src) => { if (!src) return; const x = cv.getContext('2d'); const k = Math.min(cv.width / src.width, cv.height / src.height); const w = src.width * k; const h = src.height * k; x.clearRect(0, 0, cv.width, cv.height); x.drawImage(src, (cv.width - w) / 2, (cv.height - h) / 2, w, h); };
        dessiner(c1, a.el); dessiner(c2, obj.getElement());
      }
    }
    if (ctrl && ctrl.verdict !== 'propre') {
      infoEl.textContent = ctrl.verdict === 'rate' ? `${ptxT("Retrait annulé :")} ${ctrl.raison}. ${ptxT("Votre image est gardée entière ; le fond sera imprimé.")}` : `${ptxT("À vérifier sur le damier :")} ${ctrl.raison}.`;
      infoEl.classList.add('pp-note--alerte'); return;
    }
    infoEl.classList.remove('pp-note--alerte');
    if (obj.ppFond === 'detoure') { $('[data-pp-fond-info]').textContent = ptxT("Photo détourée : vérifiez les bords dans l'aperçu. Pas satisfait ? Choisissez « Garder » ou « Retirer le fond »."); return; }
    $('[data-pp-fond-info]').textContent = conseil || {
      transparent: ptxT("Image déjà détourée : seul le visuel sera imprimé."),
      photo: obj.ppFond === 'garder' ? ptxT("Photo : son fond sera imprimé. Pour retirer une couleur, choisissez « Retirer le fond » puis la couleur.") : ptxT("La couleur choisie est retirée de la photo."),
      uni: obj.ppFond === 'garder' ? ptxT("Le fond sera imprimé (rectangle visible sur le vêtement).")
        : obj.ppFond === 'partout' ? ptxT("Toute la couleur du fond est retirée, y compris à l'intérieur du visuel (lettres, contours fermés).")
          : ptxT("Fond retiré autour du visuel (les blancs à l'intérieur sont gardés). S'il en reste dans les lettres, choisissez « Retirer partout »."),
    }[a.type];
  }

  /* Lot 30 : fichiers des clients (Karim : « qu'ils puissent mettre leurs fichiers sans encombre »). Genres : image (PNG, JPG,
     WebP, GIF 1re image, BMP, AVIF : natifs), svg (rendu à 2 400 px), pdf (PDF et AI compatibles PDF : 1re page rendue avec
     pdf.js, chargé au dépôt), heic (converti par heic2any, chargé au dépôt), refuse (EPS, Photoshop, TIFF). Plus de limite de
     poids : l'image est réduite par analyseFond. Même liste pour le bouton et le glisser-déposer. */
  const MESSAGE_FORMAT = ptxT("Ce format ne s'ouvre pas ici. Enregistrez votre fichier en PDF, PNG ou JPG puis déposez-le à nouveau. Besoin d'aide : 01 86 04 31 65 ou info@printtex.fr");
  function genreFichier(file) {
    const nom = (file.name || '').toLowerCase(); const type = (file.type || '').toLowerCase(); const ext = (nom.match(/\.([a-z0-9]+)$/) || [, ''])[1];
    if (/postscript|photoshop|tiff/.test(type) || ['eps', 'psd', 'tif', 'tiff', 'indd', 'cdr'].includes(ext)) return 'refuse';
    if (type === 'image/svg+xml' || ext === 'svg') return 'svg';
    if (type === 'application/pdf' || type === 'application/illustrator' || ['pdf', 'ai'].includes(ext)) return 'pdf';
    if (/heic|heif/.test(type) || ['heic', 'heif'].includes(ext)) return 'heic';
    if (type.startsWith('image/') || ['png', 'jpg', 'jpeg', 'webp', 'gif', 'bmp', 'avif', 'jfif'].includes(ext)) return 'image';
    return type ? 'refuse' : 'image'; // type inconnu : on essaie, l'erreur de lecture donnera le message
  }
  // Canvas → fichier PNG qui garde l'original du client (déposé tel quel à la commande).
  const canvasEnFichier = (cv, file) => new Promise((ok, ko) => cv.toBlob((bl) => { if (!bl) { ko(new Error('rendu vide')); return; } const f = new File([bl], file.name.replace(/\.[a-z0-9]+$/i, '') + '.png', { type: 'image/png' }); f.original = file.original || file; ok(f); }, 'image/png'));
  async function ouvrirSvg(file) {
    const texte = await file.text(); const doc = new DOMParser().parseFromString(texte, 'image/svg+xml'); const svg = doc.documentElement;
    if (!svg || svg.nodeName.toLowerCase() !== 'svg' || doc.querySelector('parsererror')) throw new Error('svg illisible');
    const vb = (svg.getAttribute('viewBox') || '').split(/[\s,]+/).map(Number).filter((n) => !Number.isNaN(n));
    let w = parseFloat(svg.getAttribute('width')) || 0; let h = parseFloat(svg.getAttribute('height')) || 0;
    if ((!w || !h) && vb.length === 4) { w = vb[2]; h = vb[3]; } if (!w || !h) { w = 1000; h = 1000; }
    if (vb.length !== 4) svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
    const cible = 2400; const k = cible / Math.max(w, h); const W = Math.max(1, Math.round(w * k)); const H = Math.max(1, Math.round(h * k));
    svg.setAttribute('width', W); svg.setAttribute('height', H);
    const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' }));
    try { const im = await new Promise((ok, ko) => { const i = new Image(); i.onload = () => ok(i); i.onerror = () => ko(new Error('svg non rendu')); i.src = url; }); const cv = document.createElement('canvas'); cv.width = W; cv.height = H; cv.getContext('2d').drawImage(im, 0, 0, W, H); return await canvasEnFichier(cv, file); }
    finally { URL.revokeObjectURL(url); }
  }
  let pdfjsP = null;
  async function ouvrirPdf(file) {
    const tete = new TextDecoder().decode(new Uint8Array(await file.slice(0, 1024).arrayBuffer()));
    if (!tete.includes('%PDF-')) throw new Error('pas un PDF'); // AI non compatible PDF, EPS renommé, fichier abîmé
    pdfjsP ??= import(data.pdfjsUrl).then((m) => { m.GlobalWorkerOptions.workerSrc = data.pdfjsWorkerUrl; return m; }).catch((e) => { pdfjsP = null; throw e; });
    const pdfjs = await pdfjsP;
    const doc = await pdfjs.getDocument({ data: new Uint8Array(await file.arrayBuffer()), isEvalSupported: false }).promise;
    const page = await doc.getPage(1); const v1 = page.getViewport({ scale: 1 });
    const k = Math.min(2400 / Math.max(v1.width, v1.height), 8); const vue = page.getViewport({ scale: k });
    const cv = document.createElement('canvas'); cv.width = Math.round(vue.width); cv.height = Math.round(vue.height);
    await page.render({ canvasContext: cv.getContext('2d'), viewport: vue, background: 'rgba(0,0,0,0)' }).promise;
    try { doc.destroy(); } catch (e) { /* rien */ }
    return canvasEnFichier(cv, file);
  }
  let heicP = null;
  async function ouvrirHeic(file) {
    heicP ??= new Promise((ok, ko) => { if (window.heic2any) { ok(window.heic2any); return; } const s = document.createElement('script'); s.src = data.heicUrl; s.onload = () => (window.heic2any ? ok(window.heic2any) : ko(new Error('heic2any absent'))); s.onerror = () => ko(new Error('heic2any non chargé')); document.head.appendChild(s); }).catch((e) => { heicP = null; throw e; });
    const heic2any = await heicP;
    const res = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.92 }); const bl = Array.isArray(res) ? res[0] : res;
    const f = new File([bl], file.name.replace(/\.[a-z0-9]+$/i, '') + '.jpg', { type: 'image/jpeg' }); f.original = file; return f;
  }
  function addImage(file) {
    if (!file) return;
    // Création retrouvée en cours de chargement : l'image attend la fin (sinon le chargement l'effacerait).
    if (state.ready && !state.loaded) { setTimeout(() => addImage(file), 150); return; }
    const genre = genreFichier(file);
    if (genre === 'refuse') { showError(MESSAGE_FORMAT); return; }
    showError('');
    if (genre !== 'image') {
      const conv = genre === 'pdf' ? ouvrirPdf(file) : genre === 'svg' ? ouvrirSvg(file) : ouvrirHeic(file);
      showError(ptxT("Ouverture du fichier…"));
      conv.then((png) => { showError(''); addImage(png); }).catch((e) => { console.warn('fichier non ouvert :', e); showError(MESSAGE_FORMAT); });
      return;
    }
    const url = URL.createObjectURL(file);
    const src = new Image();
    src.onload = () => {
      const a = analyseFond(src);
      a.fichier = file.original || file; // original du client (PDF, SVG, HEIC… tel quel), déposé à la commande (#1689 : ne jamais perdre l'image d'origine)
      URL.revokeObjectURL(url);
      const ppId = `img${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
      originaux.set(ppId, a);
      const mode = modeAuto(a);
      const img = new fabric.Image(imageTraitee(a, mode));
      const c = canvas();
      // Hauteur utile : la zone dessinée, limitée à la hauteur imprimable (40 cm) ; design placé en haut de poitrine.
      const lh = Math.min(logicalH(state.side), hauteurMax(state.side));
      const scale = Math.min((LOGICAL_W * 0.7) / img.width, (lh * 0.7) / img.height);
      img.set({ scaleX: scale, scaleY: scale, left: LOGICAL_W / 2, top: lh / 2, originX: 'center', originY: 'center' });
      img.ppType = 'image';
      img.ppId = ppId;
      img.ppFond = mode;
      img.ppFondAuto = true;
      // « Changer d'image » : la nouvelle prend la place, la taille et l'angle de l'ancienne, qui est retirée.
      const ancienne = state.remplacer; state.remplacer = null;
      if (ancienne && c.getObjects().includes(ancienne)) {
        const cote = Math.max(ancienne.getScaledWidth(), ancienne.getScaledHeight());
        img.scale(cote / Math.max(img.width, img.height));
        img.set({ angle: ancienne.angle });
        img.setPositionByOrigin(ancienne.getCenterPoint(), 'center', 'center');
        c.remove(ancienne);
      }
      c.add(img);
      animerEntree(img); // Karim 23/10 : même entrée fluide que le texte validé
      fitInZone(img);
      zoomAuto();
      c.setActiveObject(img);
      c.requestRenderAll();
      snapshot();
      onSelection();
      updatePrice();
    };
    src.onerror = () => { URL.revokeObjectURL(url); showError(MESSAGE_FORMAT); };
    src.src = url;
  }

  /* ---------- Textes ---------- */
  const textProps = () => ({
    text: T.input.value.trim() ? T.input.value : ptxT("Votre texte"),
    font: state.font,
    fill: T.color.value,
    size: Number(T.size.value),
    curve: Number(T.curve.value),
    spacing: Number(T.spacing.value),
    stroke: T.stroke.value,
    strokeWidth: Number(T.strokeWidth.value),
    bold: T.bold.getAttribute('aria-pressed') === 'true',
    italic: T.italic.getAttribute('aria-pressed') === 'true',
  });

  function textStyle(p) {
    return {
      fontFamily: p.font, fontSize: p.size, fill: p.fill,
      fontWeight: p.bold ? 'bold' : 'normal', fontStyle: p.italic ? 'italic' : 'normal',
      charSpacing: p.spacing * 10,
      stroke: p.strokeWidth > 0 ? p.stroke : null, strokeWidth: p.strokeWidth, paintFirst: 'stroke', strokeLineJoin: 'round',
    };
  }

  // Texte droit (fabric.Text) ou courbé (groupe de lettres placées sur un arc).
  function makeText(p) {
    const style = textStyle(p);
    if (!p.curve) return new fabric.Text(p.text, { ...style, textAlign: 'center', originX: 'center', originY: 'center' });
    const glyphs = [...p.text.replace(/\n/g, ' ')].map((ch) => new fabric.Text(ch, { ...style, charSpacing: 0, originX: 'center', originY: 'center' }));
    const gap = (p.spacing / 100) * p.size;
    const widths = glyphs.map((g) => g.width + gap);
    const total = widths.reduce((a, b) => a + b, 0);
    const R = total / ((Math.abs(p.curve) / 100) * Math.PI * 1.8);
    const up = p.curve > 0 ? 1 : -1;
    let s = -total / 2;
    glyphs.forEach((g, i) => {
      const phi = (s + widths[i] / 2) / R;
      s += widths[i];
      g.set({ left: R * Math.sin(phi), top: up * R * (1 - Math.cos(phi)), angle: up * phi * 180 / Math.PI });
    });
    return new fabric.Group(glyphs, { originX: 'center', originY: 'center' });
  }

  // Garde un élément entièrement dans la zone d'impression : réduit s'il est trop grand, recentre s'il sort.
  /* Règle Karim (15/10/2026) : le design n'est jamais coupé ni hors de la zone. La boîte réelle (rotation comprise)
     est réduite pour tenir dans la zone (marge 2 %), puis recalée contre le bord. Appelé à l'ajout, au déplacement,
     pendant l'agrandissement et la rotation, quand le texte s'allonge et après un placement rapide. */
  const MARGE_ZONE = 1;
  const facteurMax = (obj, side = state.side) => {
    obj.setCoords();
    const r = obj.getBoundingRect(true, true);
    return Math.min((LOGICAL_W * MARGE_ZONE) / r.width, (Math.min(logicalH(side) * MARGE_ZONE, hauteurMax(side)) / r.height));
  };
  function fitInZone(obj, side = state.side, interactif = false) {
    if (interactif && obj.__entree && !obj.__entree.annule) { obj.__entree.annule = true; obj.set({ opacity: 1 }); } // action du client : l'entrée animée s'arrête, elle ne remettra rien
    const W = LOGICAL_W;
    const H = logicalH(side);
    const k = Math.min(1, facteurMax(obj, side));
    if (k < 1) {
      const c = obj.getCenterPoint();
      obj.set({ scaleX: obj.scaleX * k, scaleY: obj.scaleY * k });
      obj.setPositionByOrigin(c, 'center', 'center');
    }
    obj.setCoords();
    const r = obj.getBoundingRect(true, true);
    let dx = 0;
    let dy = 0;
    if (r.left < 0) dx = -r.left; else if (r.left + r.width > W) dx = W - r.left - r.width;
    if (r.top < 0) dy = -r.top; else if (r.top + r.height > H) dy = H - r.top - r.height;
    if (dx || dy) { obj.set({ left: obj.left + dx, top: obj.top + dy }); obj.setCoords(); }
    // Geste du client : le contour (col, couture) avertit sans limiter (Karim 21/10) ; placement automatique : casé dedans.
    if (formesZone[side]) { if (interactif) obj.ppHorsForme = !dansForme(obj, side); else caserForme(obj, side, false); }
  }

  /* Zone « forme » : les 4 coins et des points le long des bords du design (rotation comprise) doivent être dans le
     contour. Pendant un geste (déplacement, agrandissement, rotation), on revient à la dernière position valide ;
     sinon (ajout, placement, texte modifié) on réduit le design, puis on le recentre dans la forme si besoin. */
  const formesZone = {};
  function dansForme(obj, side) {
    const F = formesZone[side];
    if (!F) return true;
    const { f, mirror } = F;
    const H = logicalH(side);
    const bx = mirror ? 1 - f.bx - f.bw : f.bx;
    obj.setCoords();
    const a = obj.aCoords;
    const coins = [a.tl, a.tr, a.br, a.bl];
    for (let i = 0; i < 4; i++) {
      const p = coins[i]; const q = coins[(i + 1) % 4];
      for (let t = 0; t <= 1.0001; t += 0.125) {
        const lx = p.x + (q.x - p.x) * t; const ly = p.y + (q.y - p.y) * t;
        let fx = bx + (lx / LOGICAL_W) * f.bw;
        if (mirror) fx = 1 - fx;
        const fy = f.by + (ly / H) * f.bh;
        if (!window.PrinttexZone.dansMasque(f, fx, fy)) return false;
      }
    }
    return true;
  }
  const etat = (o) => ({ left: o.left, top: o.top, scaleX: o.scaleX, scaleY: o.scaleY, angle: o.angle });
  function caserForme(obj, side, interactif) {
    if (dansForme(obj, side)) { obj.ppOk = etat(obj); return; }
    if (interactif && obj.ppOk) { obj.set(obj.ppOk); obj.setCoords(); return; }
    const F = formesZone[side];
    const H = logicalH(side);
    const bx = F.mirror ? 1 - F.f.bx - F.f.bw : F.f.bx;
    const cxF = F.mirror ? 1 - F.f.cx : F.f.cx;
    const centreForme = new fabric.Point(((cxF - bx) / F.f.bw) * LOGICAL_W, ((F.f.cy - F.f.by) / F.f.bh) * H);
    // 1er essai : sur place, réduit au plus de moitié ; sinon taille d'origine recentrée dans la forme puis réduite.
    const ech = { scaleX: obj.scaleX, scaleY: obj.scaleY };
    // D'abord glisser verticalement (au plus près, vers le bas puis le haut) sans changer la taille : sous un col, etc.
    const p0 = obj.getCenterPoint();
    for (let k = 1; k <= 40 && !dansForme(obj, side); k++) {
      for (const sgn of [1, -1]) {
        obj.setPositionByOrigin(new fabric.Point(p0.x, p0.y + sgn * k * H * 0.015), 'center', 'center');
        obj.setCoords();
        if (dansForme(obj, side)) break;
      }
    }
    if (dansForme(obj, side)) { obj.setCoords(); obj.ppOk = etat(obj); return; }
    obj.setPositionByOrigin(p0, 'center', 'center');
    for (let essai = 0; essai < 2; essai++) {
      if (essai === 1) { obj.set(ech); obj.setPositionByOrigin(centreForme, 'center', 'center'); }
      for (let i = 0; i < (essai ? 30 : 8) && !dansForme(obj, side); i++) {
        const c = obj.getCenterPoint();
        obj.set({ scaleX: obj.scaleX * 0.92, scaleY: obj.scaleY * 0.92 });
        obj.setPositionByOrigin(c, 'center', 'center');
      }
      if (dansForme(obj, side)) break;
    }
    obj.setCoords();
    obj.ppOk = etat(obj);
  }

  async function ensureFont(p) {
    try { await document.fonts.load(`${p.italic ? 'italic ' : ''}${p.bold ? 'bold ' : ''}40px "${p.font}"`); } catch (e) { /* police système */ }
  }

  // Crée un texte (create = true) ou met à jour le texte sélectionné.
  let textJob = Promise.resolve();
  function applyText(create) {
    textJob = textJob.then(async () => {
      const p = textProps();
      await ensureFont(p);
      const c = canvas();
      const cur = c.getActiveObject();
      const obj = makeText(p);
      obj.ppType = 'text';
      obj.ppProps = p;
      if (!create && cur && cur.ppType === 'text') {
        obj.set({ left: cur.left, top: cur.top, angle: cur.angle, scaleX: cur.scaleX, scaleY: cur.scaleY, flipX: cur.flipX });
        const idx = c.getObjects().indexOf(cur);
        state.restoring = true; // un seul point d'historique par modification
        c.remove(cur);
        c.insertAt(obj, idx);
        state.restoring = false;
      } else {
        obj.set({ left: LOGICAL_W / 2, top: logicalH(state.side) * 0.3 });
        c.add(obj);
        zoomAuto();
      }
      fitInZone(obj);
      c.setActiveObject(obj);
      c.requestRenderAll();
      onSelection();
      updatePrice();
    });
    return textJob;
  }

  let historyTimer;
  function textChanged() {
    updateTextLabels();
    if (active()?.ppType === 'text') {
      applyText(false);
      clearTimeout(historyTimer);
      historyTimer = setTimeout(() => snapshot(), 600);
    }
  }

  // « + Ajouter un nouveau texte » : champ vide prêt à taper ; rien n'est posé avant « Valider le texte » (Karim 23/10).
  async function quickText() {
    setTab('texte');
    feuille(true);
    canvas().discardActiveObject(); canvas().requestRenderAll(); onSelection();
    T.input.value = '';
    T.input.placeholder = ptxT("Tapez votre texte…");
    $('[data-pp-ok]')?.classList.remove('is-attente');
    T.input.focus();
  }

  function fillTextControls(p) {
    // Ne pas réécrire le champ pendant que l'on tape (sinon les espaces disparaissent).
    if (document.activeElement !== T.input) T.input.value = p.text === ptxT("Votre texte") ? '' : p.text;
    state.font = p.font;
    T.color.value = p.fill;
    majAnneaux();
    T.size.value = p.size; T.curve.value = p.curve; T.spacing.value = p.spacing;
    T.stroke.value = p.stroke; T.strokeWidth.value = p.strokeWidth;
    T.bold.setAttribute('aria-pressed', p.bold); T.italic.setAttribute('aria-pressed', p.italic);
    $$('[data-pp-font]').forEach((b) => b.classList.toggle('is-active', b.dataset.ppFont === p.font));
    $$('[data-pp-swatch-color]').forEach((b) => b.classList.toggle('is-active', b.dataset.ppSwatchColor === p.fill));
    updateTextLabels();
  }

  function updateTextLabels() {
    const z = zoneOf(state.side);
    $('[data-pp-out="size"]').textContent = `${(Number(T.size.value) * z.cmW / LOGICAL_W).toFixed(1).replace('.', ',')} cm`;
    $('[data-pp-out="curve"]').textContent = T.curve.value === '0' ? 'droit' : T.curve.value;
    $('[data-pp-out="spacing"]').textContent = T.spacing.value;
    $('[data-pp-out="stroke"]').textContent = T.strokeWidth.value === '0' ? 'aucun' : T.strokeWidth.value;
  }

  function buildTextControls() {
    const fonts = $('[data-pp-fonts]');
    [...FONTS, ...SYSTEM_FONTS].forEach((f) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'pp-font' + (f === state.font ? ' is-active' : '');
      b.dataset.ppFont = f;
      b.style.fontFamily = `"${f}"`;
      b.textContent = f;
      b.addEventListener('click', () => {
        state.font = f;
        $$('[data-pp-font]').forEach((x) => x.classList.toggle('is-active', x === b));
        if (active()?.ppType === 'text') textChanged(); else quickText();
      });
      fonts.appendChild(b);
    });
    const colors = $('[data-pp-colors]');
    COLORS.forEach((col) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'pp-color' + (col === '#000000' ? ' is-active' : '');
      b.dataset.ppSwatchColor = col;
      b.style.background = col;
      b.setAttribute('aria-label', `Couleur ${col}`);
      b.addEventListener('click', () => {
        couleurTexteChoisie = true;
        T.color.value = col;
        $$('[data-pp-swatch-color]').forEach((x) => x.classList.toggle('is-active', x === b));
        textChanged();
      });
      colors.appendChild(b);
    });
    loadFonts();
  }

  // Anneau sur la pastille de la couleur réellement appliquée au texte (17/10/2026 : restait sur l'ancienne).
  function majAnneaux() {
    const v = String(T.color.value || '').toLowerCase();
    $$('[data-pp-swatch-color]').forEach((x) => x.classList.toggle('is-active', x.dataset.ppSwatchColor === v));
  }

  function loadFonts() {
    // Styles réellement disponibles chez Google Fonts (une graisse inexistante fait échouer la requête).
    const FULL = ['Montserrat', 'Poppins', 'Roboto', 'Open Sans', 'Lato', 'Raleway', 'Playfair Display', 'Courier Prime'];
    const WEIGHTS = ['Oswald', 'Teko', 'Fredoka', 'Comfortaa', 'Cinzel', 'Orbitron', 'Dancing Script', 'Caveat'];
    const spec = (f) => {
      const n = f.replace(/ /g, '+');
      if (FULL.includes(f)) return `family=${n}:ital,wght@0,400;0,700;1,400;1,700`;
      if (WEIGHTS.includes(f)) return `family=${n}:wght@400;700`;
      return `family=${n}`;
    };
    [FONTS.slice(0, 25), FONTS.slice(25)].forEach((list) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `https://fonts.googleapis.com/css2?${list.map(spec).join('&')}&display=swap`;
      document.head.appendChild(link);
    });
  }

  /* ---------- Sélection et barre flottante ---------- */
  /* Taille du design en cm réels (retour Karim 15/10/2026 : pouvoir faire un petit logo, 5 cm minimum) :
     − / + par pas de 1 cm et curseur, pour l'élément sélectionné ; visible dès qu'un élément est sélectionné. */
  const TAILLE_MIN = 5;
  const taille = document.createElement('div');
  taille.className = 'pp-taille';
  taille.hidden = true;
  taille.innerHTML = `<button type="button" data-taille="-1" aria-label="${ptxT("Plus petit")}">−</button>`
    + `<label><span data-taille-txt></span><input type="range" step="0.5" data-taille-range aria-label="${ptxT("Largeur imprimée en cm")}"></label>`
    + `<button type="button" data-taille="1" aria-label="${ptxT("Plus grand")}">+</button>`;
  stageWrap.appendChild(taille);
  const largeurCm = (o) => o.getScaledWidth() * zoneOf(state.side).cmW / LOGICAL_W;
  const cm = (v) => String(Math.round(v * 10) / 10).replace('.', ','); // 12,5
  // Élément réglé : le sélectionné, sinon le seul élément du côté (plus simple au doigt).
  const cibleTaille = () => active() || (canvas()?.getObjects().length === 1 ? canvas().getObjects()[0] : null);
  function majTaille() {
    const o = cibleTaille();
    taille.hidden = !o;
    if (!o) return;
    const max = zoneOf(state.side).cmW;
    const r = taille.querySelector('[data-taille-range]');
    // Maximum du curseur : la plus grande largeur qui tient entièrement dans la zone (rotation et hauteur comprises).
    const maxTient = Math.max(Math.min(TAILLE_MIN, max), Math.min(max, largeurCm(o) * facteurMax(o)));
    r.min = Math.min(TAILLE_MIN, maxTient); r.max = maxTient; r.value = largeurCm(o);
    taille.querySelector('[data-taille-txt]').textContent = `${cm(largeurCm(o))} cm`;
    // Pastille de qualité (verte / orange / rouge) à côté de la taille : visible aussi sur mobile.
    const dpi = o.ppType === 'image' ? o.width / (largeurCm(o) / 2.54) : 0;
    if (dpi) taille.dataset.qualite = dpi >= 150 ? 'ok' : dpi >= 100 ? 'moyen' : 'faible'; else delete taille.dataset.qualite;
  }
  function setLargeur(cible, enregistrer) {
    const o = cibleTaille();
    if (!o) return;
    const max = zoneOf(state.side).cmW;
    const k = Math.max(Math.min(TAILLE_MIN, max), Math.min(max, cible)) / largeurCm(o);
    const centre = o.getCenterPoint();
    o.set({ scaleX: o.scaleX * k, scaleY: o.scaleY * k });
    o.setPositionByOrigin(centre, 'center', 'center');
    fitInZone(o, state.side, true);
    if (data.jambes) { ancrer(state.side); refreshPos(); } // jogging : reste calé en haut, centré sur la jambe
    canvas().requestRenderAll();
    if (enregistrer) { snapshot(); updatePrice(); }
    onSelection();
  }
  taille.querySelectorAll('[data-taille]').forEach((b) => b.addEventListener('click', () => {
    const o = cibleTaille();
    if (o) setLargeur(Math.round(largeurCm(o)) + Number(b.dataset.taille), true);
  }));
  taille.querySelector('[data-taille-range]').addEventListener('input', (e) => setLargeur(Number(e.target.value), false));
  taille.querySelector('[data-taille-range]').addEventListener('change', () => snapshot());

  function onSelection() {
    { const l = document.querySelector('[data-pp-img-actions]'); const o = active(); if (l) l.hidden = !(o && o.ppType === 'image'); }
    const obj = active();
    majTaille();
    // Variante E : la ligne position + taille n'apparaît que lorsqu'un design est sélectionné (place réservée).
    modal.classList.toggle('pp-sel', !!obj);
    ext.selection.forEach((f) => f(obj));
    const float = $('[data-pp-float]');
    const dims = $('[data-pp-dims]');
    warningEl.hidden = true;
    { const info = $('[data-pp-panel="image"] .pp-rail__alerte'); if (info) info.hidden = true; }
    refreshFond(obj);
    if (!obj) {
      float.hidden = true;
      const z = zoneOf(state.side);
      dims.innerHTML = `${ptxT("Zone d'impression :")} <span data-pp-zone-size>${z.cmW.toLocaleString('fr-FR')} × ${z.cmH.toLocaleString('fr-FR')} ${ptxT("cm max.")}</span>`;
      refreshUi();
      return;
    }
    // Barre d'actions au-dessus de l'élément.
    // Barre d'actions en colonne sur le bord droit de l'aperçu (15/10/2026) : elle ne cache plus le design.
    float.hidden = false;

    const k = zoneOf(state.side).cmW / LOGICAL_W;
    const wCm = obj.getScaledWidth() * k;
    const hCm = obj.getScaledHeight() * k;
    dims.textContent = `${{ image: ptxT("Image"), modele: ptxT("Modèle") }[obj.ppType] || ptxT("Texte")} : ${wCm.toFixed(1).replace('.', ',')} × ${hCm.toFixed(1).replace('.', ',')} ${ptxT("cm imprimés")}${state.etire ? `, ${ptxT("étirement en")} ${state.etire}` : ''}`;
    // Bouton « Proportions d'origine » : seulement quand l'élément est déformé (largeur ou hauteur seule).
    const propor = $('[data-pp-action="propor"]'); if (propor) propor.hidden = Math.abs(obj.scaleX - obj.scaleY) < 0.01;
    if (obj.ppHorsForme) dims.insertAdjacentHTML('beforeend', ` <span class="pp-qualite pp-qualite--moyen">${ptxT("Dépasse le col ou la couture : cette partie ne sera pas imprimée")}</span>`);
    if (obj.ppType === 'image') {
      const dpi = obj.width / (wCm / 2.54);
      // Qualité d'impression toujours affichée pour une image (idée 3, 17/10/2026) : le client sait tout de suite.
      const q = dpi >= 200 ? ['excellente', 'ok'] : dpi >= 150 ? ['bonne', 'ok'] : dpi >= 100 ? ['moyenne', 'moyen'] : [ptxT("trop faible"), 'faible'];
      dims.insertAdjacentHTML('beforeend', ` <span class="pp-qualite pp-qualite--${q[1]}" title="${Math.round(dpi)} ${ptxT("points par pouce à cette taille")}">${ptxT("Qualité :")} ${q[0]}</span>`);
      if (dpi < 150) {
        warningEl.textContent = dpi < 100
          ? `${ptxT("Image petite pour cette taille : l'impression risque d'être floue (nette jusqu'à")} ${((obj.width / 150) * 2.54).toFixed(0)} ${ptxT("cm de large). Vous pouvez continuer, ou choisir une image plus grande (2 000 px de large conseillés).")}`
          : `${ptxT("Image un peu juste pour cette taille : rendu peut-être un peu flou (net jusqu'à")} ${((obj.width / 150) * 2.54).toFixed(0)} ${ptxT("cm de large). Vous pouvez continuer.")}`;
        warningEl.hidden = warningEl.dataset.ferme === warningEl.textContent;
        // Barre en bas : l'avertissement se ferme seul après 5 s et reste lisible dans la carte Image.
        if (modal.classList.contains('pp-bas3')) {
          const info = $('[data-pp-panel="image"] .pp-rail__alerte'); if (info) { info.textContent = warningEl.textContent; info.hidden = false; }
          clearTimeout(warningEl._auto); const txt = warningEl.textContent;
          if (!warningEl.hidden) warningEl._auto = setTimeout(() => { if (warningEl.textContent === txt) { warningEl.dataset.ferme = txt; warningEl.hidden = true; } }, 5000);
        }
      }
      if (state.tab === 'texte') setTab('image');
    }
    if (obj.ppType === 'text') {
      if (obj.ppProps) fillTextControls(obj.ppProps);
      if (state.tab !== 'texte') setTab('texte');
      if (!modal.classList.contains('pp-sheet-open') && !modal.classList.contains('pp-tiroir')) feuille(true); // tiroir : la sélection ne déplace plus le panneau (Karim 23/10)
    }
    refreshUi();
  }

  function action(name) {
    const c = canvas();
    const obj = c.getActiveObject();
    if (!obj) return;
    if (name === 'delete') { c.remove(obj); c.discardActiveObject(); }
    if (name === 'center') obj.set({ originX: 'center', originY: 'center', left: LOGICAL_W / 2 });
    if (name === 'front') c.bringToFront(obj);
    if (name === 'back') c.sendToBack(obj);
    if (name === 'flip') obj.set('flipX', !obj.flipX);
    if (name === 'propor') { const centre = obj.getCenterPoint(); obj.set({ scaleY: obj.scaleX }); obj.setPositionByOrigin(centre, 'center', 'center'); obj.setCoords(); fitInZone(obj, state.side, true); }
    if (name === 'rotl' || name === 'rotr') {
      const centre = obj.getCenterPoint();
      const a = (Math.round(obj.angle / 90) * 90 + (name === 'rotr' ? 90 : -90) + 360) % 360;
      obj.rotate(a);
      obj.setPositionByOrigin(centre, 'center', 'center');
      obj.setCoords();
      fitInZone(obj, state.side, true);
      if (data.jambes) { ancrer(state.side); refreshPos(); }
    }
    if (name === 'duplicate') {
      obj.clone((cl) => {
        cl.ppType = obj.ppType; cl.ppProps = obj.ppProps; cl.ppId = obj.ppId; cl.ppFond = obj.ppFond; cl.ppTol = obj.ppTol; cl.ppCouleur = obj.ppCouleur; cl.ppFondAuto = obj.ppFondAuto;
        cl.set({ left: obj.left + 15, top: obj.top + 15 });
        c.add(cl); fitInZone(cl); c.setActiveObject(cl); c.requestRenderAll(); snapshot(); onSelection(); updatePrice();
      }, ['ppType', 'ppProps', 'ppId', 'ppFond', 'ppTol', 'ppCouleur', 'ppFondAuto']);
      return;
    }
    obj.setCoords();
    c.requestRenderAll();
    snapshot();
    onSelection();
    updatePrice();
  }

  /* ---------- Placement rapide : Centré, Cœur, Contre-cœur (face), Centré, Haut du dos (dos) ----------
     Place et met à la taille d'usage tout le design du côté (images et textes ensemble) ; le client peut ensuite
     l'ajuster à la main. Cœur = poitrine gauche de la personne qui le porte, donc à droite sur l'aperçu de face.
     Tailles et décalages en cm de la zone d'impression (réduits sur les petites zones : enfant, débardeur). */
  const POSITIONS = {
    centre: { libelle: ptxT("Centré"), atelier: 'CENTRÉ' },
    coeur: { libelle: ptxT("Cœur"), atelier: 'CŒUR (poitrine gauche portée, à droite sur l\'aperçu)' },
    contrecoeur: { libelle: ptxT("Contre-cœur"), atelier: 'CONTRE-CŒUR (poitrine droite portée, à gauche sur l\'aperçu)' },
    hautdos: { libelle: ptxT("Haut du dos"), atelier: 'HAUT DU DOS (sous le col)' },
    // Jogging (Karim 16/10/2026) : 2 positions fixes, centrées sur la jambe, faciles à refaire à la presse.
    cuisse: { libelle: ptxT("Haut de cuisse"), atelier: 'HAUT DE CUISSE' },
    jambe: { libelle: ptxT("Long de la jambe"), atelier: 'LONG DE LA JAMBE' },
    milieu: { libelle: ptxT("Milieu de jambe"), atelier: 'MILIEU DE JAMBE' },
    bas: { libelle: ptxT("Bas de jambe"), atelier: 'BAS DE JAMBE' },
    poche: { libelle: ptxT("Sur la poche"), atelier: 'SUR LA POCHE ARRIÈRE' },
  };
  const positionsOf = (side) => (data.positions?.[side] || []).filter((k) => POSITIONS[k]);
  const zoneCentree = (side) => !!data.jambes || Math.abs(zoneOf(side).x + zoneOf(side).w / 2 - 0.5) < 0.02;

  // Boîte englobant tout le design d'un côté (unités logiques), null si vide.
  function designBox(side) {
    const objs = state.canvases[side]?.getObjects() || [];
    if (!objs.length) return null;
    let x0 = Infinity; let y0 = Infinity; let x1 = -Infinity; let y1 = -Infinity;
    objs.forEach((o) => {
      o.setCoords();
      const r = o.getBoundingRect(true, true);
      x0 = Math.min(x0, r.left); y0 = Math.min(y0, r.top);
      x1 = Math.max(x1, r.left + r.width); y1 = Math.max(y1, r.top + r.height);
    });
    return { x0, y0, x1, y1, w: x1 - x0, h: y1 - y0, cx: (x0 + x1) / 2, cy: (y0 + y1) / 2 };
  }

  // Cible d'une position : largeur et hauteur max, centre horizontal, et haut (ou centre vertical), en unités logiques.
  function ciblePosition(side, key) {
    const z = zoneOf(side);
    const W = LOGICAL_W; const H = Math.min(logicalH(side), hauteurMax(side)); const u = W / z.cmW;
    if (key === 'coeur' || key === 'contrecoeur') {
      const l = Math.min(9, z.cmW * 0.26) * u; // logo cœur : 9 cm (moins sur une petite zone)
      const d = Math.min(9.5, z.cmW * 0.26) * u; // centre du logo écarté de l'axe
      return { w: l, h: l, cx: W / 2 + (key === 'coeur' ? d : -d), top: Math.min(4, z.cmW * 0.1) * u };
    }
    // Haut de cuisse : petit visuel ≤ 10 cm en haut de la zone ; long de la jambe : jusqu'à toute la zone (40 cm), en haut.
    if (key === 'cuisse') return { w: Math.min(10, z.cmW) * u, h: 10 * u, cx: W / 2, top: 0 };
    if (key === 'jambe') return { w: W, h: H, cx: W / 2, top: 0 };
    // Milieu / bas de jambe : visuel de 20 cm (milieu) ou 15 cm (bas) max, sur toute la longueur de zone (75 cm) ; poche : toute la petite zone.
    const Hz = logicalH(side);
    if (key === 'milieu') return { w: W, h: Math.min(20 * u, H), cx: W / 2, cy: Hz / 2 };
    if (key === 'bas') return { w: W, h: Math.min(15 * u, H), cx: W / 2, bottom: Hz };
    if (key === 'poche') return { w: W, h: H, cx: W / 2, cy: Hz / 2 };
    if (key === 'hautdos') return { w: Math.min(25, z.cmW * 0.72) * u, h: Math.min(10, z.cmW * 0.3) * u, cx: W / 2, top: Math.min(1.5, z.cmW * 0.05) * u };
    return { w: W * 0.7, h: H * 0.7, cx: W / 2, cy: H / 2 }; // centré : même taille qu'à l'import
  }

  /* Jogging : pas de placement libre. Le visuel reste centré sur la jambe et calé en haut de la zone (sous la poche) ;
     seule sa taille change. Un ajout est placé « Haut de cuisse » (visuel en largeur) ou « Long de la jambe » (en hauteur). */
  function ancrer(side) {
    const c = state.canvases[side];
    const b = designBox(side);
    if (!c || !b) return;
    const u = LOGICAL_W / zoneOf(side).cmW;
    if (state.pos[side] === 'cuisse' && (b.w > 10.05 * u || b.h > 10.05 * u)) state.pos[side] = 'jambe';
    const Hz = logicalH(side);
    const p = state.pos[side];
    const dx = LOGICAL_W / 2 - b.cx;
    const dy = p === 'milieu' || p === 'poche' ? Hz / 2 - b.cy : p === 'bas' ? Hz - b.y1 : -b.y0;
    if (Math.abs(dx) > 0.01 || Math.abs(dy) > 0.01) {
      c.getObjects().forEach((o) => { o.set({ left: o.left + dx, top: o.top + dy }); o.setCoords(); });
      c.requestRenderAll();
    }
  }
  function placementFixe(c, side) {
    c.on('object:added', (e) => {
      const o = e.target;
      o.set({ lockMovementX: true, lockMovementY: true, hoverCursor: 'default' });
      // (aussi pendant la frappe : le texte est remplacé à chaque lettre)
      setTimeout(() => {
        if (!c.getObjects().includes(o)) return;
        if (!state.pos[side]) {
          const b = designBox(side);
          const vertical = o.ppType !== 'text' && b && b.h > b.w * 1.3; // un texte commence toujours en haut de cuisse
          const cle = positionsOf(side).includes('poche') ? 'poche' : vertical ? 'jambe' : 'cuisse';
          if (state.side === side) placer(cle); else state.pos[side] = cle;
        }
        ancrer(side);
        refreshPos();
      }, 0);
    });
    c.on('object:modified', () => { ancrer(side); refreshPos(); });
    c.on('object:scaling', () => ancrer(side));
  }

  /* Jogging : consigne de pressage pour l'atelier (z.ceinture_cm = haut de la zone sous le haut de la ceinture).
     Les 2 positions sont calées en haut de la zone : la consigne précise la position, la taille et le bas du visuel. */
  const angleCote = (side) => {
    const o = (state.canvases[side]?.getObjects() || []).find((x) => Math.round(((x.angle % 360) + 360) % 360) % 360);
    return o ? Math.round(((o.angle % 360) + 360) % 360) : 0;
  };
  function consigneAtelier(side, pf) {
    const z = zoneOf(side);
    const b = designBox(side);
    if (z.ceinture_cm == null || !b) return null;
    const haut = Math.round(z.ceinture_cm + (b.y0 * z.cmW) / LOGICAL_W);
    const bas = Math.round(z.ceinture_cm + (b.y1 * z.cmW) / LOGICAL_W);
    const key = positionValide(side) || state.pos[side];
    const pos = key && POSITIONS[key] ? POSITIONS[key].atelier : String(pf.position).toUpperCase();
    const lib = { cuisse: ptxT("petit visuel en haut de la cuisse"), jambe: ptxT("visuel le long de la jambe"), milieu: ptxT("visuel au milieu de la jambe"), bas: ptxT("visuel en bas de jambe"), poche: ptxT("petit visuel sur la poche arrière") }[key] || 'visuel';
    const ang = angleCote(side);
    return { haut, bas, texte: `${SIDES_FR[side].toUpperCase()}, ${pos}${ang ? ` ${ptxT(", pivoté de")} ${ang}°` : ''}, ${cm(pf.wCm)} × ${cm(pf.hCm)} ${ptxT("cm,")} ${lib}${ptxT(", centré")} ${key === 'poche' ? ptxT("sur la poche") : ptxT("sur la jambe")}${ptxT(", du haut à")} ${haut} ${ptxT("cm jusqu'à")} ${bas} ${ptxT("cm sous le haut de la ceinture")}` };
  }

  function placer(key) {
    const side = state.side;
    if (!zoneCentree(side)) {
      // Petite zone côté cœur : c'est la zone qui change de côté, le design garde sa place dans la zone.
      state.miroir[side] = key === 'contrecoeur';
      state.pos[side] = key;
      drawMockup();
      scheduleSave();
      return;
    }
    const c = canvas();
    const b = designBox(side);
    if (!b) { setTab('image'); showError(ptxT("Ajoutez d'abord une image ou un texte, puis choisissez sa position.")); return; }
    showError('');
    const t = ciblePosition(side, key);
    const s = Math.min(t.w / b.w, t.h / b.h);
    const cy = t.cy ?? (t.bottom != null ? t.bottom - (b.h * s) / 2 : t.top + (b.h * s) / 2);
    // Glissement de 150 ms (Karim : « l'image disparaît, apparaît ») : mêmes objets, seuls position et échelle bougent.
    const mouvements = c.getObjects().map((o) => {
      const p = o.getCenterPoint();
      return { o, de: { x: p.x, y: p.y, sx: o.scaleX, sy: o.scaleY }, a: { x: t.cx + (p.x - b.cx) * s, y: cy + (p.y - b.cy) * s, sx: o.scaleX * s, sy: o.scaleY * s } };
    });
    state.pos[side] = key;
    const fin = () => {
      mouvements.forEach(({ o, a }) => { o.set({ scaleX: a.sx, scaleY: a.sy }); o.setPositionByOrigin(new fabric.Point(a.x, a.y), 'center', 'center'); o.setCoords(); fitInZone(o); });
      c.renderAll(); // dessin final immédiat (jamais une image de retard)
      snapshot();
      onSelection();
      updatePrice();
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { fin(); return; }
    const debut = performance.now(); const D = 150;
    const pas = (now) => {
      const k = Math.min(1, (now - debut) / D); const e = 1 - (1 - k) ** 3;
      if (k >= 1) { fin(); return; }
      mouvements.forEach(({ o, de, a }) => {
        o.set({ scaleX: de.sx + (a.sx - de.sx) * e, scaleY: de.sy + (a.sy - de.sy) * e });
        o.setPositionByOrigin(new fabric.Point(de.x + (a.x - de.x) * e, de.y + (a.y - de.y) * e), 'center', 'center');
      });
      c.renderAll();
      requestAnimationFrame(pas);
    };
    requestAnimationFrame(pas);
  }

  // Position encore valable après les retouches à la main ? (sinon l'atelier lit seulement les mesures)
  function positionValide(side) {
    // Petite zone côté cœur : la position est le côté de la zone, toujours connu.
    if (!zoneCentree(side)) return positionsOf(side).includes('coeur') ? (state.miroir[side] ? 'contrecoeur' : 'coeur') : null;
    const key = state.pos[side];
    if (!key || !positionsOf(side).includes(key)) return null;
    const b = designBox(side);
    if (!b) return null;
    const axe = (b.cx - LOGICAL_W / 2) * zoneOf(side).cmW / LOGICAL_W;
    if (key === 'coeur') return axe > 2 ? key : null;
    if (key === 'contrecoeur') return axe < -2 ? key : null;
    return Math.abs(axe) < 1.5 ? key : null;
  }

  function refreshPos() {
    const row = $('[data-pp-pos]');
    const side = state.side;
    const keys = positionsOf(side);
    row.hidden = !keys.length;
    if (!keys.length) return;
    if (row.dataset.side !== side) {
      row.dataset.side = side;
      row.innerHTML = keys.map((k) => `<button type="button" data-pp-place="${k}">${POSITIONS[k].libelle}</button>`).join('');
      row.querySelectorAll('[data-pp-place]').forEach((btn) => btn.addEventListener('click', () => placer(btn.dataset.ppPlace)));
    }
    if (!state.restoring && state.canvases[side]) state.pos[side] = positionValide(side);
    const vide = !state.canvases[side]?.getObjects().length && zoneCentree(side);
    // Petite zone côté cœur : un des deux boutons est toujours actif (côté de la zone).
    const actif = zoneCentree(side) ? state.pos[side] : (state.miroir[side] ? 'contrecoeur' : 'coeur');
    row.querySelectorAll('[data-pp-place]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.ppPlace === actif);
      btn.setAttribute('aria-pressed', btn.dataset.ppPlace === actif);
      btn.disabled = vide;
    });
  }

  // État général : pastilles Face / Dos ; annuler / rétablir.
  function refreshUi() {
    if (!state.ready && !state.canvases.face) return;
    if (modal.classList.contains('pp-tiroir')) {
      if (usedSides().length && /Ajoutez une image ou un texte/.test(errorEl.textContent)) showError('');
      tiroirResume(); tiroirPastilles(); tiroirPrix();
    }
    Object.keys(SIDES).forEach((s) => {
      const on = !!state.canvases[s]?.getObjects().length;
      $(`[data-pp-dot="${s}"]`)?.classList.toggle('is-on', on);
      const zone = $(`[data-pp-zone="${s}"]`);
      addBtn?.classList.toggle('is-attente', !usedSides().length); // grisé tant que rien n'est placé (reste cliquable : il explique)
      $('[data-pp-bas-apercu]')?.classList.toggle('is-attente', !usedSides().length);
      zone?.classList.toggle('has-design', on);
      zone?.classList.toggle('pp-zone--etroite', !!zone && parseFloat(zone.style.width) > 0 && parseFloat(zone.style.width) < 150); // ex. jambe du jogging
      // Zone vide : boutons « Ajouter votre image » / « ou écrire un texte » au centre (lot 19, conversion).
      if (zone && !zone.querySelector('.pp-zonevide')) {
        zone.insertAdjacentHTML('beforeend', `<div class="pp-zonevide"><button type="button" class="pp-zonevide__img" data-pp-vide-img>${ptxT("+ Ajouter votre image")}</button><button type="button" class="pp-zonevide__txt" data-pp-vide-txt>${ptxT("ou écrire un texte")}</button></div>`);
        zone.querySelector('[data-pp-vide-img]').addEventListener('click', () => fileInput.click());
        zone.querySelector('[data-pp-vide-txt]').addEventListener('click', () => { setTab('texte'); if (!modal.classList.contains('pp-sheet-open')) feuille(true); });
      }
    });
    addBtn.classList.toggle('is-ready', usedSides().length > 0 && !addBtn.disabled);
    $('[data-pp-undo]').disabled = (state.history[state.side]?.length || 0) < 2;
    $('[data-pp-redo]').disabled = !(state.future[state.side]?.length);
    if (typeof majTaille === 'function') majTaille();
    const vide = stageWrap.querySelector('.pp-vide');
    if (vide) vide.hidden = !!state.canvases[state.side]?.getObjects().length;
    refreshPos();
  }

  /* ---------- Prix (grille) ---------- */
  const usedSides = () => Object.keys(SIDES).filter((s) => state.canvases[s]?.getObjects().length);
  const totalQty = () => Object.values(state.qty).reduce((a, b) => a + (b || 0), 0);
  // Option logo refait : ajoutée au panier après la création (5 € sous 5 pièces, offerte dès 5 — Karim 18/10).
  async function ajouterOptionLogo() {
    if (!state.logoRefait || !data.optionLogo || totalQty() >= 5) return;
    const fd = new FormData();
    fd.append('id', data.optionLogo); fd.append('quantity', 1);
    fd.append('properties[Pour]', data.title || '');
    await postCart(fd).catch(() => {});
  }

  // Grille à utiliser : teinte fixe du produit, sinon selon la couleur (« teintes » : couleur → grille), sinon « couleur ».
  function teinte() {
    const t = data.tarifs || {};
    if (t.teinte_fixe) return t.teinte_fixe;
    const c = couleurOf(state.variant);
    if (t.teintes && t.teintes[c]) return t.teintes[c];
    const blancs = (t.blanc_valeurs || []).map((x) => x.toLowerCase());
    return t.blanc && blancs.includes(c.toLowerCase()) ? 'blanc' : 'couleur';
  }

  const grilleFor = (marquages) => data.tarifs?.[teinte()]?.[String(Math.min(marquages, data.tarifs.max_marquages || 2))];

  function packPrice(marquages, qty) {
    const grille = grilleFor(marquages);
    if (!grille) return null;
    let palier = 0;
    data.tarifs.paliers.forEach((min, i) => { if (qty >= min) palier = i; });
    return { cents: grille[palier], palier };
  }

  // Colissimo : forfait, offert à partir d'un montant de commande (data.livraison, réglé dans le snippet).
  // Le seuil compte aussi ce qui est déjà dans le panier (lu à l'ouverture de l'outil).
  let panierCents = 0;
  const lirePanier = () => fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then((r) => r.json())
    .then((c) => { panierCents = c.total_price || 0; if (state.variant) updatePrice(); }).catch(() => {});
  function ligneLivraison(totalCents) {
    const l = data.livraison;
    if (!l) return '';
    totalCents += panierCents;
    if (l.zone === 'monde') return `<span class="pp-port">${ptxT("+ livraison calculée à la commande")}${ptxT(", ou retrait gratuit à l'atelier")}</span>`;
    if (l.offerte_des && totalCents >= l.offerte_des) return `<span class="pp-port"><strong>${l.zone === 'europe' ? ptxT("Livraison Colissimo Europe offerte") : ptxT("Livraison Colissimo offerte")}</strong> ${ptxT(", ou retrait gratuit à l'atelier")}</span>`;
    const reste = l.offerte_des ? ` ${ptxT("(offerte dès")} ${money(l.offerte_des)} ${ptxT(": plus que")} ${money(l.offerte_des - totalCents)}${panierCents ? ` ${ptxT("avec votre panier")}` : ''})` : '';
    return `<span class="pp-port">${l.zone === 'europe' ? ptxT("+ livraison Colissimo Europe dès") : ptxT("+ livraison Colissimo")} ${money(l.forfait)}${reste}${ptxT(", ou retrait gratuit à l'atelier")}</span>`;
  }

  function updatePrice() {
    if (!state.variant) return;
    refreshUi();
    scheduleSave();
    const qty = totalQty();
    const sides = usedSides();
    const marquages = Math.max(1, sides.length);
    const t = data.tarifs;
    addBtn.disabled = qty < 1;
    state.surDevis = !!(t && qty > (t.max_quantite || 100));
    $('[data-pp-bas-apercu]')?.toggleAttribute('disabled', state.surDevis || qty < 1);
    if (state.surDevis) {
      const max = t.max_quantite || 100;
      const lien = `/pages/devis?type=pro${window.PrinttexEquipe?.actif?.() ? '&equipe=1' : ''}&produit=${encodeURIComponent(data.title)}&quantite=${qty}`;
      priceEl.innerHTML = `<strong>${ptxT("Plus de")} ${max} ${ptxT("pièces : sur devis")}</strong> <a href="${lien}">${ptxT("Recevoir mon devis sous 24 h")}</a>`;
      priceEl.dataset.total = '';
      const basTotal = $('[data-pp-bas-total]');
      if (basTotal) basTotal.innerHTML = `<span>${qty} ${ptxT("pièces,")} <strong>${ptxT("sur devis")}</strong></span>`;
      addBtn.disabled = true;
      return;
    }
    const pp = packPrice(marquages, Math.max(1, qty));
    if (!pp) {
      priceEl.innerHTML = `<strong>${money(state.variant.price * qty)}</strong><span>${qty} ${ptxT("pièce")}${qty > 1 ? 's' : ''}</span>`;
      return;
    }
    const lib = sides.length > 1 ? (data.cotes ? `${sides.length} emplacements` : ptxT("face + dos")) : (data.cotes ? ptxT("1 emplacement") : ptxT("1 marquage"));
    // La 1re pièce (BAT) reste au prix BAT ; le palier dégressif s'applique aux pièces suivantes.
    const bat = grilleFor(marquages)[0];
    const totalCents = qty <= 1 ? bat : bat + (qty - 1) * pp.cents;
    const total = money(totalCents);
    if (priceEl.dataset.total && priceEl.dataset.total !== total) {
      priceEl.classList.remove('pp-pulse');
      void priceEl.offsetWidth; // relance l'animation
      priceEl.classList.add('pp-pulse');
    }
    priceEl.dataset.total = total;
    const basTotal = $('[data-pp-bas-total]');
    // Aucune pièce comptée (ex. liste d'équipe sans tailles) : on le dit, plutôt que « 0 pièce, 25 € ».
    if (basTotal) basTotal.innerHTML = qty < 1 ? `<span><strong>${window.PrinttexEquipe?.actif?.() ? ptxT("Indiquez la taille de chaque personne") : ptxT("Choisissez au moins une taille")}</strong></span>` : `<span>${qty} ${ptxT("pièce")}${qty > 1 ? 's' : ''}, <strong>${total}</strong></span>`;
    const detail = qty <= 1 ? `${ptxT("1 pièce,")} ${lib}` : `${ptxT("1ʳᵉ pièce")} ${money(bat)} + ${qty - 1} × ${money(pp.cents)}, ${lib}`;
    priceEl.innerHTML = `<strong>${total}</strong><span>${detail}</span>`;
    // Frais de livraison annoncés avant le panier (pas de surprise au paiement).
    priceEl.insertAdjacentHTML('beforeend', ligneLivraison(totalCents));
    // Produits à plusieurs emplacements (jogging) : la formule la plus choisie, au bon prix.
    if (data.cotes && sides.length !== 1 && grilleFor(1)) priceEl.insertAdjacentHTML('beforeend', `<span class="pp-conseil">${ptxT("Conseillé : 1 emplacement,")} ${money(grilleFor(1)[0])} ${ptxT("la pièce")}</span>`);
    // À partir de 20 pièces : proposer le devis (pré-rempli avec le produit et la quantité).
    if (qty >= 20) {
      priceEl.insertAdjacentHTML('beforeend', `<a class="pp-devis-hint" href="/pages/devis?produit=${encodeURIComponent(data.title)}&quantite=${qty}">${ptxT("Gros volume ? Recevez un devis sous 24 h")}</a>`);
    }

    // Tableau des paliers (onglet Tailles), palier actuel en évidence.
    const grille = grilleFor(marquages);
    $('[data-pp-tiers]').innerHTML = `<p class="pp-note">${ptxT("Prix à la pièce, impression")} ${lib} ${ptxT("incluse.")} ${ptxT("La 1<sup>re</sup> pièce est au prix fixe ; le tarif dégressif s'applique aux pièces suivantes.")}</p><div class="pp-tiers__row">` +
      t.paliers_libelles.map((l, i) => `<div class="${i === pp.palier ? 'is-on' : ''}"><span>${ptxT(l)}</span><strong>${money(grille[i])}</strong></div>`).join('') + '</div>';

    if (t.max_marquages === 1 && sides.length > 1) {
      priceEl.innerHTML += `<span class="pp-warn-inline">${ptxT("Une seule face personnalisable sur ce produit.")}</span>`;
      addBtn.disabled = true;
    } else if (sides.length > (t.max_marquages || 2)) {
      priceEl.innerHTML += `<span class="pp-warn-inline">${t.max_marquages || 2} ${ptxT("emplacements maximum en ligne pour l'instant : pour plus,")} <a href="/pages/devis?produit=${encodeURIComponent(data.title)}">${ptxT("demandez un devis")}</a>.</span>`;
      addBtn.disabled = true;
    }
  }

  /* ---------- Export et panier ---------- */
  const toBlob = (el, type, quality) => new Promise((resolve) => el.toBlob(resolve, type, quality));

  // Rendu de la zone à une largeur donnée, indépendamment de la taille d'affichage.
  function renderZone(side, widthPx) {
    const c = state.canvases[side];
    // La sélection est rendue après l'export : sinon, au retour, le champ texte créerait un 2e texte au lieu de modifier le premier.
    const sel = c.getActiveObject();
    c.discardActiveObject();
    const z = c.getZoom(); const w = c.getWidth(); const h = c.getHeight();
    c.setDimensions({ width: LOGICAL_W, height: logicalH(side) });
    c.setZoom(1);
    const el = c.toCanvasElement(widthPx / LOGICAL_W);
    c.setDimensions({ width: w, height: h });
    c.setZoom(z);
    c.renderAll(); // export : redessin immédiat (jamais d'image vide)
    if (sel && c.getObjects().includes(sel)) c.setActiveObject(sel);
    return el;
  }

  /* Fichier de production DTF : le visuel seul (fond transparent, sans le vêtement), recadré au plus près,
     à la taille réelle (300 dpi, ou la résolution réelle de l'image si elle est plus faible). Si le navigateur ne peut pas créer une image aussi grande (Safari iPhone :
     ~16 Mpx), la résolution est réduite et la taille réelle reste inscrite dans le PNG. */
  const MOBILE = /iP(hone|ad|od)|Android/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const MAX_PIXELS = MOBILE ? 16000000 : 50000000; // sur ordinateur : toujours 300 dpi, même sur la plus grande zone

  // Retire les bords entièrement transparents.
  function trimTransparent(el) {
    const { width: w, height: h } = el;
    const d = el.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, w, h).data;
    const rowEmpty = (y) => { for (let x = 0, i = y * w * 4 + 3; x < w; x++, i += 4) if (d[i]) return false; return true; };
    const colEmpty = (x, y0, y1) => { for (let y = y0; y <= y1; y++) if (d[(y * w + x) * 4 + 3]) return false; return true; };
    let y0 = 0; let y1 = h - 1;
    while (y0 < h && rowEmpty(y0)) y0++;
    if (y0 === h) return { el, x: 0, y: 0 };
    while (rowEmpty(y1)) y1--;
    let x0 = 0; let x1 = w - 1;
    while (colEmpty(x0, y0, y1)) x0++;
    while (colEmpty(x1, y0, y1)) x1--;
    const out = document.createElement('canvas');
    out.width = x1 - x0 + 1; out.height = y1 - y0 + 1;
    out.getContext('2d').drawImage(el, x0, y0, out.width, out.height, 0, 0, out.width, out.height);
    return { el: out, x: x0, y: y0 };
  }

  // Inscrit la résolution (bloc pHYs) dans le PNG : le logiciel d'impression l'ouvre directement à la bonne taille en cm.
  const CRC_TABLE = Array.from({ length: 256 }, (_, n) => { let c = n; for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1; return c >>> 0; });
  const crc32 = (bytes) => { let c = 0xffffffff; for (const b of bytes) c = CRC_TABLE[(c ^ b) & 0xff] ^ (c >>> 8); return (c ^ 0xffffffff) >>> 0; };
  async function pngWithDpi(blob, dpi) {
    const png = new Uint8Array(await blob.arrayBuffer());
    const chunk = new Uint8Array(21);
    const v = new DataView(chunk.buffer);
    const ppm = Math.round(dpi / 0.0254);
    v.setUint32(0, 9);
    chunk.set([0x70, 0x48, 0x59, 0x73], 4); // « pHYs »
    v.setUint32(8, ppm); v.setUint32(12, ppm); chunk[16] = 1; // pixels par mètre
    v.setUint32(17, crc32(chunk.subarray(4, 17)));
    const at = 33; // signature (8) + bloc IHDR (25)
    return new Blob([png.subarray(0, at), chunk, png.subarray(at)], { type: 'image/png' });
  }

  /* Fichier à imprimer déposé dans Firebase Storage (projet printtex-commande, règle « perso » : dépôt seul,
     PNG uniquement, lecture par lien exact). Shopify convertit ses images en WebP quand on les ouvre depuis
     l'admin (illisible par GTX Graphics Lab) ; Firebase renvoie le PNG tel quel, et « attachment » le fait
     télécharger directement sous son nom (produit, couleur, côté, taille, position, résolution, réf.). */
  /* fetch natif (23/10/2026) : le script Shopify shop_events_listener remplace window.fetch et signe toutes les requêtes
     (Signature-Input) ; Firebase et notre Worker refusent cet en-tête au préflight CORS → « Failed to fetch ». Un cadre vide
     de même origine garde un fetch intact (même origine, mêmes cookies) ; sinon, le fetch de la page. */
  let cadreFetch = null;
  function fetchBrut(url, opt) {
    try {
      if (!cadreFetch || !cadreFetch.contentWindow) { cadreFetch = document.createElement('iframe'); cadreFetch.hidden = true; cadreFetch.setAttribute('aria-hidden', 'true'); cadreFetch.tabIndex = -1; document.body.appendChild(cadreFetch); }
      const f = cadreFetch.contentWindow.fetch;
      if (typeof f === 'function' && /\[native code\]/.test(Function.prototype.toString.call(f))) return f.call(cadreFetch.contentWindow, url, opt);
    } catch (e) { /* cadre indisponible : fetch de la page */ }
    return fetch(url, opt);
  }
  const BUCKET = 'printtex-commande.firebasestorage.app';
  let deposerPng = async function (blob, nom, type = 'image/png') {
    const chemin = `perso/${crypto.randomUUID()}/${nom}`;
    const sep = `printtex${Date.now().toString(36)}`;
    const meta = JSON.stringify({ name: chemin, contentType: type, contentDisposition: `attachment; filename="${nom}"` });
    const corps = new Blob([
      `--${sep}\r\nContent-Type: application/json; charset=utf-8\r\n\r\n${meta}\r\n--${sep}\r\nContent-Type: ${type}\r\n\r\n`,
      blob, `\r\n--${sep}--`,
    ]);
    const r = await fetchBrut(`https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o?name=${encodeURIComponent(chemin)}`, {
      method: 'POST',
      headers: { 'X-Goog-Upload-Protocol': 'multipart', 'Content-Type': `multipart/related; boundary=${sep}` },
      body: corps,
    });
    if (!r.ok) throw new Error(`${ptxT("envoi du fichier refusé (")}${r.status})`);
    const j = await r.json();
    return `https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o/${encodeURIComponent(chemin)}?alt=media&token=${j.downloadTokens}`;
  }
  // Lot 30 : si le dépôt direct échoue (requête signée refusée au préflight, réseau filtré…), notre Worker dépose côté serveur.
  const API_DEPOT = 'https://printtex-equipe.printtex75.workers.dev/api/depot';
  async function deposerViaWorker(blob, nom, type) {
    const fd = new FormData(); fd.append('fichier', blob, nom); fd.append('nom', nom); fd.append('type', type);
    const r = await fetchBrut(API_DEPOT, { method: 'POST', body: fd });
    if (!r.ok) throw new Error(`${ptxT("dépôt par le serveur refusé (")}${r.status})`);
    const j = await r.json(); if (!j.url) throw new Error('dépôt par le serveur : adresse absente'); return j.url;
  }
  const deposerPngDirect = deposerPng;
  deposerPng = async function (blob, nom, type = 'image/png') {
    try { return await deposerPngDirect(blob, nom, type); }
    catch (e) { console.warn('dépôt Firebase direct impossible, passage par le Worker :', e.message); return deposerViaWorker(blob, nom, type); }
  };

  const slug = (s) => String(s || '').replace(/œ/g, 'oe').replace(/Œ/g, 'OE').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^A-Za-z0-9]+/g, '-').replace(/^-|-$/g, '');

  async function printFile(side) {
    const c = state.canvases[side];
    c.discardActiveObject();
    const W = LOGICAL_W; const H = logicalH(side);
    // Boîte englobant tous les éléments (marge pour les contours), limitée à la zone d'impression.
    let x0 = W; let y0 = H; let x1 = 0; let y1 = 0;
    c.getObjects().forEach((o) => {
      o.setCoords();
      const r = o.getBoundingRect(true, true);
      x0 = Math.min(x0, r.left); y0 = Math.min(y0, r.top);
      x1 = Math.max(x1, r.left + r.width); y1 = Math.max(y1, r.top + r.height);
    });
    x0 = Math.max(0, Math.floor(x0 - 10)); y0 = Math.max(0, Math.floor(y0 - 10));
    x1 = Math.min(W, Math.ceil(x1 + 10)); y1 = Math.min(H, Math.ceil(y1 + 10));
    if (x1 <= x0 || y1 <= y0) { x0 = 0; y0 = 0; x1 = W; y1 = H; }

    const k = zoneOf(side).cmW / W; // cm par unité logique
    // Résolution réelle des images du client à leur taille d'impression.
    const reelles = c.getObjects().filter((o) => o.ppType === 'image')
      .map((o) => Math.round(o.width / ((o.getScaledWidth() * k) / 2.54)));
    const reelle = Math.min(...reelles);
    /* Fichier léger : 300 dpi s'il y a du texte (net) ; sinon la résolution réelle de l'image la plus fine
       (entre 150 et 300 dpi) : agrandir une petite image à 300 dpi alourdit le fichier sans ajouter de détail. */
    const cible = c.getObjects().some((o) => o.ppType !== 'image') || !reelles.length
      ? DPI : Math.min(DPI, Math.max(150, ...reelles));
    const full = (zoneOf(side).cmW / 2.54) * cible / W; // pixels par unité logique à la résolution choisie
    const area = (x1 - x0) * (y1 - y0) * full * full;
    const mult = area > MAX_PIXELS ? full * Math.sqrt(MAX_PIXELS / area) : full;
    const dpi = Math.round(cible * mult / full);

    const z = c.getZoom(); const w = c.getWidth(); const h = c.getHeight();
    c.setDimensions({ width: W, height: H });
    c.setZoom(1);
    const raw = c.toCanvasElement(mult, { left: x0, top: y0, width: x1 - x0, height: y1 - y0 });
    c.setDimensions({ width: w, height: h });
    c.setZoom(z);
    c.renderAll(); // export : redessin immédiat (jamais d'image vide)

    const t = trimTransparent(raw);
    const wCm = (t.el.width / mult) * k;
    const hCm = (t.el.height / mult) * k;
    const axeCm = (x0 + t.x / mult + t.el.width / mult / 2 - W / 2) * k; // décalage du centre / axe de la zone
    const blob = await pngWithDpi(await toBlob(t.el, 'image/png'), dpi);
    // Placement rapide choisi (et encore respecté) : nommé en tête, avant les mesures.
    const pos = positionValide(side);
    return {
      blob, wCm, hCm, dpi,
      faible: reelle < 150,
      reelle,
      position: pos ? POSITIONS[pos].libelle : Math.abs(axeCm) < 0.3 ? ptxT("Centre") : ptxT("Libre"),
    };
  }

  // Boîte englobant la boîte en cache (photo de référence du côté, pour la zone) ET celle mesurée sur les pixels de cette photo :
  // une photo couleur cadrée autrement que la référence n'est jamais coupée dans l'aperçu.
  function boiteVisible(el) { const c = document.createElement('canvas'); c.width = 200; c.height = Math.round(200 * ratioOf(el)); c.getContext('2d').drawImage(el, 0, 0, c.width, c.height); const a = garmentBox(el); const b = garmentBox(c); const x = Math.min(a.x, b.x); const y = Math.min(a.y, b.y); return { x, y, w: Math.max(a.x + a.w, b.x + b.w) - x, h: Math.max(a.y + a.h, b.y + b.h) - y }; }
  async function previewFile(side, W = 900, { cadre = false, sansCreation = false } = {}) { // W = 720 pour la miniature du panier (plus léger, ajout plus rapide)
    const src = await mockupSource(side);
    const H = Math.round(W * ratioOf(src.el));
    const out = document.createElement('canvas');
    // cadre : recadré sur le vêtement (boîte + marge 3 %), carré : même échelle et même position pour la face et le dos
    const g = cadre ? boiteVisible(src.el) : null; if (g && src.mirror) g.x = 1 - g.x - g.w;
    const m = 0.03; const c = g ? { x: Math.max(0, g.x - m), y: Math.max(0, g.y - m) } : null; if (c) { c.w = Math.min(1, g.x + g.w + m) - c.x; c.h = Math.min(1, g.y + g.h + m) - c.y; }
    const k = c ? Math.min(W / (c.w * W), W / (c.h * H)) : 1; // le vêtement tient dans W × W
    out.width = W; out.height = c ? W : H;
    const ctx = out.getContext('2d');
    if (c) { ctx.fillStyle = pierre(); ctx.fillRect(0, 0, W, W); ctx.translate((W - c.w * W * k) / 2 - c.x * W * k, (W - c.h * H * k) / 2 - c.y * H * k); ctx.scale(k, k); }
    paintSource(ctx, src, W, H);
    if (!sansCreation) { const r = zoneRect(side, src, W, H); ctx.drawImage(renderZone(side, r.width), r.left, r.top, r.width, r.height); }
    return toBlob(out, 'image/jpeg', 0.82);
  }

  function showError(msg) { errorEl.textContent = msg; errorEl.hidden = !msg; }

  const packVariantId = (marquages, palier) => data.tarifs?.pack_variantes?.[teinte()]?.[String(marquages)]?.[palier] || null;

  // Produit « perso-… » (une variante par quantité totale) : assets/printtex-packs.json. null si indisponible.
  let packsCommande = null;
  async function packCommande(marquages, qty) {
    try {
      packsCommande ??= await fetch(data.packsUrl).then((r) => r.json());
      const handle = packsCommande.produits[data.handle];
      const P = handle && packsCommande.packs[handle];
      if (!P) return null;
      const t0 = teinte();
      const t = [t0, t0 === 'natural' ? 'naturel' : t0, 'unique'].find((k) => P.v[k]);
      const m = String(Math.min(marquages, data.tarifs?.max_marquages || 2));
      const id = t && P.v[t][m]?.[qty - 1];
      return id ? { id, pack: handle, teinte: t, marquages: m } : null;
    } catch (e) {
      return null;
    }
  }

  async function postCart(fd) {
    const res = await fetch(data.cartAddUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(json.description || json.message || `${ptxT("Erreur")} ${res.status}`);
    return json;
  }

  async function addToCart() {
    showError('');
    const sides = usedSides();
    if (!sides.length) { showError(ptxT("Ajoutez une image ou un texte sur le produit avant de commander.")); return; }
    const lignes = Object.entries(state.qty).filter(([, q]) => q > 0);
    if (!lignes.length) { setTab('quantites'); showError(ptxT("Choisissez au moins une taille.")); return; }
    const qty = totalQty();
    const marquages = sides.length;
    const pp = packPrice(marquages, qty);
    addBtn.disabled = true;
    addBtn.textContent = ptxT("Préparation…");

    try {
      const ref = `P${Date.now().toString(36).toUpperCase()}`;
      /* Dans la commande (admin Shopify), par côté marqué, seulement : « _Face, aperçu » (image) et
         « _Face, fichier à imprimer » (lien Firebase : un clic télécharge le PNG). « _ » = caché au client au
         paiement et dans les mails (l'aperçu reste en miniature au panier). Le nom du PNG donne les infos atelier :
         produit, couleur, côté, taille, position, résolution (réelle + « RESOLUTION-FAIBLE » si l'image est trop petite). */
      const zoneProps = []; // [clé, valeur] ou [clé, fichier, nom du fichier]
      const couleur = couleurIdx >= 0 ? couleurOf(state.variant) : '';
      const repartition = lignes.map(([t, q]) => (t ? `${t} × ${q}` : `${q}`)).join(', ');
      // Plus rapide (lot 18) : la création (lien « Recommander ») et les fichiers à imprimer partent en même temps.
      const lienP = partagerDesign();
      const depots = [];
      const emplacements = []; // ligne lisible pour le client et l'admin : « Face : 24,5 × 20 cm, centré, Dos : … »
      for (const s of sides) {
        const Z = SIDES_FR[s];
        const pf = await printFile(s);
        emplacements.push(`${Z} : ${pf.wCm.toFixed(1).replace(".", ",")} × ${pf.hCm.toFixed(1).replace(".", ",")} cm, ${String(pf.position).toLowerCase()}`);
        const dims = `${pf.wCm.toFixed(1)}x${pf.hCm.toFixed(1)}cm`.replace(/\./g, ',');
        const resolution = pf.faible ? `${pf.reelle}dpi_RESOLUTION-FAIBLE` : `${pf.dpi}dpi`;
        const ca = consigneAtelier(s, pf);
        const nom = [slug(data.title), slug(couleur), slug(Z).toLowerCase(), dims, slug(pf.position), angleCote(s) ? `pivote-${angleCote(s)}deg` : '', ca ? `a-${ca.haut}cm-sous-ceinture` : '', resolution, ref].filter(Boolean).join('_');
        if (ca) zoneProps.push([`_${Z}, position`, ca.texte]);
        zoneProps.push([`_${Z}, aperçu`, await previewFile(s, 720), `apercu_${nom}.jpg`]);
        const k = zoneProps.push([`_${Z}, fichier à imprimer`, '']) - 1;
        depots.push(deposerPng(pf.blob, `${nom}.png`).then((u) => { zoneProps[k][1] = u; }).catch((e) => {
          // Dépôt impossible (réseau, Firebase) : la commande passe quand même, le PNG est joint à la ligne (fichier Shopify) et l'atelier est prévenu.
          zoneProps[k] = [`_${Z}, fichier à imprimer`, pf.blob, `${nom}.png`];
          if (!zoneProps.some(([c]) => c === '_Fichiers : à récupérer')) zoneProps.push(['_Fichiers : à récupérer', `dépôt Firebase impossible (${String(e.message || e).slice(0, 80)}) : le PNG à imprimer est joint à la ligne (fichier Shopify), à récupérer dans la commande`]);
        }));
      }
      // Originaux du client (images telles qu'envoyées), une adresse par image : l'atelier peut toujours repartir de zéro.
      const originauxDeposes = []; let originauxEchecs = 0; const notesOriginaux = [];
      // Règle Firebase perso/ (chef 23/10) : originaux acceptés en JPEG, PNG, WebP, SVG, HEIC/HEIF, GIF, BMP, AVIF, PDF, AI jusqu'à 25 Mo.
      const TYPES_ORIGINAUX = { png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', jfif: 'image/jpeg', webp: 'image/webp', gif: 'image/gif', bmp: 'image/bmp', avif: 'image/avif', svg: 'image/svg+xml', heic: 'image/heic', heif: 'image/heif', pdf: 'application/pdf', ai: 'application/pdf' };
      let numOriginal = 0;
      for (const s of usedSides()) for (const o of state.canvases[s].getObjects()) {
        const a = o.ppType === 'image' ? originaux.get(o.ppId) : null;
        if (!a?.fichier) continue;
        let fichier = a.fichier; let ext = (fichier.name.match(/\.([a-z0-9]{2,5})$/i) || [, 'png'])[1].toLowerCase();
        let type = fichier.type || TYPES_ORIGINAUX[ext] || 'application/octet-stream'; // HEIC sous Windows : type vide → déduit du nom
        if (fichier.size > 25 * 1024 * 1024) { // au-delà de la règle : version réduite (canevas d'analyse ≤ 16 Mpx) à la place, dit dans _Original
          const png = a.type === 'transparent'; const bl = await new Promise((ok) => a.el.toBlob(ok, png ? 'image/png' : 'image/jpeg', 0.92)).catch(() => null);
          if (bl) { notesOriginaux.push(`original réduit (fichier d'origine de ${Math.round(fichier.size / 1048576)} Mo)`); fichier = bl; ext = png ? 'png' : 'jpg'; type = png ? 'image/png' : 'image/jpeg'; }
        }
        numOriginal++;
        depots.push(deposerPng(fichier, `original_${slug(SIDES_FR[s]).toLowerCase()}_${ref}_${numOriginal}.${ext}`, type).then((u) => { originauxDeposes.push(u); }).catch(() => { originauxEchecs++; }));
      }
      await Promise.all(depots);
      if (originauxDeposes.length || originauxEchecs || notesOriginaux.length) zoneProps.push(['_Original', [...originauxDeposes, ...notesOriginaux, originauxEchecs ? `échec d'envoi (${originauxEchecs} fichier${originauxEchecs > 1 ? 's' : ''})` : ''].filter(Boolean).join(' ')]);
      // Lot 30 (A10) : méthode appliquée à chaque image, pour l'atelier.
      const fondsImages = usedSides().flatMap((s) => state.canvases[s].getObjects().filter((o) => o.ppType === 'image').map((o) => {
        const lib = { garder: 'fond gardé', contour: `fond retiré autour (tolérance ${o.ppTol ?? TOL})`, partout: `fond retiré partout (tolérance ${o.ppTol ?? TOL})`, detoure: 'détouré par IA' }[o.ppFond] || o.ppFond;
        const c = o.ppControle; return `${SIDES_FR[s]} : ${lib}${c && c.verdict !== 'propre' ? ` — contrôle ${c.verdict === 'rate' ? 'raté, image gardée entière' : 'douteux'} (${c.raison})` : ''}`;
      }));
      if (fondsImages.length) zoneProps.push(['_Fond', fondsImages.join(' ; ')]);
      zoneProps.unshift(['Emplacements', emplacements.join(', ')]);
      if (state.logoRefait) zoneProps.push(['Logo refait', totalQty() >= 5 ? 'oui (offert dès 5 pièces)' : 'oui']);
      /* Données techniques du panier (modifier tailles et quantités) en une seule ligne cachée :
         « _ppx » = référence|quantité totale|pack|teinte|marquages|tailles disponibles|répartition. */
      const ppx = (commande) => [ref, qty, commande.pack, commande.teinte, commande.marquages,
        tailleIdx >= 0 ? data.options[tailleIdx].values.join(',') : '', lignes.map(([t, q]) => `${t}:${q}`).join(',')].join('|');

      // 1 design = 1 ligne de commande : variante « N pièces » du produit « perso-… » (prix exact : 1re pièce au
      // prix BAT + pièces suivantes au tarif dégressif). Tailles et quantités modifiables ensuite dans le panier.
      // BAT validé en ligne (idée métier 2) : l'aperçu vu et accepté, horodaté dans la commande.
      const quand = new Date().toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short', timeZone: 'Europe/Paris' });
      zoneProps.push(['_BAT', `aperçu validé en ligne le ${quand.replace(' ', ' à ')}`]); // caché au client, visible dans l'admin
      // Date de l'événement indiquée dans l'aperçu : visible par l'atelier dans la commande.
      if (state.evenement) zoneProps.push(['Événement', `le ${new Date(state.evenement + 'T12:00:00Z').toLocaleDateString('fr-FR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}`]);
      // « Recommander la même chose » sans compte client (idée métier 8) : lien qui rouvre l'outil avec cette création.
      addBtn.textContent = ptxT("Enregistrement de la création…");
      const lien = await lienP;
      if (lien) zoneProps.push(['Recommander', lien]);

      const commande = await packCommande(marquages, qty);
      if (commande) {
        addBtn.textContent = ptxT("Envoi…");
        const fd = new FormData();
        fd.append('id', commande.id);
        fd.append('quantity', 1);
        // Sans tailles (tote, casquette…), la quantité est déjà dans la variante « N pièces » : pas de doublon.
        if (tailleIdx >= 0) fd.append('properties[Tailles]', repartition);
        if (couleurIdx >= 0) fd.append('properties[Couleur]', couleur);
        zoneProps.forEach(([k, val, name]) => (val instanceof Blob ? fd.append(`properties[${k}]`, val, name) : fd.append(`properties[${k}]`, val)));
        fd.append('properties[_ppx]', ppx(commande));
        await postCart(fd);
        await clearSaved();
        history.replaceState(null, '', location.pathname + location.search); // retour depuis le panier : la fiche, sans rouvrir l'outil
        addBtn.classList.add('is-done');
        addBtn.textContent = ptxT("✓ Ajouté au panier"); addBtn.classList.remove('is-ajoute'); void addBtn.offsetWidth; addBtn.classList.add('is-ajoute'); { const conf = document.querySelector('.pp-apercu [data-confirmer]'); if (conf) { conf.classList.add('mv-ajoute'); conf.innerHTML = `<span>${conf.textContent}</span><span class="mv-coche">${ptxT("✓ Ajouté")}</span>`; requestAnimationFrame(() => conf.classList.add('is-ajoute')); } }
        await new Promise((r) => setTimeout(r, 650));
        await ajouterOptionLogo();
        await appliquerCarteCadeau();
        window.location.href = data.cartUrl;
        return;
      }

      let urls = null; // URLs des fichiers déjà envoyés (réutilisées pour les autres tailles)
      // La 1re pièce est au prix BAT (palier 0, fixe) ; les suivantes au palier de la quantité totale.
      const envois = [];
      lignes.forEach(([taille, q], i) => {
        if (pp && pp.palier > 0 && i === 0) {
          envois.push({ taille, q: 1, palier: 0, bat: true });
          if (q > 1) envois.push({ taille, q: q - 1, palier: pp.palier });
        } else {
          envois.push({ taille, q, palier: pp ? pp.palier : 0, bat: pp && pp.palier === 0 && i === 0 });
        }
      });
      let n = 0;
      for (const { taille, q, palier, bat } of envois) {
        n++;
        addBtn.textContent = envois.length > 1 ? `${ptxT("Envoi")} ${n}/${envois.length}…` : ptxT("Envoi…");
        const v = variantFor(couleurOf(state.variant), taille);
        const packId = pp ? packVariantId(marquages, palier) : null;
        const fd = new FormData();
        fd.append('id', packId || v.id);
        fd.append('quantity', q);
        if (packId) {
          if (tailleIdx >= 0) fd.append('properties[Taille]', taille);
          if (couleurIdx >= 0) fd.append('properties[Couleur]', couleurOf(state.variant));
          fd.append('properties[Tarif]', bat ? '1re pièce (BAT)' : `Tarif dégressif (${data.tarifs.paliers_libelles[palier]} pièces)`);
        }
        if (envois.length > 1) fd.append('properties[Même design]', `${qty} pièces au total (${repartition})`);
        zoneProps.forEach(([k, val, name]) => {
          if (!(val instanceof Blob)) fd.append(`properties[${k}]`, val);
          else if (urls && urls[k]) fd.append(`properties[${k}]`, urls[k]);
          else fd.append(`properties[${k}]`, val, name);
        });
        fd.append('properties[_Référence design]', ref);
        const item = await postCart(fd);
        const props = item.properties || item.items?.[0]?.properties || {};
        if (!urls) urls = Object.fromEntries(zoneProps.filter(([, val]) => val instanceof Blob).map(([k]) => [k, props[k]]).filter(([, u]) => u));
      }
      await clearSaved();
      history.replaceState(null, '', location.pathname + location.search); // retour depuis le panier : la fiche, sans rouvrir l'outil
      addBtn.classList.add('is-done');
      addBtn.textContent = ptxT("✓ Ajouté au panier"); addBtn.classList.remove('is-ajoute'); void addBtn.offsetWidth; addBtn.classList.add('is-ajoute'); { const conf = document.querySelector('.pp-apercu [data-confirmer]'); if (conf) { conf.classList.add('mv-ajoute'); conf.innerHTML = `<span>${conf.textContent}</span><span class="mv-coche">${ptxT("✓ Ajouté")}</span>`; requestAnimationFrame(() => conf.classList.add('is-ajoute')); } }
      await new Promise((r) => setTimeout(r, 650));
      await appliquerCarteCadeau();
      window.location.href = data.cartUrl;
    } catch (e) {
      showError(`${ptxT("L'ajout au panier a échoué :")} ${e.message}. Réessayez ou appelez-nous au 01 86 04 31 65.`);
      addBtn.disabled = false;
      addBtn.textContent = ptxT("Ajouter au panier");
    }
  }

  /* ---------- Création gardée sur l'appareil (IndexedDB) ----------
     Retrouvée à la réouverture de l'outil (retour arrière, page rechargée, visite suivante), effacée une fois
     ajoutée au panier. IndexedDB plutôt que localStorage : les images importées dépassent vite 5 Mo. */
  const SAVE_KEY = data.handle || String(data.productId);
  const SAVE_MAX_AGE = 30 * 24 * 3600 * 1000;
  function idb(mode, fn) {
    return new Promise((resolve) => {
      try {
        const req = indexedDB.open('printtex-perso', 1);
        req.onupgradeneeded = () => req.result.createObjectStore('designs');
        req.onerror = () => resolve(null);
        req.onsuccess = () => {
          const tx = req.result.transaction('designs', mode);
          const r = fn(tx.objectStore('designs'));
          tx.oncomplete = () => resolve(r ? r.result : null);
          tx.onerror = () => resolve(null);
          tx.onabort = () => resolve(null);
        };
      } catch (e) { resolve(null); }
    });
  }
  const lastJson = (side) => state.history[side][state.history[side].length - 1];
  let saveTimer;
  function scheduleSave() {
    if (!state.loaded) return; // pas avant d'avoir récupéré une éventuelle création (sinon on l'écraserait)
    clearTimeout(saveTimer);
    saveTimer = setTimeout(() => {
      if (!usedSides().length) { clearSaved(); return; }
      const design = { t: Date.now(), variant: state.variant?.id, qty: state.qty, pos: state.pos, miroir: state.miroir };
      Object.keys(SIDES).forEach((s) => { design[s] = lastJson(s); });
      idb('readwrite', (st) => st.put(design, SAVE_KEY));
    }, 800);
  }
  function clearSaved() {
    clearTimeout(saveTimer);
    return idb('readwrite', (st) => st.delete(SAVE_KEY));
  }
  const loadInto = (c, json) => new Promise((resolve) => c.loadFromJSON(json, resolve));

  /* « Recommander la même chose » (17/10/2026) : la création est enregistrée (Worker printtex-equipe, 1 an) ; le lien
     « Recommander » de la commande rouvre l'outil avec elle (?design=<id>), couleur et quantités comprises. */
  const API_DESIGN = 'https://printtex-equipe.printtex75.workers.dev/api/design';
  const designDuLien = new URLSearchParams(location.search).get('design');
  async function partagerDesign() {
    try {
      const design = { t: Date.now(), variant: state.variant?.id, qty: state.qty, pos: state.pos, miroir: state.miroir };
      Object.keys(SIDES).forEach((s) => { design[s] = lastJson(s); });
      const r = await fetchBrut(API_DESIGN, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ produit: data.handle, design }) });
      const j = await r.json();
      return r.ok && j.id ? `${location.origin}/products/${data.handle}?design=${j.id}` : null;
    } catch (e) { return null; }
  }

  async function restoreSaved() {
    let saved = null;
    if (/^[a-z0-9]{10}$/.test(designDuLien || '')) {
      const d = await fetch(`${API_DESIGN}/${designDuLien}`).then((r) => (r.ok ? r.json() : null)).catch(() => null);
      if (d && d.produit === data.handle && d.design) {
        saved = { ...d.design, t: Date.now() };
        const v = data.variants.find((x) => x.id === saved.variant);
        if (v) setVariant(v);
      }
    }
    saved ??= await idb('readonly', (st) => st.get(SAVE_KEY));
    if (!saved || Date.now() - saved.t > SAVE_MAX_AGE) { state.loaded = true; return; }
    state.restoring = true;
    // La couleur reste celle choisie sur la fiche (pas celle de la création retrouvée).
    if (saved.qty) { state.qty = saved.qty; state.tailleChoisie = true; buildSizes(); }
    if (saved.pos) state.pos = { ...state.pos, ...saved.pos };
    if (saved.miroir) state.miroir = { ...state.miroir, ...saved.miroir };
    for (const side of Object.keys(SIDES)) {
      if (!saved[side]) continue;
      const c = state.canvases[side];
      const dejaPoses = c.getObjects().slice(); // posés pendant le chargement : gardés
      await loadInto(c, saved[side]);
      dejaPoses.forEach((o) => { if (!c.getObjects().includes(o)) c.add(o); });
      // Textes recréés une fois leur police chargée (sinon mesurés avec la police de secours).
      for (const o of c.getObjects().filter((x) => x.ppType === 'text' && x.ppProps)) {
        await ensureFont(o.ppProps);
        const neuf = makeText(o.ppProps);
        neuf.set({ left: o.left, top: o.top, angle: o.angle, scaleX: o.scaleX, scaleY: o.scaleY, flipX: o.flipX });
        neuf.ppType = 'text';
        neuf.ppProps = o.ppProps;
        const idx = c.getObjects().indexOf(o);
        c.remove(o);
        c.insertAt(neuf, idx);
      }
      for (const f of ext.restaurer) await f(c); // modules : leurs éléments recréés avec la bonne police
      // Création retrouvée : recalée dans la zone actuelle (la zone a pu changer depuis).
      c.getObjects().forEach((o) => fitInZone(o, side));
      c.discardActiveObject();
      c.requestRenderAll();
      state.history[side] = [JSON.stringify(c.toJSON(['ppType', 'ppProps', 'ppId', 'ppFond', 'ppTol', 'ppCouleur', 'ppFondAuto']))];
      state.future[side] = [];
    }
    state.restoring = false;
    state.loaded = true;
    if (usedSides().length) showRestored();
    drawMockup();
    onSelection();
    updatePrice();
  }

  function showRestored() {
    let bar = $('[data-pp-restored]');
    if (!bar) {
      bar = document.createElement('p');
      bar.className = 'pp-restored';
      bar.dataset.ppRestored = '';
      bar.innerHTML = `${ptxT("Nous avons retrouvé votre création.")} <button type="button">${ptxT("Recommencer à zéro")}</button>`;
      stageWrap.prepend(bar);
      bar.querySelector('button').addEventListener('click', async () => {
        await clearSaved();
        Object.keys(SIDES).forEach((s) => {
          const c = state.canvases[s];
          state.restoring = true;
          c.clear();
          state.restoring = false;
          state.history[s] = [];
          state.pos[s] = null;
          state.miroir[s] = false;
          snapshot(s);
        });
        // Repart de la couleur choisie sur la fiche, et d'une seule pièce (taille de la fiche) : les quantités aussi.
        const v = data.variants.find((x) => x.id === currentPageVariantId());
        if (v && couleurOf(v) !== couleurOf(state.variant)) setVariant(v);
        const vt = v || state.variant;
        state.qty = { [tailleIdx >= 0 ? vt.options[tailleIdx] : '']: 1 };
        buildSizes();
        updatePrice();
        drawMockup();
        bar.hidden = true;
        onSelection();
        updatePrice();
      });
    }
    bar.hidden = false;
    if (modal.classList.contains('pp-var-e')) {
      modal.appendChild(bar);
      clearTimeout(bar.ppTimer);
      bar.ppTimer = setTimeout(() => { bar.hidden = true; }, 4000);
    }
  }

  /* ---------- Ouverture / fermeture ----------
     L'ouverture ajoute une entrée d'historique (#personnaliser) : le bouton retour du téléphone ou du navigateur
     ferme l'outil au lieu de quitter la fiche produit. */
  // L'outil s'ouvre toujours à la couleur cochée sur la fiche (elle prime sur celle de la création retrouvée).
  let ficheVue = null; // variante de la fiche lors de la dernière ouverture de l'outil
  function open() {
    lirePanier();
    if (modal.classList.contains('pp-tiroir')) showError('');
    // Grille des packs chargée dès l'ouverture (l'ajout au panier n'attend plus ce fichier).
    if (!packsCommande && data.packsUrl) fetch(data.packsUrl).then((r) => r.json()).then((p) => { packsCommande ??= p; }).catch(() => {});
    if (!window.fabric) { open.attente = (open.attente || 0) + 1; if (open.attente === 55) showError(ptxT("Le chargement prend du temps (connexion lente). Patientez quelques secondes ou rechargez la page.")); setTimeout(open, 150); return; }
    if (!history.state?.pp) {
      if (location.hash === '#personnaliser') history.replaceState(history.state, '', location.pathname + location.search);
      history.pushState({ pp: true }, '', '#personnaliser');
    }
    modal.hidden = false;
    document.documentElement.classList.add('pp-lock');
    // Cascade d'entrée (Karim 21/10) : classe posée 600 ms, animations CSS en « backwards », aucune attente ajoutée.
    modal.classList.add('pp-entree'); clearTimeout(open._entree); open._entree = setTimeout(() => modal.classList.remove('pp-entree'), 600);
    // Première image tout de suite (bande, squelette, barre) ; l'initialisation lourde suit à l'image d'après.
    if (state.ready) initialiserOuverture(); else { stage.classList.add('is-loading'); variantesCompletes.then(() => requestAnimationFrame(() => setTimeout(initialiserOuverture, 0))); }
  }
  function initialiserOuverture() {
    if (!state.ready) {
      createCanvases();
      buildTextControls();
      buildSwatches();
      // Toutes les photos du produit (couleurs, face et dos) chargées dès l'ouverture de l'outil.
      [...new Set(data.variants.map((x) => x.image).concat(Object.keys(SIDES).flatMap((k) => [data[k]?.image, ...Object.values(data[k]?.images || {})])))].forEach((u) => loadImage(u));
      setVariant(data.variants.find((x) => x.id === currentPageVariantId()) || data.variants[0]);
      setTab('image');
      // Produit à une seule face personnalisable (ex. bob) : pas d'onglet Dos.
      if (data.sides && !data.sides.includes('dos')) $('.pp-seg').hidden = true;
      state.ready = true;
      // Faces préchauffées pendant un temps libre : la première rotation Face / Dos ne décode ni ne détoure rien.
      (window.requestIdleCallback || ((f) => setTimeout(f, 800)))(() => Object.keys(SIDES).forEach((s) => prechaufferFace(s)));
      restoreSaved();
    } else if (currentPageVariantId() !== ficheVue) {
      // Couleur changée sur la fiche depuis la dernière ouverture : l'outil la reprend.
      const v = data.variants.find((x) => x.id === currentPageVariantId());
      if (v && couleurOf(v) !== couleurOf(state.variant)) setVariant(v);
    }
    ficheVue = currentPageVariantId();
    // Taille de la zone affichée tout de suite (sans attendre le chargement de la photo).
    const size = $('[data-pp-zone-size]');
    if (size && !size.textContent.trim()) size.textContent = `${zoneOf(state.side).cmW.toLocaleString('fr-FR')} × ${zoneOf(state.side).cmH.toLocaleString('fr-FR')} ${ptxT("cm max.")}`;
    requestAnimationFrame(() => setSide(state.side));
  }

  function hide() {
    modal.hidden = true;
    document.documentElement.classList.remove('pp-lock');
  }

  // Croix ou Échap : revient sur l'entrée d'historique d'avant l'ouverture (popstate → hide).
  function close() {
    if (history.state?.pp) history.back();
    else hide();
  }
  window.addEventListener('popstate', () => {
    if (history.state?.pp) { if (modal.hidden) open(); } else if (!modal.hidden) hide();
  });

  /* ---------- Fiche produit : date de livraison estimée et bouton fixe sur mobile ---------- */
  // Jours fériés français (Pâques calculé : lundi de Pâques, Ascension, lundi de Pentecôte).
  function feries(an) {
    const a = an % 19; const b = Math.floor(an / 100); const c = an % 100;
    const d = (19 * a + b - Math.floor(b / 4) - Math.floor((b - Math.floor((b + 8) / 25) + 1) / 3) + 15) % 30;
    const e = (32 + 2 * (b % 4) + 2 * Math.floor(c / 4) - d - (c % 4)) % 7;
    const m = Math.floor((a + 11 * d + 22 * e) / 451);
    const paques = new Date(an, Math.floor((d + e - 7 * m + 114) / 31) - 1, ((d + e - 7 * m + 114) % 31) + 1);
    const plus = (n) => new Date(an, paques.getMonth(), paques.getDate() + n);
    return [new Date(an, 0, 1), plus(1), new Date(an, 4, 1), new Date(an, 4, 8), plus(39), plus(50),
      new Date(an, 6, 14), new Date(an, 7, 15), new Date(an, 10, 1), new Date(an, 10, 11), new Date(an, 11, 25)]
      .map((x) => x.toDateString());
  }
  const ouvre = (d) => d.getDay() % 6 !== 0 && !feries(d.getFullYear()).includes(d.toDateString());
  function joursOuvres(n) {
    const d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (ouvre(d)) n--; }
    return d;
  }
  const livraison = document.querySelector('[data-pp-livraison]');
  if (livraison) {
    const f = (d) => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    livraison.innerHTML = `${ptxT("Livraison estimée")} <strong>${ptxT("entre le")} ${f(joursOuvres(2))} ${ptxT("et le")} ${f(joursOuvres(4))}</strong> ${ptxT("(Colissimo)")}`;
  }
  // Tableau des prix à la pièce (impression 1 face incluse) sous le bouton, pour la couleur choisie sur la fiche :
  // le prix d'une pièce seule est visible avant d'ouvrir l'outil.
  const grilleFiche = document.querySelector('[data-pp-grille]');
  function renderGrilleFiche(variantId) {
    const t = data.tarifs;
    const v = data.variants.find((x) => x.id === Number(variantId));
    if (!grilleFiche || !t || !v) return;
    const avant = state.variant;
    state.variant = v; // teinte() lit la couleur de state.variant
    const g1 = grilleFor(1);
    // Produit à une seule face (casquette, bob…) : pas de prix « face + dos ».
    const g2 = (t.max_marquages || 2) > 1 && (!data.sides || data.sides.includes('dos') || data.cotes) ? grilleFor(2) : null;
    state.variant = avant;
    if (!g1) return;
    const cols = t.paliers_libelles.map((l, i) => `<div><span>${ptxT(l)}</span><strong>${money(g1[i])}</strong></div>`).join('');
    // Fiche produit (Design, lot 30) : un titre court, une ligne, et la règle de prix en petit (chef 24/10 : aucune surprise au panier) ;
    // le détail face + dos reste dans l'outil.
    grilleFiche.innerHTML = `<p class="pp-cta__grille-titre">${ptxT("Plus vous en prenez, moins c'est cher")}</p>` +
      `<div class="pp-cta__grille-row">${cols}<div><span>${ptxT("+ de")} ${t.max_quantite || 100}</span><strong>${ptxT("Devis")}</strong></div></div>` +
      `<p class="pp-cta__grille-note">${g2 ? (data.cotes ? ptxT("Prix par pièce, un emplacement imprimé compris.") : ptxT("Prix par pièce, impression d'une face comprise.")) : ptxT("Prix par pièce, impression comprise.")}</p>` +
      `<p class="pp-cta__grille-note">${ptxT("La 1re pièce est au prix unitaire, les suivantes au prix du palier atteint.")}</p>`;
    grilleFiche.hidden = false;
    // Phrase au-dessus du tableau : prix exacts de la couleur choisie (pièce seule, puis 51 à 100 pièces).
    const phrase = document.querySelector('[data-pp-cta-price]');
    if (phrase) phrase.textContent = `${ptxT("Personnalisé, impression incluse :")} ${money(g1[0])} ${ptxT("la pièce seule, dès")} ${money(g1[t.paliers.length - 1])} ${ptxT("en quantité.")}`;
    const seul = document.querySelector('[data-pp-cta-seul]');
    if (seul) seul.textContent = `${ptxT("Sans impression :")} ${money(v.price)}`;
    const seulBarre = document.querySelector('[data-pp-sticky-seul]'); if (seulBarre) seulBarre.textContent = money(v.price); // barre fixe : même prix (chef 24/10)
  }
  renderGrilleFiche(currentPageVariantId());
  document.addEventListener('variant:change', (e) => { if (e.detail?.variant) renderGrilleFiche(e.detail.variant.id); }, true);
  document.addEventListener('pp:couleur', (e) => renderGrilleFiche(e.detail.id)); // couleur changée dans l'outil : fiche = outil

  const sticky = document.querySelector('[data-pp-sticky]');
  const ctaBtn = document.querySelector('.pp-cta__btn');
  if (sticky && ctaBtn && 'IntersectionObserver' in window) {
    document.body.appendChild(sticky); // hors des conteneurs du thème (position fixe fiable)
    sticky.querySelector('[data-pp-sticky-vierge]')?.addEventListener('click', (e) => {
      const o = document.querySelector('[data-pf-vierge-onglet]');
      if (!o) return;
      e.preventDefault(); o.open = true; o.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    // Barre « Personnaliser » dès que le bouton n'est pas à l'écran : au-dessus (déjà dépassé) ou en dessous (mobile : il était
    // sous la ligne de flottaison sur toutes les fiches, lot 18).
    new IntersectionObserver(([e]) => sticky.classList.toggle('is-shown', e.intersectionRatio < 1), { threshold: [0, 1] }).observe(ctaBtn);
    // Au-dessus de la barre de navigation mobile du thème (mobile-dock) : elle se cache en glissant vers le bas
    // (sa classe « invisible » reste), donc on suit sa position réelle.
    // Bannière de cookies de Shopify (#shopify-pc__banner, en bas) : tant qu'elle est affichée, la barre passe au-dessus.
    const dock = document.querySelector('mobile-dock');
    {
      let attente = 0;
      const hautBas = (el) => {
        if (!el || !el.isConnected) return 0;
        const s = getComputedStyle(el); const r = el.getBoundingClientRect();
        if (s.display === 'none' || s.visibility === 'hidden' || Number(s.opacity) === 0 || r.height < 4 || r.bottom < innerHeight - 8) return 0;
        return Math.max(0, Math.round(innerHeight - r.top));
      };
      const caler = () => {
        attente = 0;
        const elB = document.getElementById('shopify-pc__banner');
        if (elB && !elB.dataset.ppSuivie) { elB.dataset.ppSuivie = '1'; [elB, elB.parentElement].forEach((x) => x && obs.observe(x, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] })); }
        const banniere = hautBas(elB);
        const h = Math.max(hautBas(dock), banniere);
        sticky.style.bottom = h > 4 ? h + 'px' : '';
        document.documentElement.style.setProperty('--pp-banniere', `${banniere}px`);
      };
      const plusTard = () => { if (!attente) attente = requestAnimationFrame(caler); };
      addEventListener('scroll', plusTard, { passive: true }); addEventListener('resize', plusTard);
      dock?.addEventListener('transitionend', caler); dock?.addEventListener('transitionrun', () => setTimeout(caler, 320));
      // La bannière arrive après le chargement et disparaît au clic (Accepter / Refuser) : on la suit.
      const obs = new MutationObserver(plusTard); obs.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('click', () => setTimeout(caler, 350), true);
      // La barre est aussi montrée dès l'arrivée (lot 18), parfois avant que le dock soit en place : recalage quand elle
      // apparaît, quand le dock change de taille, et peu après le chargement.
      new MutationObserver(plusTard).observe(sticky, { attributes: true, attributeFilter: ['class'] });
      if (window.ResizeObserver && dock) new ResizeObserver(plusTard).observe(dock);
      [300, 1000, 2500].forEach((t) => setTimeout(caler, t));
      caler();
    }
  }

  document.querySelectorAll('[data-pp-open]').forEach((b) => b.addEventListener('click', open));
  // Préchargement discret (lot 20) : photos de la couleur affichée sur la fiche, quand le navigateur est libre.
  const precharger = () => {
    const v = data.variants.find((x) => x.id === currentPageVariantId()) || data.variants[0];
    [v?.image, data.face?.image, data.dos?.image, data.face?.images?.[couleurOf(v)], data.dos?.images?.[couleurOf(v)]].filter(Boolean).forEach((u) => loadImage(u));
  };
  const auRepos = (f) => (window.requestIdleCallback ? requestIdleCallback(f, { timeout: 4000 }) : setTimeout(f, 2500));
  if (document.readyState === 'complete') auRepos(precharger); else addEventListener('load', () => auRepos(precharger), { once: true });
  // L'outil ne s'ouvre qu'au clic sur « Personnaliser ». Un lien arrivant avec #personnaliser montre la fiche normale ;
  // seul un rechargement pendant que l'outil est ouvert (history.state.pp) le rouvre.
  if (designDuLien || carteDuLien) open();
  else if (location.hash === '#personnaliser') {
    if (history.state?.pp) open();
    else history.replaceState(history.state, '', location.pathname + location.search);
  }
  $('[data-pp-close]').addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (modal.hidden) return;
    const typing = ['TEXTAREA', 'INPUT'].includes(document.activeElement?.tagName);
    if (e.key === 'Escape') { if (apercu && !apercu.hidden) fermerApercu(); else close(); }
    if ((e.key === 'Delete' || e.key === 'Backspace') && !typing && active()) { e.preventDefault(); action('delete'); }
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'z' && !typing) { e.preventDefault(); if (e.shiftKey) redo(); else undo(); }
  });
  $$('[data-pp-side]').forEach((b) => b.addEventListener('click', () => basculerSide(b.dataset.ppSide)));
  // Clic délégué : marche aussi pour un onglet ajouté plus tard par un autre script (ex. « Idées »).
  $('.pp-tabs').addEventListener('click', (e) => {
    const b = e.target.closest('[data-pp-tab]');
    if (!b) return;
    const ouverte = modal.classList.contains('pp-sheet-open');
    if (mobile() && ouverte && state.tab === b.dataset.ppTab) { feuille(false); return; }
    if (b.dataset.ppTab === 'texte' && state.ready && !canvas().getObjects().some((o) => o.ppType === 'text')) { // texte posé tout de suite
      T.input.focus({ preventScroll: true }); // dans le geste : le clavier s'ouvre aussi sur iPhone
      quickText();
      return;
    }
    setTab(b.dataset.ppTab);
    feuille(true);
  });
  // Poignée de la feuille (mobile) : la referme ; l'ajout d'une image la referme aussi pour voir le résultat.
  const poignee = document.createElement('button');
  poignee.type = 'button';
  poignee.className = 'pp-sheet-handle';
  poignee.setAttribute('aria-label', 'Replier le panneau');
  poignee.innerHTML = '<span></span>';
  poignee.addEventListener('click', () => feuille(false));
  $('.pp-panels').prepend(poignee);
  // Glisser le panneau vers le bas (depuis la poignée, ou depuis le haut du contenu) : il se replie.
  let glisse = null;
  $('.pp-panels').addEventListener('touchstart', (e) => {
    // Karim 23/10 (vidéo, 2:34) : tirer vers le bas dans un panneau remonté en haut (liste Équipe) le repliait ; seule la poignée replie.
    glisse = e.target.closest('.pp-sheet-handle') ? e.touches[0].clientY : null;
  }, { passive: true });
  $('.pp-panels').addEventListener('touchend', (e) => {
    if (glisse !== null && e.changedTouches[0].clientY - glisse > 50) feuille(false);
    glisse = null;
  }, { passive: true });
  fileInput.addEventListener('change', () => feuille(false));
  // Aperçu vide : boutons « Importer une image » / « Ajouter un texte » posés sur le vêtement.
  const vide = document.createElement('div');
  vide.className = 'pp-vide';
  vide.innerHTML = `<button type="button" data-vide-image>${ptxT("Importer une image")}</button><button type="button" data-vide-texte>${ptxT("Ajouter un texte")}</button>`;
  stageWrap.appendChild(vide);
  vide.querySelector('[data-vide-image]').addEventListener('click', () => fileInput.click());
  vide.querySelector('[data-vide-texte]').addEventListener('click', () => quickText());
  /* Variantes de placement des outils à faire valider par Karim (15/10/2026) : ?variante=a (barre en haut),
     b (colonne à gauche), c (barre en bas), d (barre en bas + bouton « + Ajouter »). Sans paramètre : E. */
  const variante = varianteOutil;
  // E (version propre) : rien sur le vêtement ; infos au-dessus, positions + taille + actions sur une ligne dessous.
  if (variante === 'e') {
    modal.classList.add('pp-var-e');
    const ligne = document.createElement('div');
    ligne.className = 'pp-ctrl';
    stage.after(ligne);
    [$('[data-pp-pos]'), taille].forEach((el) => el && ligne.appendChild(el));
    const zb = $('[data-pp-zoom]');
    // Actions du design (dupliquer, centrer, miroir, devant / derrière, supprimer) dans la ligne du haut, à la place
    // de la taille imprimée, quand un élément est sélectionné.
    zb?.before($('[data-pp-float]'));
    if (zb) zb.title = ptxT("Zoom");
    addBtn.textContent = ptxT("Aperçu avant mise au panier"); // ouvre l'aperçu final, puis « Ajouter au panier » (Karim 21/10)
  }
  if (/^[abcd]$/.test(variante)) {
    modal.classList.add(`pp-var-${variante}`);
    if (variante === 'd') {
      const fab = document.createElement('div');
      fab.className = 'pp-fab';
      fab.innerHTML = `<div class="pp-fab__menu" hidden><button type="button" data-fab-image>${ptxT("Image")}</button><button type="button" data-fab-texte>${ptxT("Texte")}</button></div><button type="button" class="pp-fab__btn" aria-label="${ptxT("Ajouter")}">${ptxT("+ Ajouter")}</button>`;
      stageWrap.appendChild(fab);
      const menu = fab.querySelector('.pp-fab__menu');
      fab.querySelector('.pp-fab__btn').addEventListener('click', () => { menu.hidden = !menu.hidden; });
      fab.querySelector('[data-fab-image]').addEventListener('click', () => { menu.hidden = true; fileInput.click(); });
      fab.querySelector('[data-fab-texte]').addEventListener('click', () => { menu.hidden = true; quickText(); });
    }
  }
  $('[data-pp-undo]').addEventListener('click', undo);
  $('[data-pp-redo]').addEventListener('click', redo);
  fileInput.addEventListener('change', () => { [...fileInput.files].forEach(addImage); fileInput.value = ''; });
  // Fichier préparé sur la page « Préparer mon visuel » (printtex-visuel-transfert.js) : placé une seule fois.
  if (window.ptxTransfert) window.ptxTransfert.reprendre('perso').then((f) => f && addImage(f)).catch(() => {});
  // Glisser-déposer : sur la zone d'import et directement sur le produit.
  [$('[data-pp-drop]'), stageWrap].forEach((el) => {
    el.addEventListener('dragover', (e) => { e.preventDefault(); el.classList.add('is-drag'); });
    el.addEventListener('dragleave', () => el.classList.remove('is-drag'));
    el.addEventListener('drop', (e) => { e.preventDefault(); el.classList.remove('is-drag'); [...e.dataTransfer.files].forEach(addImage); });
  });
  $('[data-pp-add-text]').addEventListener('click', quickText);
  // Taper sans texte sélectionné crée un texte (une seule fois, même si l'on tape vite).
  let creating = false;
  // Le champ texte appartient à l'onglet Texte : le soulignement suit toujours le panneau affiché.
  T.input.addEventListener('focus', () => { if (state.tab !== 'texte') setTab('texte'); });
  // Karim 23/10 : le texte ne se pose pas pendant la frappe. Le bouton « Valider le texte » (ou Entrée) le met sur le
  // vêtement avec une entrée animée ; le champ signale juste qu'une validation attend.
  T.input.addEventListener('input', () => { updateTextLabels(); $('[data-pp-ok]')?.classList.toggle('is-attente', !!T.input.value.trim()); });
  T.input.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); validerTexte(); } });
  // Entrée en motion design : opacité 0 → 1, échelle 0,92 → 1, montée de 10 px, 360 ms, courbe douce (transform + opacité
  // seulement) ; fondu court de 150 ms si l'utilisateur préfère moins de mouvement.
  function animerEntree(o) {
    const c = canvas(); const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sx = o.scaleX; const sy = o.scaleY; const top = o.top; const duree = reduit ? 150 : 360; const t0 = performance.now();
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    // Lot 30 : une action du client pendant l'animation (rotation, taille, déplacement → fitInZone interactif) l'annule ;
    // sa dernière image ne remet plus l'échelle et la position d'avant (un texte tourné à 90° ressortait de la zone).
    const etat = { annule: false }; o.__entree = etat;
    o.set({ opacity: 0 });
    const pas = (now) => {
      if (etat.annule) { if (o.__entree === etat) o.__entree = null; o.set({ opacity: 1 }); o.setCoords(); c.requestRenderAll(); return; }
      const k = Math.max(0, Math.min(1, (now - t0) / duree)); const e = ease(k); // la 1re image rAF peut précéder t0
      o.set(reduit ? { opacity: e } : { opacity: e, scaleX: sx * (0.92 + 0.08 * e), scaleY: sy * (0.92 + 0.08 * e), top: top + 10 * (1 - e) });
      o.setCoords(); c.requestRenderAll();
      if (k < 1) requestAnimationFrame(pas); else { o.set({ opacity: 1, scaleX: sx, scaleY: sy, top }); o.setCoords(); c.requestRenderAll(); if (o.__entree === etat) o.__entree = null; }
    };
    requestAnimationFrame(pas);
  }
  async function validerTexte() {
    if (!T.input.value.trim()) { T.input.focus(); return; }
    if (creating) return; creating = true;
    const cur = active(); const creer = !(cur && cur.ppType === 'text');
    try { await applyText(creer); } finally { creating = false; }
    const o = active(); if (creer && o) animerEntree(o);
    snapshot(); $('[data-pp-ok]')?.classList.remove('is-attente');
    // Chef 23/10 (parcours client) : la validation ferme le clavier, sinon la barre d'onglets et « Aperçu avant panier »
    // restent cachés ; sur le rail la carte Texte reste ouverte (couleur, police, nouveau texte), ailleurs la feuille se replie.
    document.activeElement?.blur?.();
    if (!modal.classList.contains('pp-rail')) feuille(false);
  }
  [T.color, T.size, T.curve, T.spacing, T.stroke, T.strokeWidth].forEach((el) => el.addEventListener('input', textChanged));
  T.color.addEventListener('input', () => { couleurTexteChoisie = true; majAnneaux(); });
  [T.bold, T.italic].forEach((b) => b.addEventListener('click', () => { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') !== 'true'); textChanged(); }));
  $$('[data-pp-action]').forEach((b) => b.addEventListener('click', () => action(b.dataset.ppAction)));
  // Intensité du retrait : recalcul pendant le glissement (attente courte pour rester fluide sur mobile).
  let attenteIntensite;
  $('[data-pp-intensite-curseur]')?.addEventListener('input', (e) => {
    clearTimeout(attenteIntensite);
    const tol = Number(e.target.value);
    attenteIntensite = setTimeout(() => {
      const obj = canvas().getActiveObject();
      if (obj?.ppType === 'image' && obj.ppFond !== 'garder') setFond(obj, obj.ppFond, tol, obj.ppCouleur, false);
    }, 120);
  });
  // Mobile : « Options » ouvre / replie couleur à retirer, intensité et conseil (panneau d'une ligne sinon).
  $('[data-pp-fond-plus]')?.addEventListener('click', (e) => {
    const box = $('[data-pp-fond]'); const ouvert = !box.classList.contains('is-ouvert');
    box.classList.toggle('is-ouvert', ouvert); e.currentTarget.setAttribute('aria-expanded', String(ouvert));
    window.dispatchEvent(new Event('resize'));
  });
  $('[data-pp-detourer]')?.addEventListener('click', async (e) => {
    const b = e.currentTarget;
    const obj = canvas().getActiveObject();
    const a = obj?.ppType === 'image' ? originaux.get(obj.ppId) : null;
    if (!a || b.disabled) return;
    const texte = b.textContent;
    b.disabled = true; b.textContent = a.masqueIA ? ptxT("Détourage…") : ptxT("Détourage… (quelques secondes)");
    try {
      await masqueIA(a);
      const cote = Math.max(obj.getScaledWidth(), obj.getScaledHeight());
      setFond(obj, 'detoure', obj.ppTol ?? TOL, obj.ppCouleur, false);
      obj.scale(cote / Math.max(obj.width, obj.height)); fitInZone(obj); obj.setCoords(); canvas().requestRenderAll(); onSelection();
    } catch (err) {
      showError(ptxT("Le détourage automatique n'a pas pu se faire sur cet appareil. Essayez « Retirer le fond » ou une image déjà détourée (PNG)."));
    }
    b.disabled = false; b.textContent = texte;
  });
  $$('[data-pp-fond-mode]').forEach((b) => b.addEventListener('click', () => {
    const obj = active();
    if (obj?.ppType === 'image' && obj.ppFond !== b.dataset.ppFondMode) setFond(obj, b.dataset.ppFondMode, obj.ppTol ?? TOL, obj.ppCouleur, false);
  }));
  $('[data-pp-fond-couleurs]')?.addEventListener('click', (e) => {
    const b = e.target.closest('[data-pp-fond-couleur]');
    const obj = active();
    const a = obj && originaux.get(obj.ppId);
    if (!b || !a) return;
    setFond(obj, obj.ppFond === 'garder' ? 'contour' : obj.ppFond, obj.ppTol ?? TOL, a.palette[+b.dataset.ppFondCouleur], false);
  });
  // Panneau « Fond de l'image » à côté du vêtement (ordinateur : à gauche ; mobile : sous le vêtement), bien visible.
  { const f = $('[data-pp-fond]'); const ligne = $('.pp-ctrl'); if (f) { f.classList.add('pp-fondbox'); if (window.matchMedia('(min-width: 900px)').matches) ($('[data-pp-logo-refait]') || $('[data-pp-drop]'))?.after(f); else (ligne || stage).after(f); } }
  /* ---------- Aperçu final avant le panier (15/10/2026) ----------
     « Ajouter au panier » ouvre d'abord « Votre aperçu » : face et dos en grand, couleur choisie, design à sa taille et
     sa place, sans poignées ni pointillés (mêmes images que « Face, aperçu » de la commande). Modifier / Ajouter au panier. */
  let apercu = null;
  let apercuJeton = 0;
  /* BAT (idée métier 2, 17/10/2026) : fiche imprimable (Enregistrer en PDF) avec, par emplacement, l'aperçu sur le
     vêtement, la taille imprimée en cm, la position et la consigne de pose ; référence et date. Pour les pros et les
     commandes sur devis : le client la valide ou la transmet, l'atelier imprime exactement ça. */
  async function telechargerBat() {
    const w = window.open('', '_blank');
    if (!w) { showError(ptxT("Autorisez les fenêtres pour ce site afin de télécharger le BAT.")); return; }
    w.document.write(`<p style="font-family:system-ui;padding:20px">${ptxT("Préparation du BAT…")}</p>`);
    const sides = usedSides();
    const ref = `BAT-${Date.now().toString(36).toUpperCase()}`;
    const vers64 = (b) => new Promise((ok) => { const r = new FileReader(); r.onload = () => ok(r.result); r.readAsDataURL(b); });
    const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const blocs = [];
    for (const s of sides) {
      const pf = await printFile(s);
      const ca = consigneAtelier(s, pf);
      const textes = state.canvases[s].getObjects().filter((o) => o.ppType === 'text').map((o) => o.ppProps?.text).filter(Boolean);
      blocs.push(`<section><img src="${await vers64(await previewFile(s))}" alt=""><div><h2>${esc(SIDES[s])}</h2><ul>
        <li><b>${ptxT("Taille imprimée :")}</b> ${pf.wCm.toFixed(1).replace('.', ',')} × ${pf.hCm.toFixed(1).replace('.', ',')} cm</li>
        <li><b>${ptxT("Position :")}</b> ${esc(pf.position)}${angleCote(s) ? ` ${ptxT(", pivoté")} ${angleCote(s)}°` : ''}</li>
        ${ca ? `<li><b>${ptxT("Pose :")}</b> ${esc(ca.texte)}</li>` : ''}
        ${textes.length ? `<li><b>${ptxT("Textes :")}</b> ${textes.map((t) => `« ${esc(t)} »`).join(', ')}</li>` : ''}
        <li><b>${ptxT("Qualité :")}</b> ${pf.faible ? `${ptxT("faible (")}${pf.reelle} ${ptxT("dpi) : rendu flou possible")}` : 'bonne'}</li></ul></div></section>`);
    }
    const tailles = Object.entries(state.qty).filter(([, q]) => q > 0).map(([t, q]) => (t ? `${t} × ${q}` : `${q}`)).join(', ');
    const date = new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
    w.document.open();
    w.document.write(`<!doctype html><html lang="fr"><head><meta charset="utf-8"><title>${ref}, ${esc(data.title)}</title><style>
      body{font:14px/1.45 system-ui,Segoe UI,Roboto,sans-serif;color:#171717;margin:24px}h1{font-size:20px;margin:0}h2{font-size:16px;margin:0 0 6px}
      header{display:flex;justify-content:space-between;gap:16px;border-bottom:2px solid #171717;padding-bottom:10px;margin-bottom:14px}
      section{display:flex;gap:18px;align-items:flex-start;break-inside:avoid;margin:0 0 16px}img{width:260px;border:1px solid #e5e5e5;border-radius:8px}
      ul{margin:0;padding-left:18px}.sig{margin-top:24px;display:flex;gap:30px}.sig div{flex:1;border-top:1px solid #737373;padding-top:6px;color:#525252}
      small{color:#525252}@media print{button{display:none}body{margin:12mm}}
    </style></head><body><header><div><h1>${ptxT("Bon à tirer (BAT)")}</h1><small>${ptxT("Printtex, 5 rue Planchat, 75020 Paris, 01 86 04 31 65, info@printtex.fr")}</small></div>
      <div style="text-align:right"><b>${ref}</b><br>${date}</div></header>
      <p><b>${esc(data.title)}</b>${couleurIdx >= 0 ? ` ${ptxT(", couleur")} ${esc(couleurOf(state.variant))}` : ''}, ${esc(tailles)}, ${esc(priceEl.dataset.total || '')}</p>
      ${blocs.join('')}
      <p><small>${ptxT("Les couleurs à l'écran peuvent légèrement différer du rendu sur textile. Tailles et positions données à ± 1 cm. Produit personnalisé : pas de droit de rétractation (art. L221-28 du Code de la consommation).")}</small></p>
      <div class="sig"><div>${ptxT("Bon pour accord, date et signature du client")}</div><div>${ptxT("Printtex")}</div></div>
      <p><button onclick="print()">${ptxT("Enregistrer en PDF / imprimer")}</button></p></body></html>`);
    w.document.close();
    setTimeout(() => { try { w.print(); } catch (e) { /* le client imprime avec le bouton */ } }, 400);
  }

  /* Date de l'événement (idée métier 10, 17/10/2026) : reçu à temps en standard, en express, ou trop juste. */
  function repondreDate(valeur) {
    const rep = apercu.querySelector('[data-evenement-rep]');
    const D = window.printtexDateLivraison;
    state.evenement = valeur || '';
    if (!valeur || !D) { rep.hidden = true; return; }
    const voulu = new Date(valeur + 'T12:00:00Z'); // printtex-date-livraison compte à midi UTC
    const r = D.calcul(document.querySelector('[data-pdl]')?.dataset.pdlDelaiLong === 'true');
    const jour = (d) => d.toLocaleDateString('fr-FR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
    rep.className = 'pp-evenement__rep';
    if (voulu >= r.recuMax) { rep.textContent = `${ptxT("Oui, livré avant le")} ${jour(voulu)} ${ptxT("en standard (au plus tard le")} ${jour(r.recuMax)}).`; rep.classList.add('is-ok'); }
    else if (voulu >= r.express) { rep.textContent = `${ptxT("Choisissez l'express (18 €) au paiement pour l'avoir avant le")} ${jour(voulu)} ${ptxT(": reçu le")} ${jour(r.express)}.`; rep.classList.add('is-moyen'); }
    else { rep.innerHTML = `${ptxT("Trop court pour la livraison : appelez-nous au")} <a href="tel:+33186043165">01 86 04 31 65</a>${ptxT(", on trouve une solution (retrait à l'atelier possible).")}`; rep.classList.add('is-non'); }
    rep.hidden = false;
  }

  // Conseils métier avant de commander (idées 4 et 6, 17/10/2026) : couleurs fluo, visuel large sur petites tailles.
  function conseilsCommande(sides) {
    const c = [];
    const PETITES = /^(xxs|xs|3xs|\d{1,2} ?ans|\d{1,2}\/\d{1,2})/i;
    const petites = Object.entries(state.qty).filter(([t, q]) => q > 0 && PETITES.test(t)).map(([t]) => t);
    const largeMax = Math.max(0, ...sides.flatMap((s) => state.canvases[s].getObjects().map((o) => o.getScaledWidth() * zoneOf(s).cmW / LOGICAL_W)));
    if (petites.length && largeMax > 24) c.push(`${ptxT("Visuel de")} ${Math.round(largeMax)} ${ptxT("cm de large : sur les petites tailles (")}${petites.join(', ')}${ptxT("), il peut toucher les coutures. Nous le réduisons si besoin, ou commandez-le en 2 lignes (petites tailles plus petit).")}`);
    const fluo = sides.some((s) => state.canvases[s].getObjects().some((o) => {
      const a = o.ppType === 'image' && originaux.get(o.ppId);
      // Fluo = très lumineux et très saturé, dans les teintes fluo (vert / jaune / rose) ; un rouge ou un bleu franc s'imprime bien.
      return a && (a.palette || []).some(([r, g, b]) => { const mx = Math.max(r, g, b); const mn = Math.min(r, g, b); return mx > 220 && (mx - mn) / mx > 0.8 && (g > 200 || (r > 230 && b > 110)); });
    }));
    if (fluo) c.push(ptxT("Couleurs très vives (fluo) dans votre image : à l'impression elles seront un peu moins éclatantes qu'à l'écran. Pour une couleur exacte (Pantone), précisez-la dans la note de commande."));
    return c;
  }

  async function ouvrirApercu() {
    const jeton = ++apercuJeton;
    showError('');
    await textJob; // texte en cours de frappe appliqué avant l'aperçu
    Object.values(state.canvases).forEach((c) => { c.getActiveObject()?.exitEditing?.(); c.renderAll(); });
    const sides = usedSides();
    if (!sides.length) { showError(ptxT("Ajoutez une image ou un texte sur le produit avant de commander.")); return; }
    if (!Object.values(state.qty).some((q) => q > 0)) { setTab('quantites'); showError(ptxT("Choisissez au moins une taille.")); return; }
    // Lot 29 (chef, 23/10) : plus d'arrêt « Choisissez votre taille » quand une taille est déjà affichée (« XS ×1 ») : un
    // appui suffit ; l'aperçu rappelle les tailles avec un bouton Modifier (lot 19 : le contrôle de taille se fait là).
    if (!apercu) {
      apercu = document.createElement('div');
      apercu.className = 'pp-apercu';
      apercu.setAttribute('role', 'dialog');
      apercu.setAttribute('aria-modal', 'true');
      apercu.setAttribute('aria-label', ptxT("Votre aperçu"));
      apercu.innerHTML = '<div class="pp-apercu__boite"><div class="pp-apercu__haut"><button type="button" class="pp-apercu__retour" data-modifier>' + ptxT("← Retour à l’outil") + '</button><p class="pp-apercu__titre">' + ptxT("Votre aperçu") + '</p></div><div class="pp-apercu__3d" data-apercu-3d hidden></div><div class="pp-apercu__vues" data-vues></div>'
        + '<p class="pp-apercu__recap" data-recap></p>'
        // Relecture des textes (idée métier 7, 17/10/2026) : une faute imprimée = une pièce à refaire.
        + '<div class="pp-relire" data-relire hidden><p class="pp-relire__titre" data-relire-titre>' + ptxT("Vos textes (imprimés tels quels) :") + '</p><ul class="pp-relire__liste" data-relire-liste></ul>'
        + '<div class="pp-relire__etape" data-relire-etape hidden><p>' + ptxT("Pas de retour possible sur un texte personnalisé : une faute est imprimée telle quelle.") + '</p>'
        + '<div class="pp-relire__btns"><button type="button" class="pp-btn" data-relire-corriger>' + ptxT("Corriger") + '</button><button type="button" class="pp-add is-ready" data-relire-bon>' + ptxT("C'est bon, j'ajoute") + '</button></div></div>'
        + '</div>'
        + '<ul class="pp-conseils" data-conseils hidden></ul>'
        // Options repliées : rien à lire si on n'en a pas besoin.
        + '<details class="pp-apercu__options"><summary>' + ptxT("Une date à respecter ? Le BAT en PDF ?") + '</summary>'
        + '<label class="pp-evenement">' + ptxT("Date de votre événement") + ' <input type="date" data-evenement></label><p class="pp-evenement__rep" data-evenement-rep hidden></p>'
        + '<button type="button" class="pp-apercu__bat" data-bat>' + ptxT("Télécharger le BAT (PDF)") + '</button></details>'
        + '<p class="pp-droits">' + ptxT("En commandant, vous certifiez avoir le droit d'imprimer ces visuels (logos de marques, personnages, photos d'autrui).") + '</p>'
        + '<div class="pp-apercu__actions"><button type="button" class="pp-btn pp-apercu__modifier" data-modifier>' + ptxT("← Modifier") + '</button>'
        + '<button type="button" class="pp-add is-ready" data-confirmer>' + ptxT("Ajouter au panier") + '</button></div></div>';
      modal.appendChild(apercu);
      apercu.querySelectorAll('[data-modifier]').forEach((b) => b.addEventListener('click', fermerApercu));
      apercu.querySelector('[data-vues]').addEventListener('click', (e) => {
        const b = e.target.closest('[data-modifier-face]');
        if (!b) return;
        fermerApercu();
        setSide(b.dataset.modifierFace);
      });
      apercu.querySelector('[data-bat]').addEventListener('click', telechargerBat);
      apercu.querySelector('[data-evenement]').addEventListener('change', (e) => repondreDate(e.target.value));
      apercu.querySelector('[data-relire-corriger]').addEventListener('click', () => {
        fermerApercu();
        const t = Object.entries(state.canvases).flatMap(([s, c]) => c.getObjects().filter((o) => o.ppType === 'text').map((o) => [s, c, o]))[0];
        if (t) { setSide(t[0]); t[1].setActiveObject(t[2]); t[1].requestRenderAll(); setTab('texte'); }
      });
      apercu.querySelector('[data-relire-bon]').addEventListener('click', () => { apercu.dataset.relu = '1'; apercu.querySelector('[data-confirmer]').click(); });
      apercu.querySelector('[data-confirmer]').addEventListener('click', async () => {
        // Chef 23/10 (Karim : « un appui suffit ») : plus d'étape bloquante « Vérifiez l'orthographe » ; les textes restent
        // listés dans l'aperçu (dernier filet) et le correcteur du téléphone souligne les mots douteux pendant la saisie.
        const b = apercu.querySelector('[data-confirmer]');
        b.disabled = true; b.textContent = ptxT("Préparation…");
        await addToCart();
        b.disabled = false; b.textContent = ptxT("Ajouter au panier");
        if (!errorEl.hidden) fermerApercu();
      });
    }
    const vues = apercu.querySelector('[data-vues]');
    vues.innerHTML = sides.map((s) => `<figure><div class="pp-apercu__charge"></div><figcaption>${SIDES[s]} <button type="button" class="pp-apercu__face" data-modifier-face="${s}">${ptxT("Modifier")} ${data.cotes ? `« ${SIDES[s]} »` : s === 'dos' ? ptxT("le dos") : ptxT("la face")}</button></figcaption></figure>`).join('');
    const tailles = Object.entries(state.qty).filter(([, q]) => q > 0).map(([t, q]) => (t ? `${t} × ${q}` : `${q}`)).join(', ');
    // Une seule pièce : le prix d'une 2e pièce, au moment de valider (lot 20).
    const g = data.tarifs && totalQty() === 1 ? grilleFor(Math.max(1, sides.length)) : null;
    const deuxieme = g && g[1] && g[1] < g[0] ? `<span class="pp-apercu__plus">${ptxT("Une 2")}<sup>e</sup> ${ptxT("pièce ?")} ${money(g[1])} ${ptxT("au lieu de")} ${money(g[0])}</span>` : '';
    apercu.querySelector('[data-recap]').innerHTML = deuxieme + `${couleurIdx >= 0 ? `<strong>${couleurOf(state.variant)}</strong>, ` : ''}${tailles}, <strong>${priceEl.dataset.total || ''}</strong>`
      + (tailleIdx >= 0 ? ` <button type="button" class="pp-apercu__tailles" data-apercu-tailles>${ptxT("Changer la taille")}</button>` : '');
    apercu.querySelector('[data-apercu-tailles]')?.addEventListener('click', () => { fermerApercu(); setTab('quantites'); });
    // Textes à relire (tous les côtés), affichés sans rien bloquer (Karim : pas de case obligatoire).
    const textes = sides.flatMap((s) => state.canvases[s].getObjects().filter((o) => o.ppType === 'text' && o.ppProps?.text?.trim()).map((o) => [s, o.ppProps.text.trim()]));
    const relire = apercu.querySelector('[data-relire]');
    relire.hidden = !textes.length;
    delete apercu.dataset.relu;
    relire.classList.remove('is-rappel');
    apercu.querySelector('[data-relire-etape]').hidden = true;
    apercu.querySelector('[data-relire-titre]').textContent = ptxT("Vos textes (imprimés tels quels) :");
    apercu.querySelector('[data-relire-liste]').innerHTML = textes.map(([s, t]) => `<li><span>${SIDES[s]}</span> « ${t.replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]))} »</li>`).join('');
    const conseils = conseilsCommande(sides);
    const ul = apercu.querySelector('[data-conseils]');
    ul.innerHTML = conseils.map((t) => `<li>${t}</li>`).join('');
    ul.hidden = !conseils.length;
    clearTimeout(apercu._sortie); apercu.classList.remove('pp-apercu--sortie'); // réouverture pendant la fermeture : on reprend sans attendre
    apercu.hidden = false;
    apercu.classList.remove('pp-apercu--entree'); void apercu.offsetWidth; apercu.classList.add('pp-apercu--entree'); // fenêtre qui monte et apparaît (320 ms)
    modal.classList.add('has-apercu');
    for (const [i, s] of sides.entries()) {
      const url = URL.createObjectURL(await previewFile(s));
      if (jeton !== apercuJeton) return; // aperçu rouvert entre-temps : on n'écrit pas d'ancienne image
      const fig = vues.children[i];
      if (fig) fig.querySelector('.pp-apercu__charge').outerHTML = `<img src="${url}" alt="Aperçu ${SIDES[s].toLowerCase()}">`;
      // Lot 30 (A2, B8) : le fichier qui part vraiment à l'impression, sur damier CSS (jamais dans le fichier lui-même).
      if (fig) { try { const z = renderZone(s, 480); fig.insertAdjacentHTML('beforeend', `<div class="pp-apercu__fichier"><span class="pp-damier"><img src="${z.toDataURL('image/png')}" alt="${ptxT("Fichier imprimé")} ${SIDES[s].toLowerCase()}"></span><small>${ptxT("Voici exactement ce qui sera imprimé")}</small></div>`); } catch (e) { /* vignette facultative */ } }
    }
    monter3D(jeton, sides);
  }
  // Lot 30 (Karim 23/10) : le vêtement en 3D au-dessus des aperçus, pour tous les produits à une face (+ dos). three.js et le
  // module ne se chargent qu'ici ; échec (WebGL, réseau, produit à plusieurs emplacements) = aperçu simple, sans message.
  let vue3d = null; let vues3d = null;
  async function monter3D(jeton, sides) {
    const boite = apercu.querySelector('[data-apercu-3d]');
    if (!boite || !data.url3d || data.jambes || data.cotes || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const t0 = performance.now();
    try {
      // 3D seulement pour un produit qui a des vues 3D (chef 24/10) : la liste (3 ko) est lue d'abord ; sinon rien n'est chargé.
      vues3d ??= data.vues3dUrl ? await fetch(data.vues3dUrl).then((r) => (r.ok ? r.json() : {})).catch(() => ({})) : {};
      if (!vues3d[data.handle] || jeton !== apercuJeton) return;
      const { monterTshirt3D } = await import(data.url3d);
      const face = await mockupSource('face'); if (!face.el) return;
      const dos = data.dos ? await mockupSource('dos') : null;
      const vraiDos = dos && !dos.mirror ? dos : null; // dos « miroir de la face » : le module se sert de la face
      // Vraies vues Ralawise de la couleur (dos, côté) quand elles existent : plus juste que la face retournée ou le côté estimé.
      const vraies = vues3d[data.handle]?.[couleurOf(state.variant)] || {};
      const zone = (s, src) => { const W = src.el.naturalWidth || src.el.width, H = src.el.naturalHeight || src.el.height; const r = zoneRect(s, src, W, H); return [r.left / W, r.top / H, r.width / W, r.height / H]; };
      const visuel = (s) => (sides.includes(s) ? renderZone(s, 1200) : null);
      if (jeton !== apercuJeton) return;
      boite.innerHTML = ''; boite.hidden = false; apercu.classList.add('has-3d');
      vue3d = await monterTshirt3D(boite, { photos: { face: face.el, dos: vraies.dos || (vraiDos ? vraiDos.el : null), cote: vraies.cote || null }, visuelFace: visuel('face'), visuelDos: dos ? visuel('dos') : null, zoneFace: zone('face', face), zoneDos: dos ? zone('dos', dos) : null });
      if (jeton !== apercuJeton) { vue3d.detruire(); vue3d = null; return; }
      boite.dataset.pp3dMs = Math.round(performance.now() - t0); // vitesse de montage, lue par les tests
    } catch (e) { boite.hidden = true; apercu.classList.remove('has-3d'); vue3d = null; console.warn('3D indisponible :', e.message); }
  }
  function fermerApercu() {
    if (!apercu || apercu.hidden) return;
    // Apple : sortie par le chemin d'entrée (redescend et s'efface), masquage à la fin ; 220 ms, 150 ms si moins d'animations.
    apercu.classList.remove('pp-apercu--entree'); apercu.classList.add('pp-apercu--sortie');
    if (vue3d) { vue3d.detruire(); vue3d = null; }
    clearTimeout(apercu._sortie); apercu._sortie = setTimeout(() => { apercu.classList.remove('pp-apercu--sortie'); apercu.hidden = true; }, 230);
    modal.classList.remove('has-apercu');
    Object.values(state.canvases).forEach((c) => c.requestRenderAll());
    drawMockup();
    // Mobile : au retour (onglet Tailles ouvert…), la scène n'a sa taille finale qu'après la mise en page : on recalcule.
    requestAnimationFrame(() => requestAnimationFrame(drawMockup));
    setTimeout(drawMockup, 350);
  }
  $('[data-pp-logo-refait-case]')?.addEventListener('change', (e) => { state.logoRefait = e.target.checked; majLogoRefait(); });
  Object.values(state.canvases).forEach((c) => { c.on('object:added', majLogoRefait); c.on('object:removed', majLogoRefait); });
  {
    const ligne = document.createElement('div');
    ligne.className = 'pp-img-actions'; ligne.dataset.ppImgActions = ''; ligne.hidden = true;
    ligne.innerHTML = `<button type="button" class="pp-btn" data-pp-img-changer>${ptxT("Changer d'image")}</button><button type="button" class="pp-btn pp-img-actions__retirer" data-pp-img-retirer>× ${ptxT("Retirer l'image")}</button>`;
    const panneauImage = $('[data-pp-panel="image"]'); if (panneauImage) panneauImage.prepend(ligne); else ($('[data-pp-drop]'))?.after(ligne);
    ligne.querySelector('[data-pp-img-changer]').addEventListener('click', () => { state.remplacer = active(); fileInput.click(); });
    ligne.querySelector('[data-pp-img-retirer]').addEventListener('click', () => action('delete'));
  }
  addBtn.addEventListener('click', ouvrirApercu);
  $('[data-pp-bas-apercu]')?.addEventListener('click', () => addBtn.click());
  $('[data-pp-ok]')?.addEventListener('click', () => validerTexte()); // « Valider le texte » : pose (ou met à jour) le texte, replie le clavier // onglet Tailles en bas : même chemin (mode Équipe compris)
  // Zoom : bouton Zoom sur la zone / Vue entière ; pincer à deux doigts (mobile) de 1× à 4×.
  $('[data-pp-zoom]')?.addEventListener('click', () => setVue(vue.mode === 'entier' ? 'zone' : 'entier', true));
  // Fabric garde en mémoire la position de la zone à l'écran : on la recalcule à chaque toucher / clic, sinon après un
  // changement de mise en page (panneau ouvert, recadrage, zoom) le doigt sélectionne à côté du design.
  ['pointerdown', 'mousedown', 'touchstart'].forEach((ev) => stageWrap.addEventListener(ev, () => {
    Object.values(state.canvases).forEach((c) => c.calcOffset());
  }, { capture: true, passive: true }));
  let pince = null; let pinceRaf = 0;
  const ecartDoigts = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
  stageWrap.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 2) return;
    e.preventDefault(); e.stopPropagation();
    const actuel = vue.mode === 'zone' ? vue.zoomZone : Number(vue.mode) || 1;
    pince = { d: ecartDoigts(e.touches), z: actuel };
    vue.auto = false;
  }, { capture: true, passive: false });
  stageWrap.addEventListener('touchmove', (e) => {
    if (!pince || e.touches.length !== 2) return;
    e.preventDefault(); e.stopPropagation();
    const z = Math.min(4, Math.max(1, pince.z * ecartDoigts(e.touches) / pince.d));
    vue.mode = z < 1.05 ? 'entier' : z;
    cancelAnimationFrame(pinceRaf);
    pinceRaf = requestAnimationFrame(drawMockup);
  }, { capture: true, passive: false });
  stageWrap.addEventListener('touchend', (e) => { if (pince && e.touches.length < 2) pince = null; }, { capture: true });
  window.addEventListener('resize', () => { if (!modal.hidden) drawMockup(); });

  /* ---------- Accès pour les modules (printtex-modeles.js : onglet « Idées ») ----------
     Seul lien entre l'outil et ses modules : ils ajoutent leurs propres onglets et éléments par cette API. */
  /* ---------- Téléphone : rail d'icônes + menus en carte (lot 28, maquette A choisie par Karim le 19/10) ---------- */
  function railLargeur() { return modal.classList.contains('pp-rail') && !modal.classList.contains('pp-bas3') ? 64 : 0; }
  let railEl = null; let railCarteEl = null;
  const RAIL_ICO = {
    position: '<rect x="4" y="4" width="16" height="16" rx="2"></rect><circle cx="12" cy="10" r="2.5"></circle><path d="M8 17h8"></path>',
    taille: '<path d="M4 9V4h5M20 15v5h-5M4 4l7 7M20 20l-7-7"></path>',
    apercu: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"></path><circle cx="12" cy="12" r="3"></circle>',
    equipe: '<circle cx="9" cy="8" r="3"></circle><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6"></path><circle cx="17" cy="9" r="2.5"></circle><path d="M16 14c2.8 0 5 2.2 5 5"></path>',
    idees: '<path d="M9 18h6M10 21h4M12 3a6 6 0 00-4 10.5c.7.7 1 1.5 1 2.5h6c0-1 .3-1.8 1-2.5A6 6 0 0012 3z"></path>',
    image: '<rect x="3" y="4" width="18" height="16" rx="3"></rect><circle cx="9" cy="10" r="2"></circle><path d="M21 16l-5-5-9 9"></path>',
    texte: '<path d="M5 6V4h14v2M12 4v16M9 20h6"></path>',
    couleur: '<path d="M8 3l-5 4 3 4 2-1v11h8V10l2 1 3-4-5-4c-1 2-2 3-4 3s-3-1-4-3z"></path>',
    quantites: '<path d="M4 20V10M10 20V4M16 20v-8M22 20H2"></path>',
  };
  const RAIL_NOMS = { image: ptxT("Image"), texte: ptxT("Texte"), couleur: ptxT("Couleur"), position: ptxT("Position"), taille: ptxT("Taille"), quantites: ptxT("Tailles"), idees: ptxT("Idées"), apercu: ptxT("Aperçu"), equipe: ptxT("Équipe"), fond: ptxT("Fond") };
  function railInstaller() {
    if (railEl || !modal.classList.contains('pp-tiroir')) return;
    if (modal.classList.contains('pp-glisse')) glisseQuitter();
    modal.classList.add('pp-rail');
    tiroirEl.style.height = '';
    const panels = $('.pp-panels');
    // Menus Position et Taille : les réglages existants (mêmes boutons, mêmes règles), déplacés dans une carte.
    const pPos = document.createElement('div');
    pPos.className = 'pp-panel'; pPos.dataset.ppPanel = 'position'; pPos.hidden = true;
    const pos = $('[data-pp-pos]'); if (pos) pPos.appendChild(pos);
    if (data.sides ? data.sides.includes('dos') : true) {
      pPos.insertAdjacentHTML('beforeend', `<div class="pp-rail__cote"><button type="button" class="pp-btn" data-rail-cote="face">${ptxT("Face")}</button><button type="button" class="pp-btn" data-rail-cote="dos">${ptxT("Dos")}</button></div>`);
      pPos.querySelectorAll('[data-rail-cote]').forEach((b) => b.addEventListener('click', () => { basculerSide(b.dataset.railCote); railCarte('position'); }));
    }
    // Karim 23/10 (vidéo, 2:25) : un seul onglet « Tailles » (celles du vêtement) ; la taille du visuel se règle ici, sous la position.
    pPos.insertAdjacentHTML('beforeend', `<p class="pp-panel__titre">${ptxT("Taille du visuel")}</p>`);
    pPos.appendChild(taille);
    pPos.insertAdjacentHTML('beforeend', `<p class="pp-rail__aide">${ptxT("Touchez votre image ou votre texte sur le vêtement pour régler sa taille.")}</p>`);
    panels.append(pPos);
    // « Fond de l'image » reste accessible depuis le menu Image.
    if ($('[data-pp-panel="fond"]') && !$('[data-rail-fond]')) {
      $('[data-pp-panel="image"]')?.insertAdjacentHTML('beforeend', `<button type="button" class="pp-btn pp-rail__fond" data-rail-fond>${ptxT("Fond de l'image")}</button>`);
      $('[data-rail-fond]')?.addEventListener('click', () => { setTab('fond'); railCarte('fond'); });
    }
    // La carte (sous la zone d'impression) et le rail.
    railCarteEl = document.createElement('div');
    railCarteEl.className = 'pp-rail__carte';
    railCarteEl.innerHTML = `<div class="pp-rail__tete"><strong data-rail-titre></strong><button type="button" class="pp-rail__fermer" aria-label="${ptxT("Fermer")}">×</button></div>`;
    railCarteEl.appendChild(panels);
    railCarteEl.querySelector('.pp-rail__fermer').addEventListener('click', () => railCarte(null));
    const items = ['image', 'texte', 'couleur', 'position', 'quantites', 'idees', 'apercu']; // « Taille » fusionné dans « Position » (Karim 23/10)
    if ($('[data-peo-ouvrir]')) items.push('equipe');
    railEl = document.createElement('div');
    railEl.className = 'pp-rail__barre'; railEl.setAttribute('role', 'toolbar'); railEl.setAttribute('aria-label', ptxT("Réglages"));
    railEl.innerHTML = items.map((k) => `<button type="button" data-rail="${k}" aria-label="${RAIL_NOMS[k]}"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${RAIL_ICO[k]}</svg><span>${RAIL_NOMS[k]}</span></button>`).join('');
    modal.classList.add('pp-bas3');
    $('[data-pp-panel="image"]')?.insertAdjacentHTML('afterbegin', '<p class="pp-rail__alerte" hidden></p>');
    stageWrap.append(railCarteEl);
    { const barre = tiroirEl.querySelector('.pp-tiroir__barre'); barre.insertBefore(railEl, barre.firstChild); }
    railEl.insertAdjacentHTML('beforeend', '<span class="pp-rail__trait" aria-hidden="true"></span>');
    // Poignée : on ferme la carte en la glissant vers le bas.
    railCarteEl.insertAdjacentHTML('afterbegin', '<span class="pp-rail__poignee" aria-hidden="true"></span>');
    {
      let g = null;
      const tete = () => railCarteEl.querySelector('.pp-rail__tete');
      const debut = (e) => { if (modal.classList.contains('pp-clavier') || !e.target.closest('.pp-rail__poignee, .pp-rail__tete') || e.target.closest('button')) return; g = { y: e.clientY, t: performance.now(), dy: 0 }; railCarteEl.classList.add('is-glisse'); try { railCarteEl.setPointerCapture(e.pointerId); } catch (err) { /* rien */ } };
      const bouge = (e) => { if (!g) return; g.dy = Math.max(0, e.clientY - g.y); railCarteEl.style.transform = `translate3d(0, ${g.dy}px, 0)`; };
      const fin = () => {
        if (!g) return; const v = g.dy / Math.max(1, performance.now() - g.t); const ferme = g.dy > 70 || v > 0.6; g = null;
        railCarteEl.classList.remove('is-glisse'); railCarteEl.style.transform = '';
        if (ferme) railCarte(null);
      };
      railCarteEl.addEventListener('pointerdown', debut, { passive: true });
      railCarteEl.addEventListener('pointermove', bouge, { passive: true });
      railCarteEl.addEventListener('pointerup', fin, { passive: true });
      railCarteEl.addEventListener('pointercancel', fin, { passive: true });
      void tete;
    }
    railEl.addEventListener('click', (e) => {
      const b = e.target.closest('[data-rail]'); if (!b) return;
      const k = b.dataset.rail;
      if (k === 'apercu') { railCarte(null); addBtn.click(); return; }
      if (k === 'equipe') {
        state.railEquipe = true; setTab('quantites'); railCarte('quantites');
        const o = $('[data-peo-ouvrir]'); if (o && o.getAttribute('aria-expanded') !== 'true') o.click();
        setTimeout(() => o?.scrollIntoView({ block: 'nearest' }), 60);
        return;
      }
      state.railEquipe = false;
      if (state.railOuvert === k) { railCarte(null); return; }
      // Texte : posé tout de suite sur le vêtement (sélectionné, clavier ouvert), comme le bouton « + Texte ».
      if (k === 'texte' && state.ready && !canvas().getObjects().some((o) => o.ppType === 'text')) { T.input.focus({ preventScroll: true }); quickText(); return; }
      if (k === 'position' && !cibleTaille()) { const o = canvas().getObjects()[0]; if (o) { canvas().setActiveObject(o); canvas().requestRenderAll(); onSelection(); } }
      setTab(k); railCarte(k);
    });
    // Toucher à côté du menu (vêtement, en-tête…) : il se referme.
    document.addEventListener('pointerdown', (e) => {
      if (!state.railOuvert || modal.hidden || !modal.classList.contains('pp-rail')) return;
      if (e.target.closest('.pp-rail__carte, .pp-rail__barre, .pp-apercu, .pp-tiroir__boite, .pp-relire')) return;
      railCarte(null);
    }, true);
    // Clavier (texte) : le vêtement reste visible en haut, le champ juste au-dessus du clavier.
    T.input.addEventListener('focus', () => { if (modal.classList.contains('pp-rail')) { modal.classList.add('pp-clavier'); railClavier(); } });
    T.input.addEventListener('blur', () => setTimeout(() => { if (document.activeElement !== T.input) { modal.classList.remove('pp-clavier'); stage.style.transform = ''; if (state.railOuvert) railPlacer(); } }, 120));
    window.visualViewport?.addEventListener('resize', () => { if (modal.classList.contains('pp-clavier')) railClavier(); });
    window.addEventListener('resize', () => { if (state.railOuvert && !modal.classList.contains('pp-clavier')) setTimeout(railPlacer, 260); });
    // Équipe chargée plus tard (module printtex-equipe-outil) : l'icône arrive dès qu'il est prêt.
    const ajouterEquipe = () => { if (railEl.querySelector('[data-rail="equipe"]') || !$('[data-peo-ouvrir]')) return !!railEl.querySelector('[data-rail="equipe"]'); (railEl.querySelector('[data-rail="apercu"]') || railEl.lastChild).insertAdjacentHTML('beforebegin', `<button type="button" data-rail="equipe" aria-label="${RAIL_NOMS.equipe}"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${RAIL_ICO.equipe}</svg><span>${RAIL_NOMS.equipe}</span></button>`); return true; };
    [300, 1200, 3000, 6000].forEach((t) => setTimeout(ajouterEquipe, t));
    // Barre du bas : prix + « Ajouter au panier » (l'aperçu de validation s'ouvre d'abord, comme avant).
    const libelle = tiroirEl.querySelector('[data-tiroir-cta] span'); if (libelle) libelle.textContent = ptxT("Aperçu avant panier");
    modal.dataset.cran = 'ferme';
    tiroirPrix();
    if (state.canvases[state.side]) drawMockup();
  }
  // Ouvre (k = nom du panneau) ou ferme (null) la carte de menu.
  function railCarte(k) {
    if (!railCarteEl) return;
    const nouveauMenu = state.railOuvert !== (k || null);
    state.railOuvert = k || null;
    if (!k && modal.classList.contains('pp-carte-ouverte') && modal.classList.contains('pp-bas3')) {
      // Fermeture : la carte descend et s'efface (160 ms) au lieu de disparaître d'un coup.
      modal.classList.add('pp-carte-sort'); clearTimeout(railCarteEl._sort); railCarteEl._sort = setTimeout(() => modal.classList.remove('pp-carte-sort'), 170);
    }
    if (k) { modal.classList.remove('pp-carte-sort'); clearTimeout(railCarteEl._sort); }
    modal.classList.toggle('pp-carte-ouverte', !!k);
    modal.classList.toggle('pp-sheet-open', !!k);
    modal.dataset.cran = k ? 'moitie' : 'ferme';
    if (k && state.tab !== k) setTab(k);
    const actif = k === 'quantites' && state.railEquipe ? 'equipe' : k === 'fond' ? 'image' : k;
    railEl.querySelectorAll('[data-rail]').forEach((b) => b.classList.toggle('is-active', b.dataset.rail === actif));
    const t = railCarteEl.querySelector('[data-rail-titre]');
    if (t && k) { const ico = RAIL_ICO[actif] ? `<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${RAIL_ICO[actif]}</svg>` : ''; t.innerHTML = `${ico}<span>${k === 'fond' ? ptxT("Fond de l'image") : RAIL_NOMS[actif] || ''}</span>`; }
    if (modal.classList.contains('pp-bas3')) {
      const trait = railEl.querySelector('.pp-rail__trait'); const b = actif && railEl.querySelector(`[data-rail="${actif}"]`);
      if (trait) { if (b) { trait.style.width = `${b.offsetWidth - 16}px`; trait.style.transform = `translate3d(${b.offsetLeft + 8}px, 0, 0)`; } trait.classList.toggle('is-visible', !!b); }
      if (b && (b.offsetLeft < railEl.scrollLeft || b.offsetLeft + b.offsetWidth > railEl.scrollLeft + railEl.clientWidth)) railEl.scrollTo({ left: b.offsetLeft - 8, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    if (k === 'position') railCarteEl.querySelectorAll('[data-rail-cote]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.railCote === state.side)));
    if (k) { railPlacer(); if (nouveauMenu) railCarteEl.scrollTop = 0; }
    if (!k) { modal.classList.remove('pp-clavier'); stage.style.transform = ''; Object.values(state.canvases).forEach((c) => c.calcOffset()); }
    setTimeout(() => Object.values(state.canvases).forEach((c) => c.calcOffset()), 30);
  }
  // Place la carte dans la plus grande place libre qui ne touche pas la zone d'impression (dessous en priorité).
  function railPlacer() {
    if (!railCarteEl || !state.railOuvert || modal.classList.contains('pp-clavier')) return;
    const w = stageWrap.getBoundingClientRect(); const r = railEl.getBoundingClientRect();
    const zEl = $(`[data-pp-zone="${state.side}"]`); if (!zEl) return;
    // place libérée sous la zone : vêtement réduit depuis le haut si la carte n'a pas 220 px dessous.
    const tAvant = stage.style.transition; stage.style.transition = 'none'; stage.style.transform = ''; let z = zEl.getBoundingClientRect(); stage.style.transition = tAvant;
    const paysageCarte = modal.classList.contains('pp-bas3') && w.width > w.height * 1.25 && w.right - 8 - (z.right + 8) >= 200;
    const st = stage.getBoundingClientRect(); const basVet = Math.max(z.bottom + 26, st.bottom); // le menu ne cache jamais le vêtement
    const besoin = paysageCarte ? 0 : modal.classList.contains('pp-bas3') ? 180 : 220; const manque = besoin - (w.bottom - 6 - basVet);
    let sc = 1;
    if (manque > 0) {
      const s = sc = Math.max(0.5, Math.min(1, (w.bottom - 6 - besoin - st.top) / Math.max(1, basVet - st.top)));
      stage.style.transformOrigin = '50% 0'; stage.style.transform = `scale(${s})`;
      const zr = z; const y = (v) => st.top + (v - st.top) * s; const x = (v) => st.left + st.width / 2 + (v - st.left - st.width / 2) * s;
      z = { top: y(zr.top), bottom: y(zr.bottom), left: x(zr.left), right: x(zr.right) };
    }
    const lab = zEl.querySelector('.pp-zone__label'); const lb = lab && lab.offsetParent ? lab.getBoundingClientRect().bottom : 0;
    const zb = Math.max(z.bottom, st.top + st.height * sc, lb > z.bottom && lb - z.bottom < 40 ? lb : 0) + 8;
    const g = modal.classList.contains('pp-bas3') ? w.left + 8 : r.right + 6;
    const zones = [
      { nom: 'dessous', left: g, top: zb, right: w.right - 6, bottom: w.bottom - 6 },
      { nom: 'droite', left: z.right + 8, top: w.top + 6, right: w.right - 6, bottom: w.bottom - 6 },
      { nom: 'dessus', left: g, top: w.top + 6, right: w.right - 6, bottom: z.top - 8 },
    ].map((x) => ({ ...x, l: x.right - x.left, h: x.bottom - x.top }));
    let choix = paysageCarte ? zones[1] : zones[0];
    if (!paysageCarte && !(zones[0].h >= 150 && zones[0].l >= 200)) choix = zones.filter((x) => x.l >= 200 && x.h >= 110).sort((a, b) => b.l * Math.min(b.h, 360) - a.l * Math.min(a.h, 360))[0] || zones[0];
    Object.assign(railCarteEl.style, { left: `${choix.left - w.left}px`, top: `${choix.top - w.top}px`, width: `${Math.max(160, choix.l)}px`, maxHeight: `${Math.max(90, choix.h)}px`, bottom: '' });
    railCarteEl.dataset.place = choix.nom;
  }
  // Clavier ouvert : la carte se pose juste au-dessus du clavier ; le vêtement remonte et se réduit pour rester entier.
  function railClavier() {
    if (!railCarteEl) return;
    const vv = window.visualViewport; const clavier = vv ? Math.max(0, window.innerHeight - vv.height - vv.offsetTop) : 0;
    Object.assign(railCarteEl.style, { left: '', top: '', width: '', bottom: `${clavier}px`, maxHeight: '' });
    requestAnimationFrame(() => {
      let c = railCarteEl.getBoundingClientRect(); const w = stageWrap.getBoundingClientRect();
      const basVisible = vv ? vv.height + vv.offsetTop : window.innerHeight; const dep = c.bottom - basVisible;
      if (dep > 0.5) { railCarteEl.style.bottom = `${clavier + dep}px`; c = railCarteEl.getBoundingClientRect(); }
      const dispo = c.top - w.top - 8; const h = stage.offsetHeight || 1;
      const s = Math.min(1, dispo / h);
      stage.style.transform = `translateY(${-stage.offsetTop + 4}px) scale(${s})`;
    });
  }

  /* ---------- Glissement du tiroir (lot 27, Karim 19/10 : « pas assez fluide, l'image disparaît ») ----------
     Téléphone en portrait : le tiroir (hauteur fixe) glisse en translate3d, la barre d'aperçu + onglets reste en bas,
     la scène se réduit / remonte en CSS au-dessus. Aucun redessin ni recalcul de mise en page pendant le geste. */
  function glisseMode() { return modal.classList.contains('pp-tiroir') && !modal.classList.contains('pp-rail') && !window.matchMedia('(orientation: landscape) and (max-height: 500px)').matches; }
  var tiroirG = { v: 0, geo: null, mb: null, t: 0 };
  function glisseGeo() {
    const h = window.innerHeight;
    const haut = $('.pp-top')?.getBoundingClientRect().bottom || 56;
    const barre = tiroirEl.querySelector('.pp-tiroir__barre');
    const fermeV = (tiroirEl.querySelector('.pp-tiroir__poignee')?.offsetHeight || 22) + (tiroirEl.querySelector('.pp-tiroir__resume')?.offsetHeight || 0) + (barre?.offsetHeight || 0);
    let moitie = Math.max(fermeV + 60, Math.round(h * 0.5));
    // La scène garde 35 % de l'écran (au moins 30 % sur les petits écrans, où le tiroir fermé est déjà haut).
    const plein = Math.max(fermeV + 40, Math.min(Math.max(moitie + 60, Math.round(h - haut - h * 0.35)), Math.round(h - haut - h * 0.3)));
    if (moitie > plein - 30) moitie = Math.round((fermeV + plein) / 2);
    const sw = stageWrap.getBoundingClientRect();
    const res = tiroirEl.querySelector('.pp-tiroir__resume'); if (res) res.style.top = `${tiroirEl.querySelector('.pp-tiroir__poignee')?.offsetHeight || 22}px`;
    return { h, haut, fermeV, moitie, plein, barre, resume: tiroirEl.querySelector('.pp-tiroir__resume'), ctrl: stageWrap.querySelector('.pp-ctrl'), base: { top: sw.top + stage.offsetTop, height: stage.offsetHeight || 1 } };
  }
  // Position du tiroir : v = hauteur visible depuis le bas de l'écran. anime : transition de 220 ms (relâché, cran).
  function glissePos(v, anime) {
    const g = tiroirG.geo; if (!g) return;
    v = Math.max(g.fermeV - 40, Math.min(g.plein + 24, v));
    tiroirG.v = v;
    const ty = g.plein - v;
    [tiroirEl, g.barre, stage, g.ctrl].forEach((el) => el?.classList.toggle('is-glisse', !anime));
    tiroirEl.style.transform = `translate3d(0, ${ty}px, 0)`;
    if (g.barre) g.barre.style.transform = `translate3d(0, ${-ty}px, 0)`;
    // Scène : interpolée entre « fermé » (taille réelle) et « haut » (centrée dans la place restante).
    const p = Math.max(0, Math.min(1, (v - g.fermeV) / Math.max(1, g.plein - g.fermeV)));
    const bas1 = g.h - g.plein;
    const s1 = Math.min(1, (bas1 - g.haut - 8) / g.base.height);
    const dy1 = (g.haut + bas1) / 2 - (g.base.top + g.base.height / 2);
    stage.style.transform = p ? `translate3d(0, ${dy1 * p}px, 0) scale(${1 + (s1 - 1) * p})` : '';
    if (g.ctrl) {
      const o = Math.max(0, Math.min(1, (1 - p) / 0.15));
      g.ctrl.style.transform = v > g.fermeV ? `translate3d(0, ${-(v - g.fermeV)}px, 0)` : '';
      g.ctrl.style.opacity = String(o); g.ctrl.style.pointerEvents = o < 0.5 ? 'none' : '';
    }
    stageWrap.classList.toggle('pp-scene-reduite', p > 0.3);
    if (g.resume) { const o = Math.max(0, 1 - p * 4); g.resume.style.opacity = String(o); g.resume.style.pointerEvents = o < 0.5 ? 'none' : ''; } // résumé effacé en tirant
  }
  function glisseCran(cran, depuisGeste) {
    if (!depuisGeste && tiroirG.geo && modal.dataset.cran === cran && modal.classList.contains('pp-glisse')) return; // cran déjà en place
    const marquer = () => { modal.classList.remove('pp-tire'); modal.dataset.cran = cran; modal.classList.toggle('pp-sheet-open', cran !== 'ferme'); tiroirTitre(); };
    clearTimeout(tiroirG.m);
    if (depuisGeste) tiroirG.m = setTimeout(marquer, 240); else marquer(); // après l'animation : rien ne recalcule pendant
    if (!depuisGeste || !tiroirG.geo) tiroirG.geo = glisseGeo();
    const g = tiroirG.geo;
    tiroirEl.style.height = `${g.plein}px`;
    const v = cran === 'ferme' ? g.fermeV : g[cran];
    glissePos(v, true);
    const cache = () => tiroirEl.style.setProperty('--pp-cache', `${g.plein - v}px`); // bas des panneaux atteignable au défilement
    if (depuisGeste) setTimeout(cache, 240); else cache();
    // Place réservée au tiroir fermé : si elle change (résumé plus haut), un seul redessin, sans image vide.
    if (tiroirG.mb !== g.fermeV) { tiroirG.mb = g.fermeV; stageWrap.style.marginBottom = `${g.fermeV}px`; drawMockup(); }
    clearTimeout(tiroirG.t);
    tiroirG.t = setTimeout(() => Object.values(state.canvases).forEach((c) => c.calcOffset()), 260);
  }
  // Résumé plus haut ou plus bas (sélection, actions) : le tiroir fermé suit, sans redessin de la scène.
  function glisseSuivreResume() {
    if (!tiroirG.geo || !glisseMode()) return;
    const cran = modal.dataset.cran || 'ferme';
    tiroirG.geo = glisseGeo();
    const g = tiroirG.geo; tiroirEl.style.height = `${g.plein}px`;
    glissePos(cran === 'ferme' ? g.fermeV : g[cran], true);
  }
  function glisseApresDessin() {
    if (state.railOuvert && modal.classList.contains('pp-rail')) requestAnimationFrame(railPlacer); // carte replacée après redessin
    if (!tiroirG || !tiroirG.geo || !glisseMode()) return;
    tiroirG.geo = glisseGeo();
    glissePos(tiroirG.v || tiroirG.geo.fermeV, false);
  }
  function glisseQuitter() {
    modal.classList.remove('pp-glisse');
    [tiroirEl, stage].forEach((el) => { el.style.transform = ''; });
    const b = tiroirEl.querySelector('.pp-tiroir__barre'); if (b) b.style.transform = '';
    stageWrap.style.marginBottom = ''; tiroirG.mb = null; tiroirG.geo = null;
    const res = tiroirEl.querySelector('.pp-tiroir__resume'); if (res) { res.style.opacity = ''; res.style.pointerEvents = ''; }
    const ctrl = stageWrap.querySelector('.pp-ctrl'); if (ctrl) { ctrl.style.opacity = ''; ctrl.style.pointerEvents = ''; ctrl.style.transform = ''; }
    stageWrap.classList.remove('pp-scene-reduite');
  }

  /* ---------- Téléphone : tiroir à crans (maquette A, lot 22) ---------- */
  const TIROIR = window.matchMedia('(max-width: 768px), (orientation: landscape) and (max-height: 500px) and (max-width: 899px)');
  const tiroirEl = document.createElement('div');
  function tiroirHauteurs() {
    const h = window.innerHeight;
    // Plein : le vêtement reste visible au-dessus du tiroir (en-tête + au moins ~190 px de produit).
    const moitie = Math.round(h * 0.55);
    return { moitie, plein: Math.max(moitie + 60, Math.min(Math.round(h * 0.85), h - 250)) };
  }
  let tiroirRedessin = 0;
  function tiroirRedessiner() { clearTimeout(tiroirRedessin); tiroirRedessin = setTimeout(() => drawMockup(), 230); }
  // Cran du tiroir : 'ferme' (résumé), 'moitie', 'plein'. Garde la classe historique pp-sheet-open en accord.
  function tiroirCran(cran) {
    if (!modal.classList.contains('pp-tiroir')) return;
    if (modal.classList.contains('pp-rail')) { railCarte(cran === 'ferme' ? null : state.tab); return; }
    if (glisseMode()) { modal.classList.add('pp-glisse'); glisseCran(cran); return; }
    if (modal.classList.contains('pp-glisse')) glisseQuitter();
    const avant = modal.dataset.cran;
    modal.dataset.cran = cran;
    const H = tiroirHauteurs();
    tiroirEl.style.height = cran === 'ferme' ? '' : `${H[cran]}px`;
    modal.classList.toggle('pp-sheet-open', cran !== 'ferme');
    tiroirTitre();
    if (avant !== cran) tiroirRedessiner();
  }
  function tiroirTitre() {
    const t = tiroirEl.querySelector('[data-tiroir-titre]');
    const b = $(`.pp-tabs [data-pp-tab="${state.tab}"] span`);
    if (t) t.textContent = b ? b.textContent : '';
  }
  // Ligne d'en-tête et bouton d'aperçu : couleur, tailles, pièces et prix (repris de l'outil).
  function tiroirPrix() {
    if (!modal.classList.contains('pp-tiroir')) return;
    const q = totalQty();
    const tailles = Object.entries(state.qty).filter(([, n]) => n > 0).map(([t, n]) => (t ? `${t} ×${n}` : `×${n}`)).join(', ');
    const total = priceEl.dataset.total || '';
    const pieces = `${q || 1} ${ptxT("pièce")}${q > 1 ? 's' : ''}`;
    const ligne = $('[data-tiroir-ligne]');
    if (ligne) ligne.textContent = [couleurIdx >= 0 ? couleurOf(state.variant) : '', tailles, total ? `${pieces} ${total}` : ''].filter(Boolean).join(', ');
    const cta = tiroirEl.querySelector('[data-tiroir-cta-prix]');
    if (cta && modal.classList.contains('pp-rail') && !state.surDevis && total) { cta.innerHTML = `<span class="pp-cta-pieces">${pieces}</span><span class="ptx-tag pp-cta-tag">${total}</span>`; }
    else if (cta) cta.textContent = state.surDevis ? (modal.classList.contains('pp-rail') ? `${q.toLocaleString('fr-FR')} ${ptxT("pièces")}` : ptxT("sur devis")) : total ? `${pieces}, ${total}` : '';
    const libCta = tiroirEl.querySelector('[data-tiroir-cta] span:first-child');
    if (libCta && modal.classList.contains('pp-rail')) libCta.textContent = state.surDevis ? ptxT("Recevoir mon devis") : ptxT("Aperçu avant panier");
    tiroirEl.querySelector('[data-tiroir-cta]')?.classList.toggle('is-attente', addBtn.classList.contains('is-attente') || !!addBtn.disabled);
    tiroirEl.querySelector('[data-tiroir-cta]')?.classList.toggle('is-vide', !usedSides().length);
  }
  // Résumé (cran fermé) : l'élément sélectionné et 3 actions rapides.
  // Raccourcis toujours visibles sous le résumé : tailles, commande d'équipe, idées.
  function raccourcis() {
    const ideesOk = !!$('.pp-tabs [data-pp-tab="idees"]');
    const r = (act, txt) => `<button type="button" class="pp-tiroir__racc" data-tiroir-act="${act}">${txt}</button>`;
    return `<div class="pp-tiroir__raccs">${r('tailles', 'Tailles')}${r('equipe', ptxT("Commande d'équipe"))}${ideesOk ? r('idees', ptxT("Idées")) : ''}</div>`;
  }
  function tiroirResume(obj = active()) {
    const r = tiroirEl.querySelector('[data-tiroir-resume]');
    if (!r) return;
    const cmLarg = (o) => String(Math.round((o.getScaledWidth() * zoneOf(state.side).cmW / LOGICAL_W) * 10) / 10).replace('.', ',');
    const bouton = (act, label, contenu) => `<button type="button" class="pp-tiroir__act" data-tiroir-act="${act}" aria-label="${label}">${contenu}</button>`;
    const poubelle = '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"></path></svg>';
    let titre; let detail; let actions;
    if (obj && obj.ppType === 'text') {
      const p = obj.ppProps || {};
      titre = ptxT("Texte sélectionné");
      detail = `${p.font || ptxT("Police")}, ${cmLarg(obj)} ${ptxT("cm de large, tirez vers le haut pour régler")}`;
      actions = bouton('police', ptxT("Police"), `<b>${ptxT("Aa")}</b>`) + bouton('couleur', ptxT("Couleur du texte"), `<span class="pp-tiroir__pastille" style="background:${p.fill || '#000'}"></span>`) + bouton('supprimer', ptxT("Supprimer"), poubelle);
    } else if (obj && (obj.ppType === 'image' || obj.ppType === 'modele' || obj.ppType === 'equipe')) {
      const dpi = obj.ppType === 'image' ? obj.width / ((obj.getScaledWidth() * zoneOf(state.side).cmW / LOGICAL_W) / 2.54) : 0;
      titre = obj.ppType === 'image' ? ptxT("Image sélectionnée") : obj.ppType === 'equipe' ? ptxT("Noms et numéros") : ptxT("Modèle sélectionné");
      detail = `${cmLarg(obj)} ${ptxT("cm de large")}${dpi ? ` ${ptxT(", Qualité :")} ${dpi >= 200 ? 'excellente' : dpi >= 150 ? 'bonne' : dpi >= 100 ? 'moyenne' : ptxT("trop faible")}` : ''}`;
      actions = obj.ppType === 'image'
        ? bouton('changer', ptxT("Changer d'image"), ptxT('Changer')) + bouton('supprimer', ptxT("Retirer l'image"), `× ${ptxT('Retirer')}`)
        : bouton('supprimer', ptxT('Supprimer'), `× ${ptxT('Supprimer')}`);
    } else if (!usedSides().length) {
      const ico = (d) => `<svg aria-hidden="true" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${d}</svg>`;
      r.innerHTML = `<div class="pp-tiroir__depart"><p class="pp-tiroir__depart-titre">${ptxT("Pour commencer, touchez :")}</p><div class="pp-tiroir__cartes">
        <button type="button" class="pp-tiroir__carte is-principale" data-tiroir-act="image">${ico('<rect x="3" y="4" width="18" height="16" rx="2"></rect><circle cx="9" cy="10" r="2"></circle><path d="M21 16l-5-5-8 8"></path>')}<strong>${ptxT("Ajouter une image")}</strong><span>${ptxT("logo, photo, dessin")}</span></button>
        <button type="button" class="pp-tiroir__carte" data-tiroir-act="texte">${ico('<path d="M4 6h16M12 6v14M8 20h8"></path>')}<strong>${ptxT("Écrire un texte")}</strong><span>${ptxT("nom, slogan, numéro")}</span></button>
      </div></div>${raccourcis()}`;
      return;
    } else {
      titre = ptxT("Votre création");
      detail = ptxT("Touchez un élément pour le modifier");
      actions = bouton('image', ptxT("Ajouter une image"), ptxT("+ Image")) + bouton('texte', ptxT("Ajouter un texte"), ptxT("+ Texte"));
    }
    r.innerHTML = `<div class="pp-tiroir__resume-ligne"><div class="pp-tiroir__resume-txt"><strong>${titre}</strong><span>${detail}</span></div><div class="pp-tiroir__acts">${actions}</div></div>${raccourcis()}`;
  }
  // Pastilles sur le vêtement : zone d'impression et qualité de l'image sélectionnée.
  function tiroirPastilles(obj = active()) {
    const p = stageWrap.querySelector('[data-tiroir-pastilles]');
    if (!p) return;
    const z = zoneOf(state.side);
    let html = `<span>${ptxT("Zone")} ${String(z.cmW).replace('.', ',')} × ${String(z.cmH).replace('.', ',')} cm</span>`;
    if (obj && obj.ppType === 'image') {
      const dpi = obj.width / ((obj.getScaledWidth() * z.cmW / LOGICAL_W) / 2.54);
      html += `<span class="is-${dpi >= 150 ? 'ok' : dpi >= 100 ? 'moyen' : 'faible'}">${ptxT("Qualité :")} ${dpi >= 200 ? 'excellente' : dpi >= 150 ? 'bonne' : dpi >= 100 ? 'moyenne' : ptxT("trop faible")}</span>`;
    }
    p.innerHTML = html;
  }
  // Met en avant les deux cartes de départ (vide) : petite pulsation.
  function tiroirAppel() {
    const c = tiroirEl.querySelector('.pp-tiroir__cartes'); if (!c) return;
    c.classList.remove('is-appel'); void c.offsetWidth; c.classList.add('is-appel');
  }
  function tiroirInstaller() {
    if (!TIROIR.matches || !modal.classList.contains('pp-var-e') || modal.classList.contains('pp-tiroir')) return;
    modal.classList.add('pp-tiroir');
    modal.dataset.cran = 'ferme';
    // En-tête : titre + ligne couleur / tailles / prix.
    const top = $('.pp-top');
    const titre = document.createElement('div');
    titre.className = 'pp-tiroir__entete';
    titre.innerHTML = `<strong>${String(data.title || '').replace(/[&<>]/g, '')}</strong><span data-tiroir-ligne></span>`;
    top.querySelector('[data-pp-close]')?.after(titre);
    // Pastilles et zoom sur le vêtement.
    stageWrap.insertAdjacentHTML('beforeend', '<div class="pp-tiroir__pastilles" data-tiroir-pastilles></div>');
    const zoom = $('[data-pp-zoom]');
    const outils = document.createElement('div'); outils.className = 'pp-tiroir__outils';
    const droite = $('.pp-top__right'); if (droite) [...droite.children].forEach((b) => outils.appendChild(b));
    if (zoom) { zoom.classList.add('pp-tiroir__zoom'); outils.appendChild(zoom); }
    stageWrap.appendChild(outils);
    // Onglet « Fond » + son panneau (le panneau « Fond de l'image » y est déplacé).
    const tabs = $('.pp-tabs');
    const fondTab = document.createElement('button');
    fondTab.type = 'button'; fondTab.dataset.ppTab = 'fond'; fondTab.setAttribute('role', 'tab');
    fondTab.innerHTML = `<svg aria-hidden="true" class="pp-svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"></rect><path d="M3 15l5-5 5 5 4-4 4 4"></path></svg><span>${ptxT("Fond")}</span>`;
    tabs.appendChild(fondTab);
    const fondPanel = document.createElement('section');
    fondPanel.className = 'pp-panel'; fondPanel.dataset.ppPanel = 'fond'; fondPanel.hidden = true;
    fondPanel.innerHTML = `<p class="pp-note pp-tiroir__fond-vide">${ptxT("Touchez une image sur le vêtement pour régler son fond (retiré, gardé, détouré).")}</p>`;
    const fondBox = $('[data-pp-fond]'); if (fondBox) fondPanel.appendChild(fondBox);
    $('.pp-panels').appendChild(fondPanel);
    // Ordre des onglets : Image, Texte, Couleur, Tailles, Fond (Idées passe dans le panneau Image).
    ['image', 'texte', 'couleur', 'quantites', 'fond', 'idees'].forEach((n) => { const b = tabs.querySelector(`[data-pp-tab="${n}"]`); if (b) tabs.appendChild(b); });
    const idees = document.createElement('button');
    idees.type = 'button'; idees.className = 'pp-btn pp-tiroir__idees'; idees.textContent = ptxT("Pas d'image ? Voir les idées");
    idees.addEventListener('click', () => $('.pp-tabs [data-pp-tab="idees"]')?.click());
    $('[data-pp-panel="image"]')?.prepend(idees);
    { const l = $('[data-pp-img-actions]'); if (l) $('[data-pp-panel="image"]')?.prepend(l); }
    // Le tiroir : poignée, titre, résumé, panneaux, erreur, bouton d'aperçu, onglets.
    tiroirEl.className = 'pp-tiroir__boite';
    tiroirEl.innerHTML = `<button type="button" class="pp-tiroir__poignee" data-tiroir-poignee aria-label="${ptxT("Agrandir ou réduire le panneau")}"><span></span></button>
      <div class="pp-tiroir__tete"><strong data-tiroir-titre></strong><button type="button" class="pp-tiroir__fini" data-tiroir-fini>${ptxT("Terminer")}</button></div>
      <div class="pp-tiroir__resume" data-tiroir-resume></div>`;
    const main = $('.pp-main');
    main.appendChild(tiroirEl);
    tiroirEl.appendChild($('.pp-panels'));
    tiroirEl.appendChild(errorEl);
    tiroirEl.insertAdjacentHTML('beforeend', `<div class="pp-tiroir__cta-ligne"><button type="button" class="pp-tiroir__cta" data-tiroir-cta><span>${ptxT("Aperçu avant panier")}</span><span data-tiroir-cta-prix></span></button></div>`);
    tiroirEl.appendChild(tabs);
    { const barre = document.createElement('div'); barre.className = 'pp-tiroir__barre'; barre.append(errorEl, tiroirEl.querySelector('.pp-tiroir__cta-ligne'), tabs); tiroirEl.appendChild(barre); }
    tiroirEl.querySelector('[data-tiroir-cta]').addEventListener('click', () => {
      if (state.surDevis) { // sur devis : le bouton du bas mène au devis, avec la création
        const a = priceEl.querySelector('a[href]');
        if (a) {
          const bouton = tiroirEl.querySelector('[data-tiroir-cta]'); bouton?.setAttribute('aria-busy', 'true');
          (async () => {
            try {
              clearTimeout(saveTimer);
              const design = { t: Date.now(), variant: state.variant?.id, qty: state.qty, pos: state.pos, miroir: state.miroir };
              Object.keys(SIDES).forEach((s) => { design[s] = lastJson(s); });
              await idb('readwrite', (st) => st.put(design, SAVE_KEY));
            } catch (e) { /* l'enregistrement local n'empêche pas la demande */ }
            const lien = usedSides().length ? await Promise.race([partagerDesign(), new Promise((r) => setTimeout(() => r(null), 4000))]) : null;
            window.location.href = lien ? `${a.href}&lien=${encodeURIComponent(lien)}` : a.href;
          })();
          return;
        }
      }
      if (!usedSides().length) { if (modal.classList.contains('pp-rail')) { setTab('image'); railCarte('image'); return; } tiroirCran('ferme'); tiroirAppel(); return; }
      addBtn.click();
    });
    tiroirEl.querySelector('[data-tiroir-fini]').addEventListener('click', () => tiroirCran('ferme'));
    tiroirEl.querySelector('[data-tiroir-resume]').addEventListener('click', (e) => {
      const b = e.target.closest('[data-tiroir-act]'); if (!b) return;
      const a = b.dataset.tiroirAct;
      if (a === 'supprimer') action('delete');
      else if (a === 'image') fileInput.click();
      else if (a === 'texte') quickText();
      else if (a === 'police' || a === 'couleur') { setTab('texte'); tiroirCran('moitie'); if (a === 'couleur') setTimeout(() => $('[data-pp-colors]')?.scrollIntoView({ block: 'center' }), 250); }
      else if (a === 'fond') { setTab('fond'); tiroirCran('moitie'); }
      else if (a === 'changer') { state.remplacer = active(); fileInput.click(); }
      else if (a === 'tailles') { setTab('quantites'); tiroirCran('moitie'); }
      else if (a === 'idees') { setTab('idees'); tiroirCran('plein'); }
      else if (a === 'equipe') {
        setTab('quantites'); tiroirCran('plein');
        const o = $('[data-peo-ouvrir]');
        if (o && o.getAttribute('aria-expanded') !== 'true') o.click();
        setTimeout(() => o?.scrollIntoView({ block: 'start' }), 260);
      }
    });
    // Poignée : toucher = ouvrir / refermer ; glisser = suivre le doigt puis se caler sur le cran le plus proche.
    const poignee = tiroirEl.querySelector('[data-tiroir-poignee]');
    let depart = null;
    poignee.addEventListener('pointerdown', (e) => { if (glisseMode()) return; depart = { y: e.clientY, h: tiroirEl.offsetHeight, bouge: false }; poignee.setPointerCapture(e.pointerId); tiroirEl.classList.add('is-glisse'); });
    poignee.addEventListener('pointermove', (e) => {
      if (!depart) return;
      const dy = depart.y - e.clientY; if (Math.abs(dy) > 6) depart.bouge = true;
      if (depart.bouge) tiroirEl.style.height = `${Math.max(120, Math.min(window.innerHeight * 0.9, depart.h + dy))}px`;
    });
    const lacher = () => {
      if (!depart) return;
      tiroirEl.classList.remove('is-glisse');
      if (!depart.bouge) { tiroirCran({ ferme: 'moitie', moitie: 'plein', plein: 'ferme' }[modal.dataset.cran] || 'moitie'); depart = null; return; }
      const h = tiroirEl.offsetHeight; const H = tiroirHauteurs();
      tiroirEl.style.height = '';
      const fermeH = tiroirEl.offsetHeight;
      const crans = [['ferme', fermeH], ['moitie', H.moitie], ['plein', H.plein]];
      crans.sort((a, b) => Math.abs(a[1] - h) - Math.abs(b[1] - h));
      depart = null;
      tiroirCran(crans[0][0]);
      tiroirRedessiner();
    };
    poignee.addEventListener('pointerup', lacher);
    poignee.addEventListener('pointercancel', lacher);
    // Mode glissé : le tiroir suit le doigt à chaque image, puis se cale (avec l'élan) sur le cran le plus proche.
    let gd = null; let gRaf = 0; let gCible = 0;
    poignee.addEventListener('pointerdown', (e) => {
      if (!glisseMode()) return;
      if (!tiroirG.geo) tiroirG.geo = glisseGeo();
      tiroirG.glisse = false;
      gd = { y: e.clientY, v: tiroirG.v || tiroirG.geo.fermeV, bouge: false, pts: [[performance.now(), e.clientY]] };
      try { poignee.setPointerCapture(e.pointerId); } catch (err) { /* rien */ }
    }, { passive: true });
    poignee.addEventListener('pointermove', (e) => {
      if (!gd) return;
      const dy = gd.y - e.clientY; if (Math.abs(dy) > 6) gd.bouge = true;
      gd.pts.push([performance.now(), e.clientY]); if (gd.pts.length > 6) gd.pts.shift();
      if (!gd.bouge) return;
      modal.classList.add('pp-tire');
      gCible = gd.v + dy;
      if (!gRaf) gRaf = requestAnimationFrame(() => { gRaf = 0; glissePos(gCible, false); });
    }, { passive: true });
    const lacherGlisse = () => {
      if (!gd) return;
      const d = gd; gd = null;
      if (gRaf) { cancelAnimationFrame(gRaf); gRaf = 0; glissePos(gCible, false); }
      if (!d.bouge) return; // toucher simple : géré au click ci-dessous
      tiroirG.glisse = true;
      const [t0, y0] = d.pts[0]; const [t1, y1] = d.pts[d.pts.length - 1];
      const elan = t1 > t0 ? ((y0 - y1) / (t1 - t0)) * 180 : 0; // px parcourus en 180 ms à la vitesse du doigt
      const g = tiroirG.geo; const vise = tiroirG.v + elan;
      const crans = [['ferme', g.fermeV], ['moitie', g.moitie], ['plein', g.plein]].sort((a, b) => Math.abs(a[1] - vise) - Math.abs(b[1] - vise));
      glisseCran(crans[0][0], true);
    };
    poignee.addEventListener('click', () => {
      if (!glisseMode()) return;
      if (tiroirG.glisse) { tiroirG.glisse = false; return; } // fin d'un glisser, pas un toucher
      glisseCran({ ferme: 'moitie', moitie: 'plein', plein: 'ferme' }[modal.dataset.cran] || 'moitie');
    });
    poignee.addEventListener('pointerup', lacherGlisse, { passive: true });
    poignee.addEventListener('pointercancel', lacherGlisse, { passive: true });
    // Toucher le vêtement : le tiroir se range (cran fermé) pour voir la création en grand.
    stageWrap.addEventListener('pointerdown', (e) => { if (e.target.closest?.('.pp-rail__carte, .pp-rail__barre')) return; if (modal.dataset.cran === 'plein') tiroirCran('moitie'); }); // Karim 23/10 : toucher le vêtement ne range plus le tiroir (plein écran → moitié seulement)
    // Mises à jour : sélection, prix, côté.
    ext.selection.push((o) => { tiroirResume(o); tiroirPastilles(o); });
    new MutationObserver(tiroirPrix).observe(priceEl, { attributes: true, childList: true, subtree: true });
    new MutationObserver(tiroirPrix).observe(addBtn, { attributes: true, attributeFilter: ['class', 'disabled'] });
    tiroirEl.addEventListener('transitionend', (e) => { if (e.target === tiroirEl && !glisseMode()) drawMockup(); });
    window.addEventListener('resize', () => { if (glisseMode()) { tiroirG.geo = null; tiroirCran(modal.dataset.cran || 'ferme'); } else if (modal.dataset.cran !== 'ferme') tiroirCran(modal.dataset.cran); });
    if (window.ResizeObserver) { let attente = 0; new ResizeObserver(() => { cancelAnimationFrame(attente); attente = requestAnimationFrame(glisseSuivreResume); }).observe(tiroirEl.querySelector('.pp-tiroir__resume')); }
    tiroirResume(); tiroirPastilles(); tiroirPrix(); tiroirTitre();
    railInstaller();
  }
  tiroirInstaller();

  window.PrinttexPerso = {
    originaux, // tests (#1689) : original de chaque image conservé (a.fichier)
    tiroir: (c) => (c ? tiroirCran(c) : modal.dataset.cran),
    data, state, ext, $, $$, COLORS, LOGICAL_W, logicalH, zoneOf,
    canvas, active, makeText, ensureFont, fitInZone, snapshot, onSelection, updatePrice, setTab, setSide,
    // Mode « Équipe » (printtex-equipe-outil.js) : export, prix et panier.
    printFile, previewFile, deposerPng, consigneAtelier, POSITIONS, packPrice, packCommande, postCart, couleurOf, variantFor, usedSides, totalQty, teinte, slug, money, clearSaved, SIDES, tailleIdx, couleurIdx, hauteurMax,
  };
  document.dispatchEvent(new CustomEvent('pp:pret'));
})();
